
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("jtfsl", function(module, exports) {
/**
 * @generated SignedSource<<7dc99622ff8ab2775d75b231f507aa88>>
 * @relayHash 0dd246a45e06b932ab1b8570b0e2a26f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9541c3f7c90ad9f1ab645d0b30662e1e580d7fd7e0951e7703e0bf175d12bd63
const $8272d98e33ae5f0d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "accountId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Group",
                            "kind": "LinkedField",
                            "name": "groupsWithId",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AudienceSegmentationContextProviderQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AudienceSegmentationContextProviderQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "0dd246a45e06b932ab1b8570b0e2a26f",
            "id": "9541c3f7c90ad9f1ab645d0b30662e1e580d7fd7e0951e7703e0bf175d12bd63",
            "metadata": {},
            "name": "AudienceSegmentationContextProviderQuery",
            "operationKind": "query",
            "text": "query AudienceSegmentationContextProviderQuery($accountId:ID){user:confluence_atlassianUser(id:$accountId){id,confluence{groupsWithId{id}}}}"
        }
    };
}();
$8272d98e33ae5f0d$var$node.hash = "d01bf7959fed02b6636fa27826de406a";
var $8272d98e33ae5f0d$export$2e2bcd8739ae039 = $8272d98e33ae5f0d$var$node;
module.exports["default"] = $8272d98e33ae5f0d$export$2e2bcd8739ae039;

});

parcelRegister("hEeUR", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");


var $1a6Dn = parcelRequire("1a6Dn");


var $8WfxO = parcelRequire("8WfxO");


var $3u0dr = parcelRequire("3u0dr");








var $3jwuS = parcelRequire("3jwuS");


var $6mKj3 = parcelRequire("6mKj3");

const $134d01bd64a6ba9b$export$e43ca933d3c87145 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(7);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = $134d01bd64a6ba9b$var$getForgeAppsHeight();
        $[0] = t0;
    } else t0 = $[0];
    const [forgeAppsHeight, setForgeAppsHeight] = (0, $42omo.useState)(t0);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isForgePageBannerFixed = !isLivePage;
    let t1;
    let t2;
    if ($[1] !== isForgePageBannerFixed) {
        t1 = ()=>{
            const listener = (e)=>{
                if ((0, $6mKj3.expVal)("confluence_pgxp_p2m_batch_1", "isEnabled", false)) setForgeAppsHeight(e?.detail?.height ?? 0);
                else setForgeAppsHeight($134d01bd64a6ba9b$var$getForgeAppsHeight());
            };
            if (isForgePageBannerFixed) document.addEventListener("forgePageBannerHeightUpdated", listener);
            return ()=>{
                if (isForgePageBannerFixed) document.removeEventListener("forgePageBannerHeightUpdated", listener);
            };
        };
        t2 = [
            isForgePageBannerFixed
        ];
        $[1] = isForgePageBannerFixed;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[4] !== forgeAppsHeight || $[5] !== isForgePageBannerFixed) {
        t3 = {
            isForgePageBannerFixed: isForgePageBannerFixed,
            forgePageBannerHeight: forgeAppsHeight
        };
        $[4] = forgeAppsHeight;
        $[5] = isForgePageBannerFixed;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ()=>{
    const [forgeAppsHeight, setForgeAppsHeight] = (0, $42omo.useState)($134d01bd64a6ba9b$var$getForgeAppsHeight());
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isForgePageBannerFixed = !isLivePage;
    (0, $42omo.useEffect)(()=>{
        const listener = (e)=>{
            if ((0, $6mKj3.expVal)('confluence_pgxp_p2m_batch_1', 'isEnabled', false)) setForgeAppsHeight(e?.detail?.height ?? 0);
            else setForgeAppsHeight($134d01bd64a6ba9b$var$getForgeAppsHeight());
        };
        if (isForgePageBannerFixed) document.addEventListener('forgePageBannerHeightUpdated', listener);
        return ()=>{
            if (isForgePageBannerFixed) document.removeEventListener('forgePageBannerHeightUpdated', listener);
        };
    }, [
        isForgePageBannerFixed
    ]);
    return {
        isForgePageBannerFixed: isForgePageBannerFixed,
        forgePageBannerHeight: forgeAppsHeight
    };
};
const $134d01bd64a6ba9b$var$getForgeAppsHeight = ()=>{
    if (typeof document === 'undefined') return 0;
    return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--forge-page-banner-height')) || 0;
};



var $fyKZ5 = parcelRequire("fyKZ5");

const $2a9f51add9ac11ab$export$7cfa481653c48265 = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const $ = (0, $frIzR.c)(5);
    const { atlGeneralWebPanelHeight: atlGeneralWebPanelHeight } = (0, $8WfxO.useATLGeneralWebPanelListener)();
    const { forgePageBannerHeight: forgePageBannerHeight } = (0, $134d01bd64a6ba9b$export$e43ca933d3c87145)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            (0, $gqqjz.FlagsStateContainer),
            (0, $1a6Dn.FloatingBannerStateContainer)
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== atlGeneralWebPanelHeight || $[2] !== forgePageBannerHeight || $[3] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t0
        }, (flags, floatingBanners)=>{
            const forgePageBannerHeightFeatureFlagged = forgePageBannerHeight;
            const pageHeaderAndBannerHeight = floatingBanners.getFloatingHeight() + (props.isContentHeaderFixedAtTop ? 55 + atlGeneralWebPanelHeight + forgePageBannerHeightFeatureFlagged : 0);
            const stickyTableHeaderConfig = {
                offsetTop: pageHeaderAndBannerHeight,
                defaultScrollRootId_DO_NOT_USE: "AkMainContent",
                shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE: true
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fyKZ5.ADFRendererComponent), {
                flags: flags,
                ...stickyTableHeaderConfig,
                ...props
            });
        });
        $[1] = atlGeneralWebPanelHeight;
        $[2] = forgePageBannerHeight;
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
});
$2a9f51add9ac11ab$export$7cfa481653c48265.displayName = 'ADFRenderer';
module.exports["ADFRenderer"] = $2a9f51add9ac11ab$export$7cfa481653c48265;

});

parcelRegister("fyKZ5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $4FxUL = parcelRequire("4FxUL");


var $ibzAc = parcelRequire("ibzAc");


var $67O0h = parcelRequire("67O0h");


var $dh538 = parcelRequire("dh538");


var $1iSzD = parcelRequire("1iSzD");


var $lJlG6 = parcelRequire("lJlG6");


var $7VJPz = parcelRequire("7VJPz");


var $fgQGl = parcelRequire("fgQGl");


var $gCz4s = parcelRequire("gCz4s");


var $btIEy = parcelRequire("btIEy");


var $i6Ps3 = parcelRequire("i6Ps3");


var $hSHWm = parcelRequire("hSHWm");





var $4cOi8 = parcelRequire("4cOi8");


var $cNwLI = parcelRequire("cNwLI");


var $kcoxM = parcelRequire("kcoxM");


var $lf1vG = parcelRequire("lf1vG");


var $cVaAA = parcelRequire("cVaAA");


var $5Ac5G = parcelRequire("5Ac5G");


var $jmjWc = parcelRequire("jmjWc");


var $bl1ay = parcelRequire("bl1ay");


var $cbvYp = parcelRequire("cbvYp");


const $044598a12ce14eec$export$b55cedbe49066c7 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "lL-x8",
    name: "CardsExtensionLoader",
    loader: async ()=>(await (parcelRequire("leEhv"))).CardsExtension
});

const $044598a12ce14eec$var$PlatformSpotlightExtensionLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "d8j05",
    name: "PlatformSpotlightExtensionLoader",
    loader: async ()=>(await (parcelRequire("ijSB6"))).SpotlightExtension
});

const $044598a12ce14eec$var$PlatformSearchExtensionLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "24LHW",
    name: "PlatformSearchExtensionLoader",
    loader: async ()=>(await (parcelRequire("b0Fzw"))).CustomSearchExtension
});

const $044598a12ce14eec$var$LinksMenuLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "khj-w",
    name: "LinksMenuLoader",
    loader: async ()=>(await (parcelRequire("fP2mK"))).LinksMenu
});

const $044598a12ce14eec$var$CarouselLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "iP7CN",
    name: "CarouselLoader",
    loader: async ()=>(await (parcelRequire("6Ck7n"))).Carousel
});
const $044598a12ce14eec$export$2a3fa2b29e6e4046 = ({ contentId: contentId })=>{
    const extensionHandlers = {
        [(0, $kcoxM.CARDS_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null),
        [(0, $5Ac5G.carouselExtensionType)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null),
        [(0, $cVaAA.LINKS_MENU_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null),
        [(0, $bl1ay.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null),
        [(0, $cNwLI.SPOTLIGHT_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null),
        [(0, $lf1vG.SEARCH_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null)
    };
    if (contentId) {
        extensionHandlers[0, $kcoxM.CARDS_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($044598a12ce14eec$export$b55cedbe49066c7, {
                extensionNode: extension,
                contentId: contentId,
                mode: (0, $4cOi8.ExtensionMode).RENDERER,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
        extensionHandlers[0, $5Ac5G.carouselExtensionType] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($044598a12ce14eec$var$CarouselLoader, {
                extensionNode: extension,
                contentId: contentId,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
        extensionHandlers[0, $cVaAA.LINKS_MENU_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($044598a12ce14eec$var$LinksMenuLoader, {
                mode: (0, $4cOi8.ExtensionMode).RENDERER,
                extensionNode: extension,
                contentId: contentId,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
        extensionHandlers[0, $cNwLI.SPOTLIGHT_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($044598a12ce14eec$var$PlatformSpotlightExtensionLoader, {
                contentId: contentId,
                extensionNode: extension,
                mode: (0, $4cOi8.ExtensionMode).RENDERER,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
        extensionHandlers[0, $bl1ay.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE] = ()=>null;
        extensionHandlers[0, $lf1vG.SEARCH_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($044598a12ce14eec$var$PlatformSearchExtensionLoader, {
                mode: (0, $4cOi8.ExtensionMode).RENDERER,
                contentId: contentId,
                extensionNode: extension,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
    }
    return extensionHandlers;
};



var $7BsWq = parcelRequire("7BsWq");


var $brsfB = parcelRequire("brsfB");






const $5523d8b8240ba692$export$cde76c461119a84c = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "31jfw",
    name: "LazySmartlinkAuthNudge",
    loader: async ()=>(await (parcelRequire("ldonE"))).SmartlinkAuthNudge
});



var $gXrHX = parcelRequire("gXrHX");


var $1SPMi = parcelRequire("1SPMi");


var $yuV6Z = parcelRequire("yuV6Z");


var $kLzei = parcelRequire("kLzei");


var $hMB4W = parcelRequire("hMB4W");


var $iP9x4 = parcelRequire("iP9x4");


var $3WO8q = parcelRequire("3WO8q");

var $gxhb8 = parcelRequire("gxhb8");


var $dtVue = parcelRequire("dtVue");


var $4IoVL = parcelRequire("4IoVL");


var $32x2E = parcelRequire("32x2E");


var $8WQTF = parcelRequire("8WQTF");


var $jyPfN = parcelRequire("jyPfN");


var $7W8i8 = parcelRequire("7W8i8");



var $ep3mz = parcelRequire("ep3mz");


var $cD1qu = parcelRequire("cD1qu");


var $gj42z = parcelRequire("gj42z");


var $4GlQ9 = parcelRequire("4GlQ9");


var $dPJCf = parcelRequire("dPJCf");


var $4o1RV = parcelRequire("4o1RV");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $e4o8D = parcelRequire("e4o8D");


var $6M71K = parcelRequire("6M71K");


var $6GQtz = parcelRequire("6GQtz");


var $dXIrr = parcelRequire("dXIrr");


var $9Eka4 = parcelRequire("9Eka4");


var $BjpgS = parcelRequire("BjpgS");


var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");





var $9wGTI = parcelRequire("9wGTI");


var $8wppk = parcelRequire("8wppk");














var $4ZTaE = parcelRequire("4ZTaE");


var $kO2Re = parcelRequire("kO2Re");


var $37B9X = parcelRequire("37B9X");





var $hmRc4 = parcelRequire("hmRc4");


var $3jwuS = parcelRequire("3jwuS");





var $1JyKZ = parcelRequire("1JyKZ");


var $aF5bm = parcelRequire("aF5bm");


var $iop2R = parcelRequire("iop2R");


var $8z3oB = parcelRequire("8z3oB");

const $2c8591f62b6cc876$var$toInternalModalState = (raw)=>{
    const extension = raw.extension;
    if (!extension) return null;
    const onClose = typeof raw.onClose === 'function' ? raw.onClose : undefined;
    return {
        resource: raw.resource ?? undefined,
        size: raw.size,
        context: raw.context,
        closeOnEscape: raw.closeOnEscape,
        closeOnOverlayClick: raw.closeOnOverlayClick,
        onClose: onClose,
        title: raw.title,
        icon: raw.icon,
        embeddedMacroLocalId: raw.embeddedMacroLocalId,
        extension: extension,
        extensionData: raw.extensionData ?? undefined,
        extensionPayload: raw.extensionPayload ?? undefined,
        isEmbeddedMacroModal: Boolean(raw.isEmbeddedMacroModal)
    };
};
const $2c8591f62b6cc876$export$3f2ad537c77fda12 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { payload: payload, flags: flags, onDismiss: onDismiss } = t0;
    let t1;
    bb0: {
        if (!payload) {
            t1 = false;
            break bb0;
        }
        const state = $2c8591f62b6cc876$var$toInternalModalState(payload);
        t1 = Boolean(state?.extension);
    }
    const canRenderModal = t1;
    if (!payload || !canRenderModal) return null;
    let t2;
    if ($[0] !== flags || $[1] !== onDismiss || $[2] !== payload) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c8591f62b6cc876$var$EmbeddedForgeMacroModalInner, {
            payload: payload,
            flags: flags,
            onDismiss: onDismiss
        });
        $[0] = flags;
        $[1] = onDismiss;
        $[2] = payload;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ payload: payload, flags: flags, onDismiss: onDismiss })=>{
    const canRenderModal = (0, $42omo.useMemo)(()=>{
        if (!payload) return false;
        const state = $2c8591f62b6cc876$var$toInternalModalState(payload);
        return Boolean(state?.extension);
    }, [
        payload
    ]);
    if (!payload || !canRenderModal) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2c8591f62b6cc876$var$EmbeddedForgeMacroModalInner, {
        payload: payload,
        flags: flags,
        onDismiss: onDismiss
    });
};
const $2c8591f62b6cc876$var$EmbeddedForgeMacroModalInner = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(95);
    const { payload: payload, flags: flags, onDismiss: onDismiss } = t0;
    let t1;
    if ($[0] !== payload) {
        t1 = $2c8591f62b6cc876$var$toInternalModalState(payload);
        $[0] = payload;
        $[1] = t1;
    } else t1 = $[1];
    const modalOptions = t1;
    const { cloudId: cloudId, environment: environment, userId: userId } = (0, $bQm3c.useSessionData)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const workspaceARI = (0, $aF5bm.useWorkspaceARI)();
    let t2;
    if ($[2] !== workspaceARI) {
        t2 = [
            workspaceARI
        ];
        $[2] = workspaceARI;
        $[3] = t2;
    } else t2 = $[3];
    const contextIds = t2;
    const [isReducedMotion, setIsReducedMotion] = (0, $42omo.useState)(false);
    let t3;
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            if (typeof window === "undefined") return;
            const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
            setIsReducedMotion(mq.matches);
            const onChange = ()=>setIsReducedMotion(mq.matches);
            mq.addEventListener("change", onChange);
            return ()=>mq.removeEventListener("change", onChange);
        };
        t4 = [];
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[6] !== flags) {
        t5 = (0, $8z3oB.getFlagProvider)(flags);
        $[6] = flags;
        $[7] = t5;
    } else t5 = $[7];
    const { showFlag: showFlag, closeFlag: closeFlag } = t5;
    const baseExtension = modalOptions?.extension;
    modalOptions?.extensionData;
    let t6;
    if ($[8] !== modalOptions?.extensionData) {
        t6 = modalOptions?.extensionData || {};
        $[8] = modalOptions?.extensionData;
        $[9] = t6;
    } else t6 = $[9];
    const baseExtensionData = t6;
    let t7;
    if ($[10] !== baseExtensionData.content || $[11] !== isLivePage) {
        t7 = baseExtensionData.content ? {
            ...baseExtensionData.content,
            subtype: isLivePage ? "live" : null
        } : undefined;
        $[10] = baseExtensionData.content;
        $[11] = isLivePage;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== baseExtensionData || $[14] !== t7) {
        t8 = {
            ...baseExtensionData,
            content: t7
        };
        $[13] = baseExtensionData;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    const updatedExtensionData = t8;
    const t9 = baseExtension;
    const t10 = modalOptions?.embeddedMacroLocalId;
    let t11;
    if ($[16] !== contextIds || $[17] !== t10 || $[18] !== t9 || $[19] !== updatedExtensionData) {
        t11 = {
            extension: t9,
            extensionData: updatedExtensionData,
            localId: t10,
            contextIds: contextIds,
            cachingEnabled: true
        };
        $[16] = contextIds;
        $[17] = t10;
        $[18] = t9;
        $[19] = updatedExtensionData;
        $[20] = t11;
    } else t11 = $[20];
    const getContextTokenHandler = (0, $1JyKZ.useGetContextToken)(t11);
    const [viewOnClose, setViewOnClose] = (0, $42omo.useState)();
    modalOptions?.embeddedMacroLocalId;
    let t12;
    bb0: {
        if (!baseExtension) {
            t12 = undefined;
            break bb0;
        }
        const { id: extensionId, environmentId: environmentId, environmentType: environmentType } = baseExtension;
        const t13 = modalOptions?.embeddedMacroLocalId || extensionId;
        let t14;
        if ($[21] !== cloudId || $[22] !== environmentId || $[23] !== environmentType || $[24] !== t13) {
            t14 = {
                workspaceId: undefined,
                cloudId: cloudId,
                localId: t13,
                environmentId: environmentId,
                environmentType: environmentType
            };
            $[21] = cloudId;
            $[22] = environmentId;
            $[23] = environmentType;
            $[24] = t13;
            $[25] = t14;
        } else t14 = $[25];
        t12 = t14;
    }
    const coreData = t12;
    let t13;
    if ($[26] !== baseExtension?.properties?.title) {
        t13 = ()=>({
                ThreeLOPrompt: (0, $4ZTaE.makeThreeLOPromptForCustomUI)({
                    appName: baseExtension?.properties?.title ?? "",
                    onSuccess: $2c8591f62b6cc876$var$_temp
                })
            });
        $[26] = baseExtension?.properties?.title;
        $[27] = t13;
    } else t13 = $[27];
    baseExtension?.properties?.title;
    const getThreeLOPrompt = t13;
    const onCloseFromModalClass = modalOptions?.onClose;
    let t14;
    if ($[28] !== coreData || $[29] !== modalOptions) {
        t14 = modalOptions?.isEmbeddedMacroModal && modalOptions && coreData ? {
            extensionPayload: modalOptions.extensionPayload,
            extensionViewData: undefined,
            coreData: {
                ...coreData,
                localId: modalOptions.embeddedMacroLocalId || ""
            }
        } : {};
        $[28] = coreData;
        $[29] = modalOptions;
        $[30] = t14;
    } else t14 = $[30];
    const embeddedMacroModalProps = t14;
    let t15;
    bb1: {
        if (!coreData || !baseExtension || !modalOptions) {
            t15 = null;
            break bb1;
        }
        const t16 = userId || undefined;
        let t17;
        if ($[31] !== baseExtension || $[32] !== contextIds || $[33] !== coreData || $[34] !== embeddedMacroModalProps || $[35] !== getContextTokenHandler || $[36] !== getThreeLOPrompt || $[37] !== locale || $[38] !== modalOptions.extensionPayload || $[39] !== t16 || $[40] !== updatedExtensionData) {
            t17 = {
                accountId: t16,
                components: getThreeLOPrompt,
                contextIds: contextIds,
                coreData: coreData,
                customBridgeMethods: undefined,
                extension: baseExtension,
                extensionData: updatedExtensionData,
                extensionPayload: modalOptions.extensionPayload,
                extensionViewData: undefined,
                getContextToken: getContextTokenHandler,
                isHidden: false,
                isResizable: false,
                locale: locale,
                timezone: undefined,
                loadingComponent: undefined,
                isEmbeddedMacro: false,
                embeddedParentLocalId: undefined,
                embeddedMacroModalProps: embeddedMacroModalProps
            };
            $[31] = baseExtension;
            $[32] = contextIds;
            $[33] = coreData;
            $[34] = embeddedMacroModalProps;
            $[35] = getContextTokenHandler;
            $[36] = getThreeLOPrompt;
            $[37] = locale;
            $[38] = modalOptions.extensionPayload;
            $[39] = t16;
            $[40] = updatedExtensionData;
            $[41] = t17;
        } else t17 = $[41];
        t15 = t17;
    }
    const iframeProps = t15;
    let t16;
    bb2: {
        if (!iframeProps) {
            t16 = null;
            break bb2;
        }
        t16 = {
            ...iframeProps,
            ...embeddedMacroModalProps
        };
    }
    const modalIframeProps = t16;
    let t17;
    bb3: {
        if (!modalOptions || !baseExtension) {
            t17 = baseExtension;
            break bb3;
        }
        let t18;
        if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
            t18 = {};
            $[42] = t18;
        } else t18 = $[42];
        let resourceOverride = t18;
        if (modalOptions?.resource) {
            let t19;
            if ($[43] !== modalOptions.resource) {
                t19 = (0, $9wGTI.fg)("forge-ui-multi-entry-resource-macro-config-fix") ? (0, $37B9X.resolveDynamicResource)(modalOptions.resource) : {
                    resource: modalOptions.resource
                };
                $[43] = modalOptions.resource;
                $[44] = t19;
            } else t19 = $[44];
            resourceOverride = t19;
        }
        const t19 = `${baseExtension.type}::dynamic-modal`;
        let t20;
        if ($[45] !== baseExtension.properties || $[46] !== resourceOverride) {
            t20 = {
                ...baseExtension.properties,
                ...resourceOverride
            };
            $[45] = baseExtension.properties;
            $[46] = resourceOverride;
            $[47] = t20;
        } else t20 = $[47];
        let t21;
        if ($[48] !== baseExtension || $[49] !== t19 || $[50] !== t20) {
            t21 = {
                ...baseExtension,
                type: t19,
                properties: t20
            };
            $[48] = baseExtension;
            $[49] = t19;
            $[50] = t20;
            $[51] = t21;
        } else t21 = $[51];
        t17 = t21;
    }
    const extensionInModal = t17;
    let t18;
    bb4: {
        if (!modalOptions || !baseExtension) {
            t18 = updatedExtensionData;
            break bb4;
        }
        const base = modalOptions.extensionData || updatedExtensionData;
        let t19;
        if ($[52] !== modalOptions.context) {
            t19 = modalOptions.context ? {
                modal: modalOptions.context
            } : {};
            $[52] = modalOptions.context;
            $[53] = t19;
        } else t19 = $[53];
        let t20;
        if ($[54] !== baseExtension.type || $[55] !== modalOptions.context) {
            t20 = baseExtension.type.startsWith("jiraServiceManagement") && modalOptions.context ? {
                ...modalOptions.context
            } : {};
            $[54] = baseExtension.type;
            $[55] = modalOptions.context;
            $[56] = t20;
        } else t20 = $[56];
        let t21;
        if ($[57] !== base || $[58] !== t19 || $[59] !== t20) {
            t21 = {
                ...base,
                ...t19,
                ...t20
            };
            $[57] = base;
            $[58] = t19;
            $[59] = t20;
            $[60] = t21;
        } else t21 = $[60];
        t18 = t21;
    }
    const extensionDataInModal = t18;
    let t19;
    if ($[61] !== onDismiss) {
        t19 = ()=>{
            onDismiss();
        };
        $[61] = onDismiss;
        $[62] = t19;
    } else t19 = $[62];
    const handleModalTearDown = t19;
    let t20;
    if ($[63] !== handleModalTearDown || $[64] !== isReducedMotion || $[65] !== onCloseFromModalClass) {
        t20 = ()=>{
            onCloseFromModalClass?.();
            if (isReducedMotion) handleModalTearDown();
        };
        $[63] = handleModalTearDown;
        $[64] = isReducedMotion;
        $[65] = onCloseFromModalClass;
        $[66] = t20;
    } else t20 = $[66];
    const handleModalClose = t20;
    let t21;
    let t22;
    if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = (0, $hmRc4.getBrowserHistory)();
        t22 = (callback)=>{
            setViewOnClose(()=>callback.data);
            return true;
        };
        $[67] = t21;
        $[68] = t22;
    } else {
        t21 = $[67];
        t22 = $[68];
    }
    let t23;
    if ($[69] !== onCloseFromModalClass) {
        t23 = (closePayload)=>{
            onCloseFromModalClass?.(closePayload?.data);
            return true;
        };
        $[69] = onCloseFromModalClass;
        $[70] = t23;
    } else t23 = $[70];
    let t24;
    if ($[71] !== closeFlag || $[72] !== showFlag || $[73] !== t23) {
        t24 = {
            showFlag: showFlag,
            closeFlag: closeFlag,
            history: t21,
            onClose: t22,
            close: t23
        };
        $[71] = closeFlag;
        $[72] = showFlag;
        $[73] = t23;
        $[74] = t24;
    } else t24 = $[74];
    const bridge = t24;
    if (!modalOptions || !baseExtension || !iframeProps || !modalIframeProps) return null;
    const t25 = modalOptions.embeddedMacroLocalId ?? baseExtension.id;
    const t26 = modalOptions.size;
    const t27 = modalOptions.title;
    const t28 = modalOptions.icon;
    const t29 = modalOptions.closeOnEscape;
    const t30 = modalOptions.closeOnOverlayClick;
    let t31;
    if ($[75] !== cloudId || $[76] !== environment || $[77] !== userId) {
        t31 = (0, $iop2R.getMentionProvider)(cloudId, environment, userId);
        $[75] = cloudId;
        $[76] = environment;
        $[77] = userId;
        $[78] = t31;
    } else t31 = $[78];
    let t32;
    if ($[79] !== bridge || $[80] !== extensionDataInModal || $[81] !== extensionInModal || $[82] !== getThreeLOPrompt || $[83] !== handleModalClose || $[84] !== handleModalTearDown || $[85] !== iframeProps || $[86] !== modalOptions.closeOnEscape || $[87] !== modalOptions.closeOnOverlayClick || $[88] !== modalOptions.icon || $[89] !== modalOptions.size || $[90] !== modalOptions.title || $[91] !== t25 || $[92] !== t31 || $[93] !== viewOnClose) {
        t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kO2Re.ModalCustomUIRenderer), {
            ...iframeProps,
            product: "confluence",
            getThreeLOPrompt: getThreeLOPrompt,
            extension: extensionInModal,
            extensionData: extensionDataInModal,
            localId: t25,
            onTearDown: handleModalTearDown,
            bridge: bridge,
            modalOnClose: handleModalClose,
            size: t26,
            title: t27,
            icon: t28,
            closeOnEscape: t29,
            closeOnOverlayClick: t30,
            getModalWidth: undefined,
            isIframeResizable: false,
            viewOnClose: viewOnClose,
            mentionProvider: t31
        });
        $[79] = bridge;
        $[80] = extensionDataInModal;
        $[81] = extensionInModal;
        $[82] = getThreeLOPrompt;
        $[83] = handleModalClose;
        $[84] = handleModalTearDown;
        $[85] = iframeProps;
        $[86] = modalOptions.closeOnEscape;
        $[87] = modalOptions.closeOnOverlayClick;
        $[88] = modalOptions.icon;
        $[89] = modalOptions.size;
        $[90] = modalOptions.title;
        $[91] = t25;
        $[92] = t31;
        $[93] = viewOnClose;
        $[94] = t32;
    } else t32 = $[94];
    return t32;
} : ({ payload: payload, flags: flags, onDismiss: onDismiss })=>{
    const modalOptions = (0, $42omo.useMemo)(()=>$2c8591f62b6cc876$var$toInternalModalState(payload), [
        payload
    ]);
    const { cloudId: cloudId, environment: environment, userId: userId } = (0, $bQm3c.useSessionData)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const workspaceARI = (0, $aF5bm.useWorkspaceARI)();
    const contextIds = (0, $42omo.useMemo)(()=>[
            workspaceARI
        ], [
        workspaceARI
    ]);
    const [isReducedMotion, setIsReducedMotion] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
        setIsReducedMotion(mq.matches);
        const onChange = ()=>setIsReducedMotion(mq.matches);
        mq.addEventListener('change', onChange);
        return ()=>mq.removeEventListener('change', onChange);
    }, []);
    const { showFlag: showFlag, closeFlag: closeFlag } = (0, $8z3oB.getFlagProvider)(flags);
    const baseExtension = modalOptions?.extension;
    const updatedExtensionData = (0, $42omo.useMemo)(()=>{
        const baseExtensionData = modalOptions?.extensionData || {};
        return {
            ...baseExtensionData,
            content: baseExtensionData.content ? {
                ...baseExtensionData.content,
                subtype: isLivePage ? 'live' : null
            } : undefined
        };
    }, [
        isLivePage,
        modalOptions?.extensionData
    ]);
    const getContextTokenHandler = (0, $1JyKZ.useGetContextToken)({
        extension: baseExtension,
        extensionData: updatedExtensionData,
        localId: modalOptions?.embeddedMacroLocalId,
        contextIds: contextIds,
        cachingEnabled: true
    });
    const [viewOnClose, setViewOnClose] = (0, $42omo.useState)();
    const coreData = (0, $42omo.useMemo)(()=>{
        if (!baseExtension) return undefined;
        const { id: extensionId, environmentId: environmentId, environmentType: environmentType } = baseExtension;
        return {
            workspaceId: undefined,
            cloudId: cloudId,
            localId: modalOptions?.embeddedMacroLocalId || extensionId,
            environmentId: environmentId,
            environmentType: environmentType
        };
    }, [
        baseExtension,
        cloudId,
        modalOptions?.embeddedMacroLocalId
    ]);
    const getThreeLOPrompt = (0, $42omo.useCallback)(()=>{
        return {
            ThreeLOPrompt: (0, $4ZTaE.makeThreeLOPromptForCustomUI)({
                appName: baseExtension?.properties?.title ?? '',
                onSuccess: ()=>{}
            })
        };
    }, [
        baseExtension?.properties?.title
    ]);
    const onCloseFromModalClass = modalOptions?.onClose;
    // Memoised so the object identity is stable across renders. Without this,
    // every render produces a fresh `{}` and any downstream useMemo that lists
    // `embeddedMacroModalProps` in its deps would invalidate on every render.
    const embeddedMacroModalProps = (0, $42omo.useMemo)(()=>modalOptions?.isEmbeddedMacroModal && modalOptions && coreData ? {
            extensionPayload: modalOptions.extensionPayload,
            extensionViewData: undefined,
            coreData: {
                ...coreData,
                localId: modalOptions.embeddedMacroLocalId || ''
            }
        } : {}, [
        coreData,
        modalOptions
    ]);
    const iframeProps = (0, $42omo.useMemo)(()=>{
        if (!coreData || !baseExtension || !modalOptions) return null;
        return {
            accountId: userId || undefined,
            components: getThreeLOPrompt,
            contextIds: contextIds,
            coreData: coreData,
            customBridgeMethods: undefined,
            extension: baseExtension,
            extensionData: updatedExtensionData,
            extensionPayload: modalOptions.extensionPayload,
            extensionViewData: undefined,
            getContextToken: getContextTokenHandler,
            isHidden: false,
            isResizable: false,
            locale: locale,
            timezone: undefined,
            loadingComponent: undefined,
            isEmbeddedMacro: false,
            embeddedParentLocalId: undefined,
            embeddedMacroModalProps: embeddedMacroModalProps
        };
    }, [
        baseExtension,
        contextIds,
        coreData,
        getContextTokenHandler,
        getThreeLOPrompt,
        locale,
        modalOptions,
        updatedExtensionData,
        userId,
        embeddedMacroModalProps
    ]);
    const modalIframeProps = (0, $42omo.useMemo)(()=>{
        if (!iframeProps) return null;
        return {
            ...iframeProps,
            ...embeddedMacroModalProps
        };
    }, [
        embeddedMacroModalProps,
        iframeProps
    ]);
    const extensionInModal = (0, $42omo.useMemo)(()=>{
        if (!modalOptions || !baseExtension) return baseExtension;
        // `openModal`'s resource is optional; only override when one is explicitly provided. When it is
        // omitted the modal defaults to the current resource, so we inherit it (and its entry) untouched.
        let resourceOverride = {};
        if (modalOptions?.resource) resourceOverride = (0, $9wGTI.fg)('forge-ui-multi-entry-resource-macro-config-fix') ? (0, $37B9X.resolveDynamicResource)(modalOptions.resource) : {
            resource: modalOptions.resource
        };
        return {
            ...baseExtension,
            type: `${baseExtension.type}::dynamic-modal`,
            properties: {
                ...baseExtension.properties,
                ...resourceOverride
            }
        };
    }, [
        baseExtension,
        modalOptions
    ]);
    const extensionDataInModal = (0, $42omo.useMemo)(()=>{
        if (!modalOptions || !baseExtension) return updatedExtensionData;
        const base = modalOptions.extensionData || updatedExtensionData;
        return {
            ...base,
            ...modalOptions.context ? {
                modal: modalOptions.context
            } : {},
            ...baseExtension.type.startsWith('jiraServiceManagement') && modalOptions.context ? {
                ...modalOptions.context
            } : {}
        };
    }, [
        baseExtension,
        modalOptions,
        updatedExtensionData
    ]);
    const handleModalTearDown = (0, $42omo.useCallback)(()=>{
        onDismiss();
    }, [
        onDismiss
    ]);
    const handleModalClose = (0, $42omo.useCallback)(()=>{
        onCloseFromModalClass?.();
        if (isReducedMotion) handleModalTearDown();
    }, [
        handleModalTearDown,
        isReducedMotion,
        onCloseFromModalClass
    ]);
    const bridge = (0, $42omo.useMemo)(()=>({
            showFlag: showFlag,
            closeFlag: closeFlag,
            history: (0, $hmRc4.getBrowserHistory)(),
            onClose: (callback)=>{
                setViewOnClose(()=>callback.data);
                return true;
            },
            close: (closePayload)=>{
                onCloseFromModalClass?.(closePayload?.data);
                return true;
            }
        }), [
        closeFlag,
        onCloseFromModalClass,
        showFlag
    ]);
    if (!modalOptions || !baseExtension || !iframeProps || !modalIframeProps) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kO2Re.ModalCustomUIRenderer), {
        ...iframeProps,
        product: "confluence",
        getThreeLOPrompt: getThreeLOPrompt,
        extension: extensionInModal,
        extensionData: extensionDataInModal,
        localId: modalOptions.embeddedMacroLocalId ?? baseExtension.id,
        onTearDown: handleModalTearDown,
        bridge: bridge,
        modalOnClose: handleModalClose,
        size: modalOptions.size,
        title: modalOptions.title,
        icon: modalOptions.icon,
        closeOnEscape: modalOptions.closeOnEscape,
        closeOnOverlayClick: modalOptions.closeOnOverlayClick,
        getModalWidth: undefined,
        isIframeResizable: false,
        viewOnClose: viewOnClose,
        mentionProvider: (0, $iop2R.getMentionProvider)(cloudId, environment, userId)
    });
};
function $2c8591f62b6cc876$var$_temp() {}


const $bb91119414a4e358$export$d8ebe500960648d = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { document: document, flags: flags } = t0;
    const [openModalPayload, setOpenModalPayload] = (0, $42omo.useState)(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (payload)=>{
            setOpenModalPayload(payload);
        };
        $[0] = t1;
    } else t1 = $[0];
    const onEmbeddedForgeOpenModal = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setOpenModalPayload(null);
        };
        $[1] = t2;
    } else t2 = $[1];
    const dismissOpenModal = t2;
    let t3;
    let t4;
    if ($[2] !== document || $[3] !== flags) {
        t3 = ()=>{
            if (!document || !(0, $9wGTI.fg)("forge_nbm_connect_to_forge_bridge")) return;
            return (0, $8wppk.registerEmbeddedMacroListeners)(document, flags, {
                onEmbeddedForgeOpenModal: onEmbeddedForgeOpenModal
            });
        };
        t4 = [
            document,
            flags,
            onEmbeddedForgeOpenModal
        ];
        $[2] = document;
        $[3] = flags;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[6] !== flags || $[7] !== openModalPayload) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2c8591f62b6cc876$export$3f2ad537c77fda12), {
            payload: openModalPayload,
            flags: flags,
            onDismiss: dismissOpenModal
        });
        $[6] = flags;
        $[7] = openModalPayload;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ document: document, flags: flags })=>{
    const [openModalPayload, setOpenModalPayload] = (0, $42omo.useState)(null);
    const onEmbeddedForgeOpenModal = (0, $42omo.useCallback)((payload)=>{
        setOpenModalPayload(payload);
    }, []);
    const dismissOpenModal = (0, $42omo.useCallback)(()=>{
        setOpenModalPayload(null);
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (!document || !(0, $9wGTI.fg)('forge_nbm_connect_to_forge_bridge')) return;
        return (0, $8wppk.registerEmbeddedMacroListeners)(document, flags, {
            onEmbeddedForgeOpenModal: onEmbeddedForgeOpenModal
        });
    }, [
        document,
        flags,
        onEmbeddedForgeOpenModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2c8591f62b6cc876$export$3f2ad537c77fda12), {
        payload: openModalPayload,
        flags: flags,
        onDismiss: dismissOpenModal
    });
};






var $6Trhx = parcelRequire("6Trhx");


var $edEsl = parcelRequire("edEsl");


var $04e9M = parcelRequire("04e9M");


var $eXfot = parcelRequire("eXfot");


var $6s78L = parcelRequire("6s78L");

async function $ad68e9e7df73622d$export$ee66267d3930a21(contentId, batch) {
    const updateBatch = batch.map((update)=>{
        const { objectKey: objectKey, state: state } = update;
        const status = state === 'DONE' ? 'CHECKED' : 'UNCHECKED';
        return {
            taskId: objectKey.localId,
            status: status
        };
    });
    const taskBatch = {
        contentId: contentId,
        tasks: updateBatch,
        trigger: 'VIEW_PAGE'
    };
    try {
        return await (0, $6s78L.mutateInterop)({
            mutation: (0, $eXfot.SetBatchedTaskStatusMutation),
            variables: taskBatch,
            __callerPackage__: "@confluence/adf-renderer"
        });
    } catch (error) {
        const client = await (0, $04e9M.getAnalyticsWebClient)();
        client.sendOperationalEvent({
            source: 'page',
            action: 'batchTaskUpdate',
            actionSubject: 'checkbox',
            attributes: {
                error: error.message || String(error),
                stack: error.stack
            }
        });
    }
}















const $05271241466f5e2e$var$ViewPageAttachmentForgeActionsPortalLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "26C7v",
    name: "ViewPageAttachmentForgeActionsPortalLoader",
    loader: async ()=>(await (parcelRequire("hMmSn"))).ViewPageAttachmentForgeActionsPortal
});
$05271241466f5e2e$var$ViewPageAttachmentForgeActionsPortalLoader.displayName = 'lazy(ViewPageAttachmentForgeActionsPortal)';
const $05271241466f5e2e$export$b8cbd42b7b7bd9d2 = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { contentId: contentId, contentType: contentType, isViewPage: isViewPage, spaceKey: spaceKey } = t0;
    if (!isViewPage || !contentId || !spaceKey || !contentType || !(0, $9wGTI.fg)("forge_attachment_display_conditions")) return null;
    let t1;
    if ($[0] !== contentId || $[1] !== contentType || $[2] !== isViewPage || $[3] !== spaceKey) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($05271241466f5e2e$var$ViewPageAttachmentForgeActionsPortalLoader, {
            contentId: contentId,
            contentType: contentType,
            isViewPage: isViewPage,
            spaceKey: spaceKey
        });
        $[0] = contentId;
        $[1] = contentType;
        $[2] = isViewPage;
        $[3] = spaceKey;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
};



var $kyRHQ = parcelRequire("kyRHQ");

const $1af8a83cb114ff50$export$3422b9c70e187e34 = {
    enabled: true,
    severityDegradedThreshold: 4747,
    severityNormalThreshold: 3775
};
const $1af8a83cb114ff50$var$logger = (0, $7W8i8.getLogger)('ADFRenderer');
const $1af8a83cb114ff50$export$c02e908ea3c1fe52 = {
    enabled: true,
    thresholds: {
        blocking: 1.5,
        degraded: 1
    }
};
const $1af8a83cb114ff50$var$mergeDataProviders = ({ hasViewUserProfilePermission: hasViewUserProfilePermission, handleActionToggle: handleActionToggle, handleInviteItemClick: handleInviteItemClick, getDataProviders: getDataProviders, providerFactory: providerFactory, isExternalShare: isExternalShare, contentId: contentId, spaceKey: spaceKey, pageContextContentId: pageContextContentId, cloudId: cloudId, userId: userId, userRole: userRole, flags: flags, profilecardProvider: profilecardProvider, intl: intl, mediaToken: mediaToken, emojiResourceParams: emojiResourceParams })=>{
    const providers = {};
    if (getDataProviders) Object.assign(providers, getDataProviders());
    if (contentId || mediaToken) {
        providers.mediaProvider = (0, $4IoVL.createRendererMediaProvider)({
            contentId: contentId,
            spaceKey: spaceKey,
            mediaDspContentId: pageContextContentId,
            isExternalShare: isExternalShare,
            mediaToken: mediaToken
        });
        providers.taskDecisionProvider = Promise.resolve(new (0, $3WO8q.ConfluenceTaskDecisionProvider)(intl, flags, contentId, handleActionToggle));
    }
    if (cloudId && userId) providers.mentionProvider = (0, $dtVue.createMentionsConfig)(cloudId, userId, undefined, undefined, handleInviteItemClick, userRole).then((config)=>config.mentionResource).catch((err)=>{
        if ($kyRHQ.env.NODE_ENV !== 'production') $1af8a83cb114ff50$var$logger.error`Failed to initialise mention resource ${err}`;
        return Promise.reject();
    });
    if (emojiResourceParams && cloudId) providers.emojiProvider = (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
        ...emojiResourceParams,
        allowAnonymousAccess: true
    });
    if (cloudId) // If global view user profile is enabled then user can view profile card
    {
        if (hasViewUserProfilePermission) providers.profilecardProvider = profilecardProvider;
    }
    if (contentId && spaceKey) providers.contextIdentifierProvider = Promise.resolve({
        containerId: spaceKey,
        objectId: contentId,
        product: 'confluence'
    });
    providers.cardProvider = Promise.resolve(new (0, $6GQtz.ConfluenceEditorCardProvider)());
    const keys = Object.keys(providers);
    if (keys.length) {
        providerFactory = providerFactory || (0, $4FxUL.default).create({});
        for (const provider of Object.keys(providers))providerFactory.setProvider(provider, providers[provider]);
    }
    return {
        providerFactory: providerFactory,
        providers: providers
    };
};
const $1af8a83cb114ff50$var$projectLinkerHandlers = {
    'com.atlassian.confluence.project-linker': ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null)
};
const $1af8a83cb114ff50$export$58eac04eb6213951 = ()=>(0, $dh538.fg)('platform_renderer_unsupported_content_tracking') ? $1af8a83cb114ff50$export$c02e908ea3c1fe52 : undefined;
const $1af8a83cb114ff50$var$DEFAULT_EXTENSION_HANDLERS = {};
const $1af8a83cb114ff50$var$DEFAULT_GET_EXTENSION_HANDLERS = ()=>$1af8a83cb114ff50$var$DEFAULT_EXTENSION_HANDLERS;
const $1af8a83cb114ff50$var$DEFAULT_EXTENSION_VIEWPORT_SIZES = [];
const $1af8a83cb114ff50$export$cec675c14d32c246 = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const { document: document, dataProviders: dataProviders, extensionHandlers: extensionHandlers = $1af8a83cb114ff50$var$DEFAULT_EXTENSION_HANDLERS, getExtensionHandlers: getExtensionHandlers = $1af8a83cb114ff50$var$DEFAULT_GET_EXTENSION_HANDLERS, eventHandlers: eventHandlers, appearance: appearance, contentMode: contentMode, adfStage: adfStage = 'stage0', portal: portal, onRendered: onRendered, renderWhenReady: renderWhenReady, allowStickyHeaders: allowStickyHeaders = true, allowPlaceholderText: allowPlaceholderText = false, isTruncatedContent: isTruncatedContent, maxHeight: maxHeight, fadeOutHeight: fadeOutHeight, flags: flags, offsetTop: offsetTop, defaultScrollRootId_DO_NOT_USE: defaultScrollRootId_DO_NOT_USE, shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE: shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE, mediaToken: mediaToken, onError: onError, UNSTABLE_allowTableAlignment: UNSTABLE_allowTableAlignment = true, UNSTABLE_allowTableResizing: UNSTABLE_allowTableResizing = true, UNSTABLE_isPresentational: UNSTABLE_isPresentational = false, extensionViewportSizes: extensionViewportSizes = $1af8a83cb114ff50$var$DEFAULT_EXTENSION_VIEWPORT_SIZES, onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail, allowRendererContainerStyles: allowRendererContainerStyles, pageMode: pageMode, ...rest } = props;
    const intl = (0, $aXWIB.useIntl)();
    const [isTaskToggled, setIsTaskToggled] = (0, $42omo.useState)(false);
    const initialState = window['__SSR_SMARTLINKS__'];
    const isPageSSR = (0, $i6Ps3.isPageSSRd)();
    const { storeOptions: storeOptions, SuspenseWrapperForUrl: SuspenseWrapperForUrl } = (0, $btIEy.useStoreOptions)(initialState, isPageSSR, {
        useSSRStore: (0, $6mKj3.expVal)('confluence_smartlinks_suspense', 'isEnabled', false)
    });
    const isEmbedded = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    // Fix for HOT-99954 - Issue where embedded pages SSR SmartLinks open in same tab
    const shouldSSRsmartLinks = isPageSSR && !isEmbedded && !(0, $lJlG6.isMobileApp_DO_NOT_USE)();
    const { cloudId: cloudId, userId: userId, featureFlags: featureFlags, isLicensed: isLicensed, isLoggedIn: isLoggedIn, isAdminHubAIEnabled: isAdminHubAIEnabled, timeZone: timeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [pageContextContentId] = (0, $ep3mz.usePageContentId)();
    const [pageContextContentType] = (0, $ep3mz.useContentType)();
    const { openCoreInvites: openCoreInvites, userRole: userRole } = (0, $42omo.useContext)((0, $hSHWm.CoreInvitesContext));
    const [shouldRefetchContent, setShouldRefetchContent] = (0, $42omo.useState)(false);
    const contentId = props.contentId || pageContextContentId;
    const contentType = props.contentType || pageContextContentType;
    const spaceKey = props.spaceKey || pageContextSpaceKey;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const taskBatcherRef = (0, $42omo.useRef)(new (0, $gxhb8.TaskBatcher)((0, $6mKj3.expVal)('confluence_frontend_task_batching_interval', 'value', 3000)));
    const feedFollowData = (0, $4GlQ9.useFeedFollow)();
    // Handlers for batched task update
    const handleBatchTaskUpdate = (0, $42omo.useCallback)((batch)=>{
        // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
        (0, $ad68e9e7df73622d$export$ee66267d3930a21)(contentId, batch).then(()=>{
            setIsTaskToggled(false);
            setShouldRefetchContent(true);
        });
    }, [
        contentId,
        setShouldRefetchContent
    ]);
    const handleActionToggle = (0, $42omo.useCallback)((objectKey, state)=>{
        setIsTaskToggled(true);
        taskBatcherRef.current.add({
            objectKey: objectKey,
            state: state
        });
    }, [
        taskBatcherRef
    ]);
    (0, $42omo.useEffect)(()=>{
        // there is a document check - we do not want to call registerGlobalMediaViewedListener
        // with no content
        if (document) (0, $edEsl.registerGlobalMediaViewedListener)({
            contentType: contentType
        });
        onRendered && onRendered();
        taskBatcherRef.current.onFlush(handleBatchTaskUpdate);
        return ()=>{
            if (document) (0, $edEsl.removeGlobalMediaViewedListener)();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        taskBatcherRef,
        handleBatchTaskUpdate
    ]);
    (0, $42omo.useEffect)(()=>{
        setShouldRefetchContent(false);
    // WS-4098 - When the contentId changes or when we mount we don't need to refetch
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        contentId
    ]);
    (0, $42omo.useEffect)(()=>{
        const handleBeforeUnload = (event)=>{
            if (isTaskToggled) {
                event.preventDefault();
                event.returnValue = ''; // This triggers the alert in all browsers
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return ()=>{
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isTaskToggled,
        contentId
    ]);
    // Setting up emoji resources for ssr and data providers
    const emojiResourceParams = (0, $42omo.useMemo)(()=>{
        if (cloudId) return (0, $yuV6Z.createEmojiProviderParameters)({
            cloudId: cloudId,
            userId: userId,
            isLicensed: isLicensed,
            isLoggedIn: isLoggedIn,
            onEmojiLoadSuccess: onEmojiLoadSuccess,
            onEmojiLoadFail: onEmojiLoadFail
        });
    }, [
        cloudId,
        userId,
        isLicensed,
        isLoggedIn,
        onEmojiLoadSuccess,
        onEmojiLoadFail
    ]);
    const emojiResourceConfig = (0, $42omo.useMemo)(()=>{
        if (emojiResourceParams) return (0, $32x2E.getEmojiConfig)(emojiResourceParams.cloudId, emojiResourceParams.userId, emojiResourceParams.disableUpload, emojiResourceParams.emojiSSRConfig, undefined, emojiResourceParams.emojiLoadCallbacks);
    }, [
        emojiResourceParams
    ]);
    const { isExternalShareRequest: isExternalShareRequest } = (0, $42omo.useContext)((0, $gXrHX.ExternalShareContext));
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const mergedExtensionHandlers = (0, $42omo.useMemo)(()=>{
        return {
            ...getExtensionHandlers?.(),
            ...extensionHandlers,
            ...(0, $044598a12ce14eec$export$2a3fa2b29e6e4046)({
                contentId: contentId
            }),
            ...(0, $7VJPz.getRendererSmartButtonExtensionHandlers)({
                contentId: contentId,
                contentType: contentType,
                cloudId: cloudId
            }),
            ...$1af8a83cb114ff50$var$projectLinkerHandlers
        };
    }, [
        extensionHandlers,
        getExtensionHandlers,
        contentId,
        contentType,
        cloudId
    ]);
    const mediaSSR = (0, $iP9x4.useMediaSSRModeAndAuthConfig)({
        contentId: contentId,
        spaceKey: spaceKey,
        isExternalShare: isExternalShareRequest,
        mediaToken: mediaToken
    });
    // -- Matches fabric-feature-flags.ts
    const isStickyHeadersEnabled = allowStickyHeaders;
    const errorHandler = (0, $42omo.useCallback)((error)=>{
        onError?.(error);
    }, [
        onError
    ]);
    const { shimAdfUrls: shimAdfUrls } = (0, $4o1RV.useNavigationPolicy)();
    const editorFeatureFlags = (0, $7BsWq.useEditorFeatureFlags)();
    const profilecardProvider = (0, $brsfB.useProfilecardProvider)({
        push: push,
        userId: userId,
        cloudId: cloudId,
        featureFlags: featureFlags
    });
    const shouldControlDataExport = (0, $4IoVL.controlDataExportOnCertainFeatures)(window.location.pathname);
    // ----------------------------------
    const allowHeadingAnchorLinks = (0, $42omo.useMemo)(()=>({
            allowNestedHeaderLinks: true,
            activeHeadingId: props.queryHash
        }), [
        props.queryHash
    ]);
    // Build media viewer extensions to add the comments button to the preview header
    const mediaViewerExtensions = (0, $BjpgS.useMediaCommentExtensions)({
        isViewPage: true,
        analyticsSource: 'viewPageScreen',
        flags: flags
    });
    const fallbackMediaNameFetcher = (0, $42omo.useMemo)(()=>contentId ? (0, $6Trhx.createFallbackMediaNameFetcher)(contentId) : undefined, [
        contentId
    ]);
    const media = (0, $42omo.useMemo)(()=>({
            allowLinking: true,
            allowCaptions: true,
            featureFlags: {
                mediaInline: true
            },
            mediaViewerExtensions: mediaViewerExtensions,
            ssr: mediaSSR,
            fallbackMediaNameFetcher: (0, $6mKj3.expVal)('platform_editor_media_name_fallback', 'isEnabled', false) ? fallbackMediaNameFetcher : undefined
        }), [
        mediaSSR,
        mediaViewerExtensions,
        fallbackMediaNameFetcher
    ]);
    const CompetitorPromptWithAppearance = (0, $42omo.useMemo)(()=>{
        return (competitorPromptProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dXIrr.PromptPopupContainer), {
                ...competitorPromptProps,
                editorAppearance: appearance
            });
    }, [
        appearance
    ]);
    const actionOptions = (0, $42omo.useMemo)(()=>{
        const isFullPage = (appearance === 'full-page' || appearance === 'full-width' || appearance === 'max') && ((0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') || (0, $dh538.fg)('platform_sl_3p_auth_inline_tailored_cta_killswitch'));
        if (isFullPage) return {
            hide: false,
            rovoChatAction: {
                optIn: true
            }
        };
    }, [
        appearance
    ]);
    const getResolvingPlaceholder = (0, $42omo.useCallback)((url)=>window.__SSR_SMARTLINKS_TITLES__?.[url], []);
    const smartLinks = (0, $42omo.useMemo)(()=>({
            ssr: shouldSSRsmartLinks,
            hideHoverPreview: false,
            CompetitorPrompt: CompetitorPromptWithAppearance,
            SuspenseWrapperForUrl: SuspenseWrapperForUrl,
            ...(0, $dh538.fg)('platform_sl_3p_auth_rovo_action_kill_switch') || (0, $dh538.fg)('platform_sl_3p_auth_inline_tailored_cta_killswitch') ? {
                actionOptions: actionOptions
            } : undefined,
            ...(0, $6mKj3.expVal)('confluence_frontend_smartlinks_title_while_loading', 'isEnabled', false) ? {
                getResolvingPlaceholder: getResolvingPlaceholder
            } : undefined
        }), [
        actionOptions,
        shouldSSRsmartLinks,
        CompetitorPromptWithAppearance,
        SuspenseWrapperForUrl,
        getResolvingPlaceholder
    ]);
    const stickyHeaders = (0, $42omo.useMemo)(()=>isStickyHeadersEnabled ? {
            offsetTop: offsetTop,
            defaultScrollRootId_DO_NOT_USE: defaultScrollRootId_DO_NOT_USE,
            shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE: shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE
        } : undefined, [
        isStickyHeadersEnabled,
        offsetTop,
        defaultScrollRootId_DO_NOT_USE,
        shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE
    ]);
    const mergedDataProviders = (0, $42omo.useMemo)(()=>$1af8a83cb114ff50$var$mergeDataProviders({
            contentId: // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
            contentId,
            spaceKey: // @ts-ignore FIXME: `spaceKey` can be `undefined` here, and needs proper handling
            spaceKey,
            pageContextContentId: pageContextContentId,
            cloudId: cloudId,
            userId: userId,
            flags: flags,
            featureFlags: featureFlags,
            push: push,
            intl: intl,
            providerFactory: dataProviders,
            profilecardProvider: profilecardProvider,
            isExternalShare: isExternalShareRequest,
            handleActionToggle: handleActionToggle,
            hasViewUserProfilePermission: hasViewUserProfilePermission,
            handleInviteItemClick: openCoreInvites,
            userRole: userRole,
            mediaToken: mediaToken,
            emojiResourceParams: emojiResourceParams
        }), [
        contentId,
        spaceKey,
        pageContextContentId,
        cloudId,
        userId,
        flags,
        featureFlags,
        push,
        intl,
        dataProviders,
        profilecardProvider,
        isExternalShareRequest,
        handleActionToggle,
        hasViewUserProfilePermission,
        openCoreInvites,
        userRole,
        mediaToken,
        emojiResourceParams
    ]);
    const SyncedBlockNodeComponent = (0, $9Eka4.useMemoizedSyncedBlockProviderNodeComponent)({
        doc: document,
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: contentType,
        mergedDataProviderDefinitions: mergedDataProviders.providers,
        // Pass the same sticky header config as the page so tables in synced blocks use
        // the same scroll root (e.g. AkMainContent) and offset — required for sticky to work.
        stickyHeadersConfig: stickyHeaders ?? undefined,
        contentMode: contentMode
    });
    const nodeComponents = (0, $42omo.useMemo)(()=>{
        if (SyncedBlockNodeComponent) return {
            syncBlock: SyncedBlockNodeComponent
        };
    }, [
        SyncedBlockNodeComponent
    ]);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // Store the finalDocument ADF in context so it can be accessed by comment editor
    // and other components (e.g. SmartlinkAuthNudge) without prop threading.
    const { setPageAdf: setPageAdf } = (0, $8WQTF.useRendererActionsDispatch)();
    (0, $42omo.useEffect)(()=>{
        if (appearance === 'full-page' || appearance === 'full-width' || appearance === 'max') {
            if (document) {
                const finalDocument = shimAdfUrls(document);
                setPageAdf(finalDocument);
            } else setPageAdf(undefined);
        }
    }, [
        appearance,
        document,
        setPageAdf,
        shimAdfUrls
    ]);
    if (!document) return null;
    const finalDocument = shimAdfUrls(document);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1SPMi.RendererAnalyticsListener), {
        // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
        objectId: contentId,
        objectType: contentType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67O0h.RendererWithAnalytics), {
        // This flag is used for fixing table width in SSR mode and for hydration
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        enableSsrInlineScripts: Boolean(undefined),
        // include renderer inline script from above on first render to prevent hydration mismatch
        noOpSSRInlineScript: renderServerPlaceholder,
        timeZone: timeZone || tenantTimeZone || undefined,
        adfStage: adfStage,
        document: finalDocument,
        appearance: appearance,
        contentMode: contentMode,
        stickyHeaders: stickyHeaders,
        extensionHandlers: mergedExtensionHandlers,
        eventHandlers: eventHandlers,
        featureFlags: editorFeatureFlags,
        dataProviders: mergedDataProviders.providerFactory,
        portal: portal,
        allowColumnSorting: true,
        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
        allowAltTextOnImages: true,
        media: media,
        emojiResourceConfig: emojiResourceConfig,
        allowCopyToClipboard: true,
        allowWrapCodeBlock: true,
        ...rest,
        useSpecBasedValidator: true,
        truncated: isTruncatedContent,
        maxHeight: maxHeight,
        fadeOutHeight: fadeOutHeight,
        analyticsEventSeverityTracking: $1af8a83cb114ff50$export$3422b9c70e187e34,
        unsupportedContentLevelsTracking: $1af8a83cb114ff50$export$58eac04eb6213951(),
        allowPlaceholderText: allowPlaceholderText,
        allowCustomPanels: true,
        smartLinks: smartLinks,
        extensionViewportSizes: extensionViewportSizes,
        onError: errorHandler,
        UNSTABLE_allowTableAlignment: UNSTABLE_allowTableAlignment,
        UNSTABLE_allowTableResizing: UNSTABLE_allowTableResizing,
        UNSTABLE_isPresentational: UNSTABLE_isPresentational,
        allowRendererContainerStyles: allowRendererContainerStyles,
        shouldDisplayExtensionAsInline: (0, $hMB4W.shouldDisplayExtensionAsInline),
        allowFixedColumnWidthOption: (0, $dh538.fg)('platform_editor_table_fixed_column_width_prop') ? appearance === 'full-page' || appearance === 'full-width' : undefined,
        ...nodeComponents && {
            nodeComponents: nodeComponents
        }
    }), renderWhenReady && renderWhenReady()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fgQGl.ContentRefetchHandler), (0, $gCz4s.getContentRefetchHandlerProps)({
        contentId: contentId,
        shouldRefetch: shouldRefetchContent,
        updateShouldRefetchContent: ({ shouldRefetchContent: nextShouldRefetchContent })=>setShouldRefetchContent(nextShouldRefetchContent)
    })), pageMode && pageMode === (0, $cD1qu.PageMode).VIEW && !isEmbedded && (0, $6mKj3.expValEquals)('cc_smart_link_nudge_kill_switch', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5523d8b8240ba692$export$cde76c461119a84c), {
        contentId: contentId,
        contentType: contentType,
        isLivePage: isLivePage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
        feedConfigError: feedFollowData.feedConfigError,
        mutationError: feedFollowData.mutationError,
        showErrorFlag: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bb91119414a4e358$export$d8ebe500960648d), {
        document: document,
        flags: flags
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $05271241466f5e2e$export$b8cbd42b7b7bd9d2), {
        contentId: contentId,
        contentType: contentType,
        isViewPage: pageMode === (0, $cD1qu.PageMode).VIEW,
        spaceKey: spaceKey
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
        ...(0, $kLzei.getSmartCardRenderers)(),
        ...storeOptions,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        shouldControlDataExport: shouldControlDataExport,
        product: "CONFLUENCE"
    }, content);
});
module.exports["ANALYTICS_EVENT_SEVERITY_TRACKING"] = $1af8a83cb114ff50$export$3422b9c70e187e34;
module.exports["UNSUPPORTED_CONTENT_THRESHOLDS"] = $1af8a83cb114ff50$export$c02e908ea3c1fe52;
module.exports["ADFRendererComponent"] = $1af8a83cb114ff50$export$cec675c14d32c246;

});

parcelRegister("fgQGl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $83Z6R = parcelRequire("83Z6R");


var $f9opb = parcelRequire("f9opb");

var $jgc4t = parcelRequire("jgc4t");


var $cLo2u = parcelRequire("cLo2u");


var $dPJCf = parcelRequire("dPJCf");


var $ep3mz = parcelRequire("ep3mz");

const $96596a053dd4ef1e$export$d1bbac313eb9a2c1 = ({ contentId: contentId, shouldRefetch: shouldRefetch, refetchImmediately: refetchImmediately, onRefetchComplete: onRefetchComplete })=>{
    const history = (0, $dPJCf.useHistory)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(window.__SSR_RENDERED__);
    const chooseContentUnifiedQuery = contentType === 'blogpost' ? (0, $f9opb.default) : (0, $jgc4t.default);
    const executeQuery = (0, $83Z6R.useLazyQueryPromiseInterop)(chooseContentUnifiedQuery, {
        fetchPolicy: 'network-only'
    });
    // Store onRefetchComplete in a ref so the effect can always call the latest
    // version without needing it in the dependency array. This prevents callers
    // that pass an unstable function reference from causing an infinite refetch
    // loop when refetchImmediately is true.
    const onRefetchCompleteRef = (0, $42omo.useRef)(onRefetchComplete);
    onRefetchCompleteRef.current = onRefetchComplete;
    (0, $42omo.useEffect)(()=>{
        let unlisten;
        if (shouldRefetch && contentId) {
            const queryVariable = {
                contentId: contentId,
                spaceKey: spaceKey,
                isSSR: isSSR,
                useNewContentTopper: true
            };
            const refetchFn = async ()=>{
                let versionNumber;
                try {
                    const queryResult = await executeQuery({
                        context: {
                            single: true
                        },
                        variables: queryVariable
                    });
                    versionNumber = queryResult.content?.nodes?.[0]?.version?.number;
                } catch  {
                // NOTE: We intentionally swallow any possible error here as this query is only aimed to
                // populate the cache with just published content. Should any error occur here after
                // successful publishing the page, the Apollo cache for the query will be invalidated
                // anyway and View Page will fetch the page and handle possible errors.
                }
                // If a callback is supplied, call it regardless
                onRefetchCompleteRef.current && onRefetchCompleteRef.current(versionNumber);
            };
            if (refetchImmediately) refetchFn();
            else unlisten = history?.listen(refetchFn);
        }
        return ()=>{
            // Call the unlistener when this component unmounts
            unlisten && unlisten();
        };
    }, [
        shouldRefetch,
        executeQuery,
        contentId,
        spaceKey,
        isSSR,
        history,
        refetchImmediately
    ]);
    return null;
};
module.exports["ContentRefetchHandler"] = $96596a053dd4ef1e$export$d1bbac313eb9a2c1;

});

parcelRegister("gCz4s", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

const $b976f8b9685674e3$var$shouldNotRefetchContentState = {
    shouldRefetchContent: false
};
const $b976f8b9685674e3$export$b6dd3fd91f4d9979 = ({ contentId: contentId, shouldRefetch: shouldRefetch, updateShouldRefetchContent: updateShouldRefetchContent, updateShouldRefetchContentContext: updateShouldRefetchContentContext })=>{
    const contentRefetchHandlerProps = {
        contentId: contentId,
        shouldRefetch: shouldRefetch
    };
    if ((0, $6mKj3.expVal)('task_cache_invalidation_fix', 'isEnabled', false)) return {
        ...contentRefetchHandlerProps,
        refetchImmediately: true,
        onRefetchComplete: ()=>updateShouldRefetchContent.call(updateShouldRefetchContentContext, $b976f8b9685674e3$var$shouldNotRefetchContentState)
    };
    return contentRefetchHandlerProps;
};
module.exports["getContentRefetchHandlerProps"] = $b976f8b9685674e3$export$b6dd3fd91f4d9979;

});

parcelRegister("cNwLI", function(module, exports) {
const $b692efbc19ac9594$export$81e5b59a1e176638 = 'com.atlassian.confluence.link-cards';
const $b692efbc19ac9594$export$df3c2062a081a534 = 'com.atlassian.confluence.spotlight';
const $b692efbc19ac9594$export$4454075c4322ae47 = 'com.atlassian.confluence.hub-section';
const $b692efbc19ac9594$export$2dd5fc71941a6787 = 'com.atlassian.confluence.knowledge-cards';
const $b692efbc19ac9594$export$9fdf64a495514b4 = 'com.atlassian.confluence.links-menu';
const $b692efbc19ac9594$export$514105ca7c79025d = 'com.atlassian.confluence.carousel';
const $b692efbc19ac9594$export$cb2d1b0c753e69e6 = 'com.atlassian.confluence.company-hub-search';
const $b692efbc19ac9594$export$c14e692c91462ed4 = 'com.atlassian.confluence.hub-element-placeholder';
const $b692efbc19ac9594$export$8e1a1e8b8109dbf3 = '#DDDEE1';
const $b692efbc19ac9594$export$8161b1f4e2928fa0 = '--hub-primary-color';
const $b692efbc19ac9594$export$94d2a2331edd895d = '--hub-primary-text-color';
const $b692efbc19ac9594$export$64de52c9db8240f6 = '--hub-primary-link-color';
const $b692efbc19ac9594$export$4c91e7265b76e3a1 = '32px';
const $b692efbc19ac9594$export$d713f99e5e84a256 = '40px'; // Pre-standardization height for CSM fallback
const $b692efbc19ac9594$export$6faa4a850bc4d0ce = 'https://db7d48b351f4e353b021f65a7a8d6928@o55978.ingest.us.sentry.io/4509310829920256';
const $b692efbc19ac9594$export$ea77880e3935182d = 'unknown';
const $b692efbc19ac9594$export$c7f012c6e67c4217 = 0;
module.exports["CARDS_EXTENSION_TYPE"] = $b692efbc19ac9594$export$81e5b59a1e176638;
module.exports["SPOTLIGHT_EXTENSION_TYPE"] = $b692efbc19ac9594$export$df3c2062a081a534;
module.exports["SECTION_EXTENSION_TYPE"] = $b692efbc19ac9594$export$4454075c4322ae47;
module.exports["RESOURCE_TILES_EXTENSION_TYPE"] = $b692efbc19ac9594$export$2dd5fc71941a6787;
module.exports["LINKS_MENU_EXTENSION_TYPE"] = $b692efbc19ac9594$export$9fdf64a495514b4;
module.exports["CAROUSEL_EXTENSION_TYPE"] = $b692efbc19ac9594$export$514105ca7c79025d;
module.exports["SEARCH_EXTENSION_TYPE"] = $b692efbc19ac9594$export$cb2d1b0c753e69e6;
module.exports["HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE"] = $b692efbc19ac9594$export$c14e692c91462ed4;
module.exports["HUB_PRIMARY_COLOR_CSS_VAR"] = $b692efbc19ac9594$export$8161b1f4e2928fa0;
module.exports["HUB_PRIMARY_TEXT_COLOR_CSS_VAR"] = $b692efbc19ac9594$export$94d2a2331edd895d;
module.exports["HUB_PRIMARY_LINK_COLOR_CSS_VAR"] = $b692efbc19ac9594$export$64de52c9db8240f6;
module.exports["HUB_LOGO_HEIGHT"] = $b692efbc19ac9594$export$4c91e7265b76e3a1;
module.exports["HUB_LOGO_HEIGHT_LEGACY"] = $b692efbc19ac9594$export$d713f99e5e84a256;

});

parcelRegister("kcoxM", function(module, exports) {
const $b61d5307562de512$export$81e5b59a1e176638 = 'com.atlassian.confluence.link-cards';
const $b61d5307562de512$export$8a4891a61ff91b00 = 'cards';
const $b61d5307562de512$export$67bfcae6d68bb0bf = 'cardsExtension';
const $b61d5307562de512$export$7f17fab0aecb44ed = 'cardsExtensionConfig';
const $b61d5307562de512$export$6a35a50674becbae = 'cardsExtensionConfigBackgroundColor';
const $b61d5307562de512$export$9bf56665bf6ea6ed = 'cardsExtensionConfigBorderColor';
const $b61d5307562de512$export$cf23b6d2fd159502 = 'cardsExtensionConfigTextColor';
const $b61d5307562de512$export$131b76b4d30d2b44 = '2';
const $b61d5307562de512$export$a08b7507bedba276 = '3';
const $b61d5307562de512$export$c87753a8bb0c4e75 = '4';
const $b61d5307562de512$export$b84f9a7c097c895c = '5';
const $b61d5307562de512$export$5e905747d7497a1f = [
    {
        src: 'https://images.unsplash.com/photo-1571327352610-1c5484ccc840?auto=format&fit=crop&q=80&w=450',
        alt: 'closed wooden window'
    },
    {
        src: 'https://images.unsplash.com/photo-1566486106118-e1c24ad08802?auto=format&fit=crop&q=80&w=450',
        alt: 'green coconut trees'
    },
    {
        src: 'https://images.unsplash.com/photo-1602021224139-a6ba7e601732?auto=format&fit=crop&q=80&w=450',
        alt: 'white and black striped chair'
    },
    {
        src: 'https://images.unsplash.com/photo-1722259038071-6082eaf397ff?auto=format&fit=crop&q=80&w=450',
        alt: 'surfboard on top of a cement wall'
    },
    {
        src: 'https://images.unsplash.com/photo-1555001356-333dbc0f8b48?auto=format&fit=crop&q=80&w=450',
        alt: 'white stairs'
    },
    {
        src: 'https://images.unsplash.com/photo-1680258551363-6b5fd1ac2048?auto=format&fit=crop&q=80&w=450',
        alt: 'swimming pool tiles'
    }
];
module.exports["CARDS_EXTENSION_TYPE"] = $b61d5307562de512$export$81e5b59a1e176638;
module.exports["CARDS_EXTENSION_KEY"] = $b61d5307562de512$export$8a4891a61ff91b00;
module.exports["CARDS_EXTENSION_ANALYTIC_SOURCE"] = $b61d5307562de512$export$67bfcae6d68bb0bf;
module.exports["CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE"] = $b61d5307562de512$export$7f17fab0aecb44ed;
module.exports["CARDS_EXTENSION_CONFIG_BACKGROUND_ANALYTIC_SOURCE"] = $b61d5307562de512$export$6a35a50674becbae;
module.exports["CARDS_EXTENSION_CONFIG_BORDER_ANALYTIC_SOURCE"] = $b61d5307562de512$export$9bf56665bf6ea6ed;
module.exports["CARDS_EXTENSION_CONFIG_TEXT_ANALYTIC_SOURCE"] = $b61d5307562de512$export$cf23b6d2fd159502;
module.exports["CARDS_EXTENSION_VERSION_5"] = $b61d5307562de512$export$b84f9a7c097c895c;
module.exports["CARDS_IMAGES_V5"] = $b61d5307562de512$export$5e905747d7497a1f;

});

parcelRegister("lf1vG", function(module, exports) {
const $5c1067f237374bc4$export$e03f5e560317f88a = '1';
const $5c1067f237374bc4$export$5e16975fb5214c6c = 'company-hub-search';
const $5c1067f237374bc4$export$cb2d1b0c753e69e6 = 'com.atlassian.confluence.company-hub-search';
const $5c1067f237374bc4$export$ec7b7d5be35b7dd3 = 'customSearchExtension';
module.exports["SEARCH_EXTENSION_VERSION_1"] = $5c1067f237374bc4$export$e03f5e560317f88a;
module.exports["SEARCH_EXTENSION_KEY"] = $5c1067f237374bc4$export$5e16975fb5214c6c;
module.exports["SEARCH_EXTENSION_TYPE"] = $5c1067f237374bc4$export$cb2d1b0c753e69e6;
module.exports["CUSTOM_SEARCH_EXTENSION_ANALYTIC_SOURCE"] = $5c1067f237374bc4$export$ec7b7d5be35b7dd3;

});

parcelRegister("cVaAA", function(module, exports) {
const $8fff034c75eb58ab$export$9fdf64a495514b4 = 'com.atlassian.confluence.links-menu';
const $8fff034c75eb58ab$export$ed5854f17099adbf = 'linksMenuExtension';
module.exports["LINKS_MENU_EXTENSION_TYPE"] = $8fff034c75eb58ab$export$9fdf64a495514b4;
module.exports["LINKS_MENU_EXTENSION_ANALYTIC_SOURCE"] = $8fff034c75eb58ab$export$ed5854f17099adbf;

});

parcelRegister("5Ac5G", function(module, exports) {
const $df94cb31de3cc11e$export$a06ac4f1777262dc = 'com.atlassian.confluence.carousel';
const $df94cb31de3cc11e$export$6c8179fa243b4399 = 'carousel';
const $df94cb31de3cc11e$export$ca14f22a239c4ae9 = 'carouselExtension';
const $df94cb31de3cc11e$export$4cb671946a80c52e = 'carouselExtensionConfig';
const $df94cb31de3cc11e$export$93995a2609cff38d = 8;
const $df94cb31de3cc11e$export$3a86d0fc7eb402f4 = 'carousel-navigation-frame-';
const $df94cb31de3cc11e$export$9575b4f5d97a1c29 = '1';
const $df94cb31de3cc11e$export$b429752dfe934bea = '2';
const $df94cb31de3cc11e$export$c5c6e75ceae0cc22 = 10;
module.exports["carouselExtensionType"] = $df94cb31de3cc11e$export$a06ac4f1777262dc;
module.exports["carouselExtensionKey"] = $df94cb31de3cc11e$export$6c8179fa243b4399;
module.exports["carouselContentAnalyticSource"] = $df94cb31de3cc11e$export$ca14f22a239c4ae9;
module.exports["carouselConfigAnalyticSource"] = $df94cb31de3cc11e$export$4cb671946a80c52e;
module.exports["AUTOPLAY_SECONDS"] = $df94cb31de3cc11e$export$93995a2609cff38d;
module.exports["ARIA_CONTROLS_PREFIX"] = $df94cb31de3cc11e$export$3a86d0fc7eb402f4;
module.exports["CAROUSEL_VERSION_2"] = $df94cb31de3cc11e$export$b429752dfe934bea;
module.exports["FRAMES_LIMIT_V2"] = $df94cb31de3cc11e$export$c5c6e75ceae0cc22;

});

parcelRegister("bl1ay", function(module, exports) {
const $41fb1ea7d1d28d85$export$c14e692c91462ed4 = 'com.atlassian.confluence.hub-element-placeholder';
const $41fb1ea7d1d28d85$export$ca3a94184e0fbd97 = 'hub-element-placeholder';
module.exports["HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE"] = $41fb1ea7d1d28d85$export$c14e692c91462ed4;
module.exports["HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY"] = $41fb1ea7d1d28d85$export$ca3a94184e0fbd97;

});

parcelRegister("cbvYp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fOKpq = parcelRequire("fOKpq");


var $4IoVL = parcelRequire("4IoVL");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $1NBp8 = parcelRequire("1NBp8");


var $6M71K = parcelRequire("6M71K");


var $5kjCz = parcelRequire("5kjCz");


var $hUS75 = parcelRequire("hUS75");


var $4KFTW = parcelRequire("4KFTW");


var $bX5uj = parcelRequire("bX5uj");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $6mKj3 = parcelRequire("6mKj3");


var $aJPUt = parcelRequire("aJPUt");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $lOeVN = parcelRequire("lOeVN");


var $bAIqi = parcelRequire("bAIqi");


var $bflGB = parcelRequire("bflGB");



var $hl1Kw = parcelRequire("hl1Kw");


var $cEgMD = parcelRequire("cEgMD");


var $78QFu = parcelRequire("78QFu");


var $ep3mz = parcelRequire("ep3mz");


var $2YtTU = parcelRequire("2YtTU");





var $inPa6 = parcelRequire("inPa6");


var $k00oi = parcelRequire("k00oi");


var $5Gcps = parcelRequire("5Gcps");





var $7QM6o = parcelRequire("7QM6o");










const $4305591bcf0ed0e4$export$bd1b893a71ee8dab = (link)=>{
    const [analyticFields, setAnalyticFields] = (0, $42omo.useState)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const fetchData = async ()=>{
            const client = new (0, $k00oi.default)();
            try {
                const queriedMetadata = !!link && await client.fetchData(link);
                if (!queriedMetadata || !queriedMetadata.meta) return;
                const { containerId: initialContainerId, tenantId: initialTenantId, objectId: initialObjectId } = queriedMetadata.meta || {};
                if (!initialObjectId) return;
                const newObjectId = await (0, $5Gcps.getClickAndViewEventObjectIdFromLinkData)(initialObjectId, initialContainerId);
                setAnalyticFields({
                    containerId: initialContainerId,
                    tenantId: initialTenantId,
                    objectId: newObjectId
                });
            } catch (error) {
                (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).PERFORMANCE_INSIGHTS
                });
                (0, $7Sm4c.markErrorAsHandled)(error);
            }
        };
        fetchData();
    }, [
        link
    ]);
    const { tenantId: tenantId, objectId: objectId } = analyticFields || {};
    const handleClick = ()=>{
        if (tenantId === cloudId) createAnalyticsEvent?.((0, $5Gcps.generateClickEventPayload)(activationId, cloudId, objectId, spaceId)).fire();
    };
    const handleView = ()=>{
        if (tenantId === cloudId) createAnalyticsEvent?.((0, $5Gcps.generateViewEventPayload)(activationId, cloudId, objectId, spaceId)).fire();
    };
    return {
        handleClick: analyticFields ? handleClick : undefined,
        handleView: analyticFields ? handleView : undefined
    };
};



var $biMIt = parcelRequire("biMIt");

/**
 * @generated SignedSource<<5d9f0f9b4d004db5c39c281d1073c821>>
 * @relayHash aea879681eafb8d8dc2e8d788d24714d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ac8d9edb75319a93ed7a159d48491fc0f2f009e88d49acb7b2f4c6dd571ae406
const $53bd2fb7fcb3ebe9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "defaultValue": 25,
            "kind": "LocalArgument",
            "name": "first"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "after"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                }
            ],
            "concreteType": "PaginatedGroupList",
            "kind": "LinkedField",
            "name": "groups",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Group",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                },
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSegmentationTargetGroupsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSegmentationTargetGroupsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "aea879681eafb8d8dc2e8d788d24714d",
            "id": "ac8d9edb75319a93ed7a159d48491fc0f2f009e88d49acb7b2f4c6dd571ae406",
            "metadata": {},
            "name": "useSegmentationTargetGroupsQuery",
            "operationKind": "query",
            "text": "query useSegmentationTargetGroupsQuery($after:String,$first:Int=25){groups(after:$after,first:$first){nodes{id,name},pageInfo{endCursor,hasNextPage}}}"
        }
    };
}();
$53bd2fb7fcb3ebe9$var$node.hash = "b1d866007d469142c79544536019c0ef";
var $53bd2fb7fcb3ebe9$export$2e2bcd8739ae039 = $53bd2fb7fcb3ebe9$var$node;









var $1uFM6 = parcelRequire("1uFM6");





var $jMyy4 = parcelRequire("jMyy4");

const $a453bfc5db2076e7$export$df3f3e4ed2d81d7 = ({ nextCursor: nextCursor, initialGroupIds: initialGroupIds })=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $53bd2fb7fcb3ebe9$export$2e2bcd8739ae039), {
        variables: {
            after: nextCursor
        },
        skip: initialGroupIds.length === 0,
        __callerPackage__: "@confluence/custom-sites-extensions"
    });
    let errorComponent = undefined;
    if (error && !loading) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        else errorComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
    }
    return {
        data: data,
        loading: loading,
        errorComponent: errorComponent
    };
};


const $73ff39965b133879$var$useFeedbackCollectorWrapper = ({ source: source, type: type })=>{
    return (0, $lOeVN.useFeedbackCollector)({
        source: source,
        type: type
    });
};
const $73ff39965b133879$var$useSegmentationTargetGroupsWrapper = ({ nextCursor: nextCursor, initialGroupIds: initialGroupIds = [] })=>{
    return (0, $a453bfc5db2076e7$export$df3f3e4ed2d81d7)({
        nextCursor: nextCursor,
        initialGroupIds: initialGroupIds
    });
};
const $73ff39965b133879$var$ShortcutListenerWrapper = ({ accelerator: accelerator, listener: listener })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bflGB.ShortcutListener), {
        accelerator: accelerator,
        listener: listener
    });
};
const $73ff39965b133879$var$ExtensionConfigUpsellLoaderWrapper = ({ feature: feature })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bAIqi.ExtensionConfigUpsellLoader), {
        feature: feature
    });
};
const $73ff39965b133879$var$submitError = (error)=>{
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
};
const $73ff39965b133879$var$SmartCardProvider = ({ children: children })=>{
    return(// disable preview panel functionality for cards
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
        isPreviewPanelAvailable: (_ari)=>false
    }, children));
};
const $73ff39965b133879$export$ae511a2e03f02bcc = ({ contentId: contentId, fileId: fileId })=>{
    // When experiment is enabled, store in format: {contentId}/{fileId}
    // This allows us to track which page the image was originally uploaded to
    // When copy-pasting to another page, useMediaConfig will extract the original contentId
    // Check if the fileId already contains the contentId prefix (e.g., from linked page header)
    // If it already has a "/", it's in format {contentId}/{fileId} and we don't add another prefix
    if ((0, $6mKj3.expValEquals)('ccpi_broken_upload_images_for_confluence', 'isEnabled', true)) return fileId.includes('/') ? fileId : `${contentId}/${fileId}`;
    return fileId;
};
const $73ff39965b133879$export$52286abe2bf4f236 = ()=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const start = (0, $42omo.useCallback)(({ analyticsSource: analyticsSource })=>{
        experienceTracker.start({
            name: (0, $irVI7.CARDS_IMAGE_UPLOAD_EXPERIENCE),
            attributes: {
                source: analyticsSource
            }
        });
    }, [
        experienceTracker
    ]);
    const succeed = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.CARDS_IMAGE_UPLOAD_EXPERIENCE)
        });
    }, [
        experienceTracker
    ]);
    const stopOnError = (0, $42omo.useCallback)(({ error: error })=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.CARDS_IMAGE_UPLOAD_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    return {
        start: start,
        succeed: succeed,
        stopOnError: stopOnError
    };
};
const $73ff39965b133879$export$50a2d523eb80eb6f = ()=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const start = (0, $42omo.useCallback)(({ analyticsSource: analyticsSource, confluencePageId: confluencePageId })=>{
        experienceTracker.start({
            name: (0, $irVI7.COMPANY_HUB_CARD_AI_DESCRIPTION_EXPERIENCE),
            attributes: {
                source: analyticsSource,
                contentId: confluencePageId
            }
        });
    }, [
        experienceTracker
    ]);
    const abort = (0, $42omo.useCallback)(({ reason: reason })=>{
        experienceTracker.abort({
            name: (0, $irVI7.COMPANY_HUB_CARD_AI_DESCRIPTION_EXPERIENCE),
            reason: reason
        });
    }, [
        experienceTracker
    ]);
    const succeed = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.COMPANY_HUB_CARD_AI_DESCRIPTION_EXPERIENCE)
        });
    }, [
        experienceTracker
    ]);
    const stopOnError = (0, $42omo.useCallback)(({ error: error })=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.COMPANY_HUB_CARD_AI_DESCRIPTION_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    return {
        start: start,
        abort: abort,
        succeed: succeed,
        stopOnError: stopOnError
    };
};
const $73ff39965b133879$export$4bd687f80e42155a = (activeContentId, maybeCustomCoverImage)=>{
    if (maybeCustomCoverImage.indexOf('/') !== -1) {
        const temp = maybeCustomCoverImage.split('/');
        return [
            temp[0],
            temp[1]
        ];
    }
    // If it's not a stored cover image, we return original contentId & imageSrc
    return [
        activeContentId,
        maybeCustomCoverImage
    ];
};
const $73ff39965b133879$export$7f746b47c356effa = ({ contentId: contentId, imageSrc: imageSrc })=>{
    const [mediaConfig, setMediaConfig] = (0, $42omo.useState)(null);
    // When imageSrc is a stored cover image, it comes in format '{contentId}/{fileId}'
    // We need to split the string to get the collectionId and fileId
    const [collectionId, fileId] = $73ff39965b133879$export$4bd687f80e42155a(contentId, imageSrc);
    (0, $42omo.useEffect)(()=>{
        async function createMediaConfig() {
            if (!(0, $4IoVL.createRendererMediaProvider)) return;
            const { viewMediaClientConfig: viewMediaClientConfig } = await (0, $4IoVL.createRendererMediaProvider)({
                contentId: collectionId,
                isExternalShare: false
            });
            if (!viewMediaClientConfig) {
                setMediaConfig(null);
                return;
            }
            setMediaConfig({
                collection: `contentId-${collectionId}`,
                authProvider: viewMediaClientConfig.authProvider,
                fileId: fileId
            });
        }
        createMediaConfig();
    }, [
        collectionId,
        fileId
    ]);
    return mediaConfig;
};
const $73ff39965b133879$export$9a7b37d3055a69a6 = ({ mode: mode, extensionNode: extensionNode, contentId: contentId = '', children: children })=>{
    const mediaUploadExperienceTracker = $73ff39965b133879$export$52286abe2bf4f236();
    const aiDescriptionExperienceTracker = $73ff39965b133879$export$50a2d523eb80eb6f();
    const sessionData = (0, $bQm3c.useSessionData)();
    const { cloudId: cloudId, displayName: displayName, isAdminHubAIEnabled: isAdminHubAIEnabled, orgId: orgId, userId: userId } = sessionData || {};
    const [{ searchSessionId: searchSessionId }] = (0, $hl1Kw.useSearchSessionId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isTargetAudience: isTargetAudience } = (0, $42omo.useContext)((0, $biMIt.AudienceSegmentationContext));
    const shouldShowPremiumUpsell = (0, $2YtTU.usePremiumGate)();
    const ConfigUpsellScreen = (0, $42omo.useMemo)(()=>shouldShowPremiumUpsell ? ({ feature: feature })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($73ff39965b133879$var$ExtensionConfigUpsellLoaderWrapper, {
                feature: feature
            }) : undefined, [
        shouldShowPremiumUpsell
    ]);
    const experienceStartComponent = (0, $42omo.useCallback)(()=>{
        if (!extensionNode) return null;
        const macroAttributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extensionNode);
        const experienceName = (0, $5kjCz.getExperienceName)(mode, extensionNode);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: experienceName,
            attributes: macroAttributes,
            extensionKey: extensionNode.extensionKey,
            contentId: contentId,
            mode: mode,
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
        });
    }, [
        extensionNode,
        contentId,
        mode
    ]);
    const experienceSuccessComponent = (0, $42omo.useCallback)(()=>{
        if (!extensionNode) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bX5uj.MacroExperienceSuccess), {
            name: (0, $5kjCz.getExperienceName)(mode, extensionNode),
            contentId: contentId,
            extensionKey: extensionNode.extensionKey,
            mode: mode,
            attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(extensionNode)
        });
    }, [
        extensionNode,
        contentId,
        mode
    ]);
    const experienceStopComponent = (0, $42omo.useCallback)(({ error: error })=>{
        if (!extensionNode) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hUS75.MacroExperienceStop), {
            error: error,
            name: (0, $5kjCz.getExperienceName)(mode, extensionNode),
            contentId: contentId,
            extensionKey: extensionNode.extensionKey,
            mode: mode,
            attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(extensionNode)
        });
    }, [
        mode,
        extensionNode,
        contentId
    ]);
    const isSSRProductInDarkMode = (0, $42omo.useMemo)(()=>{
        return undefined;
    }, []);
    const errorBoundaryComponent = (0, $42omo.useMemo)(()=>({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
            }, children), []);
    const errorDisplayComponent = (0, $42omo.useMemo)(()=>({ error: error, childrenComponents: childrenComponents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            }, childrenComponents), []);
    const useAnalyticsActions = (0, $42omo.useMemo)(()=>({
            useLinkAnalyticActions: $4305591bcf0ed0e4$export$bd1b893a71ee8dab
        }), []);
    const value = (0, $42omo.useMemo)(()=>({
            experienceStartComponent: experienceStartComponent,
            experienceSuccessComponent: experienceSuccessComponent,
            experienceStopComponent: experienceStopComponent,
            cloudId: cloudId,
            searchConfigProvider: {
                peopleDirectoryUrl: (0, $1NBp8.PEOPLE_DIRECTORY).toUrl(),
                advancedSearchUrl: (0, $1NBp8.ADVANCED_SEARCH).toUrl(),
                searchSessionId: searchSessionId || ''
            },
            displayName: displayName || '',
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            orgId: orgId || '',
            userId: userId || '',
            errorBoundaryComponent: errorBoundaryComponent,
            errorDisplayComponent: errorDisplayComponent,
            submitError: $73ff39965b133879$var$submitError,
            markErrorAsHandled: $7Sm4c.markErrorAsHandled,
            useMediaConfig: $73ff39965b133879$export$7f746b47c356effa,
            createEditorMediaProvider: $4IoVL.createEditorMediaProvider,
            mediaUploadExperienceTracker: mediaUploadExperienceTracker,
            transformUploadedImageId: $73ff39965b133879$export$ae511a2e03f02bcc,
            aiDescriptionExperienceTracker: aiDescriptionExperienceTracker,
            useFeedbackCollector: $73ff39965b133879$var$useFeedbackCollectorWrapper,
            shortcutListener: $73ff39965b133879$var$ShortcutListenerWrapper,
            shouldShowPremiumUpsell: shouldShowPremiumUpsell,
            ConfigUpsellScreen: ConfigUpsellScreen,
            useSegmentationTargetGroups: $73ff39965b133879$var$useSegmentationTargetGroupsWrapper,
            isSSRProductInDarkMode: isSSRProductInDarkMode,
            analyticsContext: {
                pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
            },
            useAnalyticsActions: useAnalyticsActions,
            isCompanyHub: (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey),
            isTargetAudience: isTargetAudience,
            smartCardProviderComponent: $73ff39965b133879$var$SmartCardProvider,
            showConfigPreambleSupportLink: true,
            enableTargeting: true,
            enableUnifiedSearchFeatures: true,
            enableSmartCardsFields: true
        }), [
        experienceSuccessComponent,
        experienceStopComponent,
        cloudId,
        displayName,
        isAdminHubAIEnabled,
        orgId,
        userId,
        searchSessionId,
        shouldShowPremiumUpsell,
        ConfigUpsellScreen,
        isSSRProductInDarkMode,
        errorBoundaryComponent,
        errorDisplayComponent,
        experienceStartComponent,
        mediaUploadExperienceTracker,
        aiDescriptionExperienceTracker,
        useAnalyticsActions,
        spaceKey,
        isTargetAudience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fOKpq.ProductDependenciesContext).Provider, {
        value: value
    }, children);
};
const $73ff39965b133879$export$443fd6903ad182a1 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($73ff39965b133879$export$9a7b37d3055a69a6, props, children);
module.exports["ConfluenceDependenciesProvider"] = $73ff39965b133879$export$443fd6903ad182a1;

});

parcelRegister("bAIqi", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c1c72132c26b9ae6$export$349c99e57ed161b9 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "at4mJ",
    name: "ExtensionConfigUpsellLoader",
    loader: async ()=>(await (parcelRequire("k8sAT"))).ExtensionConfigUpsell
});

const $c1c72132c26b9ae6$export$25389a114c9b393f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "rxN2C",
    name: "ExtensionInsertUpsellLoader",
    loader: async ()=>(await (parcelRequire("6Dc9Z"))).ExtensionInsertUpsell
});
module.exports["ExtensionConfigUpsellLoader"] = $c1c72132c26b9ae6$export$349c99e57ed161b9;
module.exports["ExtensionInsertUpsellLoader"] = $c1c72132c26b9ae6$export$25389a114c9b393f;

});

parcelRegister("k8sAT", function(module, exports) {

let $ea8abc292efe7e50$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ea8abc292efe7e50$var$load("hOaAV"),
    $ea8abc292efe7e50$var$load("cEqm7"),
    $ea8abc292efe7e50$var$load("6XCf4"),
    $ea8abc292efe7e50$var$load("1qlDN"),
    $ea8abc292efe7e50$var$load("1yVM6"),
    $ea8abc292efe7e50$var$load("5pvpJ"),
    $ea8abc292efe7e50$var$load("9wTrW")
]).then(()=>parcelRequire('d1uaq'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("6Dc9Z", function(module, exports) {

let $4d3fd156dab3c133$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4d3fd156dab3c133$var$load("hOaAV"),
    $4d3fd156dab3c133$var$load("cEqm7"),
    $4d3fd156dab3c133$var$load("6XCf4"),
    $4d3fd156dab3c133$var$load("1qlDN"),
    $4d3fd156dab3c133$var$load("1yVM6"),
    $4d3fd156dab3c133$var$load("5pvpJ"),
    $4d3fd156dab3c133$var$load("5HTv6")
]).then(()=>parcelRequire('f4NfX'));

});

parcelRegister("2YtTU", function(module, exports) {
/**
 * @generated SignedSource<<8bb9bdb80921f64e532e9a0a860836ba>>
 * @relayHash b3b58abba516a7066e43fee230bb62d7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dd5ecfcc11044bcdaad98bea20a111b89a5005066669b87b37b1b8d5ea4e1ca6
const $ce65a234c274b394$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "PremiumExtensionsFeature",
                    "kind": "LinkedField",
                    "name": "premiumExtensions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "usePremiumGatePremiumGateQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "usePremiumGatePremiumGateQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "b3b58abba516a7066e43fee230bb62d7",
            "id": "dd5ecfcc11044bcdaad98bea20a111b89a5005066669b87b37b1b8d5ea4e1ca6",
            "metadata": {},
            "name": "usePremiumGatePremiumGateQuery",
            "operationKind": "query",
            "text": "query usePremiumGatePremiumGateQuery{entitlements{premiumExtensions{isEntitled}}}"
        }
    };
}();
$ce65a234c274b394$var$node.hash = "53ba2ea71d0cb2a819a38d3bb3e49b44";
var $ce65a234c274b394$export$2e2bcd8739ae039 = $ce65a234c274b394$var$node;



var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $7Sm4c = parcelRequire("7Sm4c");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5ZqQS = parcelRequire("5ZqQS");


var $jMyy4 = parcelRequire("jMyy4");

const $50d2dd6da149924b$export$31a131ac01af5546 = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const canSkipEntitlementCheck = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $ce65a234c274b394$export$2e2bcd8739ae039), {
        skip: canSkipEntitlementCheck,
        __callerPackage__: "@confluence/custom-sites-extensions"
    });
    if (error) {
        if (!((0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error))) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    return !canSkipEntitlementCheck && !data?.entitlements.premiumExtensions.isEntitled;
};
module.exports["usePremiumGate"] = $50d2dd6da149924b$export$31a131ac01af5546;

});

parcelRegister("5Gcps", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");

/**
 * @generated SignedSource<<4ec0d41eabd26d29b4ef59d463a9ba52>>
 * @relayHash 2ce4acba36ec591640edbadf9a4c0da1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 45b6c1dc2b39de9dbacf64bc05ff8155b28c306f24693e370416db912823d81a
const $c81d24d8a5f7522b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "spaceId",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
            v2 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceMetadataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedSpaceList",
                    "kind": "LinkedField",
                    "name": "spaces",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceMetadataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedSpaceList",
                    "kind": "LinkedField",
                    "name": "spaces",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "2ce4acba36ec591640edbadf9a4c0da1",
            "id": "45b6c1dc2b39de9dbacf64bc05ff8155b28c306f24693e370416db912823d81a",
            "metadata": {},
            "name": "SpaceMetadataQuery",
            "operationKind": "query",
            "text": "query SpaceMetadataQuery($id:Long!){spaces(spaceId:$id){nodes{homepage{id},id}}}"
        }
    };
}();
$c81d24d8a5f7522b$var$node.hash = "ebea840491a8ee540fbdcc7340dcbf80";
var $c81d24d8a5f7522b$export$2e2bcd8739ae039 = $c81d24d8a5f7522b$var$node;


const $e798eb82c10075ec$export$10df301dbc20c6db = (0, $c81d24d8a5f7522b$export$2e2bcd8739ae039);


const $9f3924c176ad2a57$export$2dd23eaa621322c4 = (activationId, cloudId, objectId, spaceId)=>({
        type: 'sendTrackEvent',
        data: {
            action: 'viewed',
            actionSubject: 'companyHubLink',
            source: 'companyHub',
            objectType: 'page',
            objectId: objectId,
            attributes: {
                activationId: activationId,
                spaceId: spaceId,
                spaceType: 'system',
                pageType: 'page',
                cloudId: cloudId
            }
        }
    });
const $9f3924c176ad2a57$export$e25d369331b443dc = (activationId, cloudId, objectId, spaceId)=>({
        type: 'sendTrackEvent',
        data: {
            action: 'clicked',
            actionSubject: 'companyHubLink',
            source: 'companyHub',
            objectType: objectId ? 'page' : null,
            objectId: objectId,
            attributes: {
                activationId: activationId,
                spaceId: spaceId,
                spaceType: 'system',
                pageType: objectId ? 'page' : null,
                cloudId: cloudId
            }
        }
    });
const $9f3924c176ad2a57$export$95c55278d4aca494 = async (objectId, destinationContainerId)=>{
    if (destinationContainerId === objectId) {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $e798eb82c10075ec$export$10df301dbc20c6db),
            variables: {
                id: destinationContainerId
            },
            __callerPackage__: "@confluence/analytics"
        });
        const homepageId = data?.spaces?.nodes?.[0]?.homepage?.id;
        if (!homepageId) return;
        return homepageId;
    }
    return objectId;
};
module.exports["generateViewEventPayload"] = $9f3924c176ad2a57$export$2dd23eaa621322c4;
module.exports["generateClickEventPayload"] = $9f3924c176ad2a57$export$e25d369331b443dc;
module.exports["getClickAndViewEventObjectIdFromLinkData"] = $9f3924c176ad2a57$export$95c55278d4aca494;

});

parcelRegister("biMIt", function(module, exports) {

var $jtfsl = parcelRequire("jtfsl");


var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");

const $ab43be195aa7029f$var$AudienceSegmentationContextProviderQuery = (0, $jtfsl.default);
const $ab43be195aa7029f$export$f8421e3bf566787d = 'accessible-to-anyone';
const $ab43be195aa7029f$export$6fb8438eed1d64ed = /*#__PURE__*/ (0, $42omo.createContext)({
    isCompanyHub: false,
    currentAudienceGroupIds: [],
    setCurrentAudienceGroupIds: ()=>{},
    isTargetAudience: ()=>true,
    isSegmentationApplied: false,
    setIsSegmentationApplied: ()=>{}
});
const $ab43be195aa7029f$var$AudienceSegmentationContextProviderInternal = ({ children: children, isCompanyHub: isCompanyHub, initialAudienceGroupIds: initialAudienceGroupIds = [], initialSegmentationApplied: initialSegmentationApplied = false, shouldFetchUserGroups: shouldFetchUserGroups = false })=>{
    const [currentAudienceGroupIds, setCurrentAudienceGroupIds] = (0, $42omo.useState)(initialAudienceGroupIds);
    const [isSegmentationApplied, setIsSegmentationApplied] = (0, $42omo.useState)(initialSegmentationApplied);
    const isTargetAudience = (0, $42omo.useCallback)((targetGroupIds)=>{
        if (!isCompanyHub || // if we are outside of company hub, no filtering
        targetGroupIds === undefined // if no target groups are provided, no filtering
        ) return true;
        setIsSegmentationApplied(true);
        const audienceGroupIdsSet = new Set(currentAudienceGroupIds);
        if (audienceGroupIdsSet.has($ab43be195aa7029f$export$f8421e3bf566787d)) return false;
        return targetGroupIds?.some((allowedGroup)=>audienceGroupIdsSet.has(allowedGroup));
    }, [
        currentAudienceGroupIds,
        isCompanyHub
    ]);
    const audienceSegmentationContextValue = (0, $42omo.useMemo)(()=>({
            currentAudienceGroupIds: currentAudienceGroupIds,
            setCurrentAudienceGroupIds: setCurrentAudienceGroupIds,
            isCompanyHub: isCompanyHub,
            isTargetAudience: isTargetAudience,
            isSegmentationApplied: isSegmentationApplied,
            setIsSegmentationApplied: setIsSegmentationApplied
        }), [
        currentAudienceGroupIds,
        isCompanyHub,
        isTargetAudience,
        isSegmentationApplied
    ]);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { error: queryError, loading: queryLoading } = (0, $jMyy4.useQueryInterop)($ab43be195aa7029f$var$AudienceSegmentationContextProviderQuery, {
        skip: !shouldFetchUserGroups || !isCompanyHub,
        variables: {
            accountId: userId
        },
        onCompleted: (data)=>{
            const userGroupIds = data?.user?.confluence?.groupsWithId?.map((result)=>result?.id).filter((id)=>!!id) ?? [];
            // onCompleted shouldn't be called if we skip the query but this is to ensure
            // the state doesn't get set when the fixture mock gives this query the default value
            shouldFetchUserGroups && setCurrentAudienceGroupIds(userGroupIds);
        },
        __callerPackage__: "@confluence/custom-sites-extensions"
    });
    const errorDisplay = (0, $42omo.useMemo)(()=>{
        if (queryError && !queryLoading) {
            if ((0, $1uFM6.isUnauthorizedError)(queryError)) (0, $7Sm4c.markErrorAsHandled)(queryError);
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: queryError
            });
        }
        return null;
    }, [
        queryError,
        queryLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ab43be195aa7029f$export$6fb8438eed1d64ed.Provider, {
        value: audienceSegmentationContextValue
    }, errorDisplay, children);
};
const $ab43be195aa7029f$export$23b23ee9c5e80f4e = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
})($ab43be195aa7029f$var$AudienceSegmentationContextProviderInternal);
module.exports["COMMON_VIEW_ID"] = $ab43be195aa7029f$export$f8421e3bf566787d;
module.exports["AudienceSegmentationContext"] = $ab43be195aa7029f$export$6fb8438eed1d64ed;
module.exports["AudienceSegmentationContextProvider"] = $ab43be195aa7029f$export$23b23ee9c5e80f4e;

});

parcelRegister("leEhv", function(module, exports) {

let $f75a26d718946271$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f75a26d718946271$var$load("1oHTu"),
    $f75a26d718946271$var$load("juJ52"),
    $f75a26d718946271$var$load("jDjSj"),
    $f75a26d718946271$var$load("2YffH"),
    $f75a26d718946271$var$load("j1hcz"),
    $f75a26d718946271$var$load("c6fuq"),
    $f75a26d718946271$var$load("5Znjm"),
    $f75a26d718946271$var$load("iJogx"),
    $f75a26d718946271$var$load("7wBDb"),
    $f75a26d718946271$var$load("2mZ4J"),
    $f75a26d718946271$var$load("lPQcc"),
    $f75a26d718946271$var$load("cmqxT"),
    $f75a26d718946271$var$load("eBRUf"),
    $f75a26d718946271$var$load("b90ZR"),
    $f75a26d718946271$var$load("9XYQ9"),
    $f75a26d718946271$var$load("7EorR"),
    $f75a26d718946271$var$load("llxGi"),
    $f75a26d718946271$var$load("9ijrN"),
    $f75a26d718946271$var$load("iNa18"),
    $f75a26d718946271$var$load("Wowvf"),
    $f75a26d718946271$var$load("6SWFK"),
    $f75a26d718946271$var$load("5zapo"),
    $f75a26d718946271$var$load("3MYQs"),
    $f75a26d718946271$var$load("9atVd"),
    $f75a26d718946271$var$load("eVYW1"),
    $f75a26d718946271$var$load("1oiJ6"),
    $f75a26d718946271$var$load("9GOJf"),
    $f75a26d718946271$var$load("bTmOC"),
    $f75a26d718946271$var$load("3L4o4"),
    $f75a26d718946271$var$load("8j9XC"),
    $f75a26d718946271$var$load("gknbb"),
    $f75a26d718946271$var$load("6iz6l"),
    $f75a26d718946271$var$load("4SCW2"),
    $f75a26d718946271$var$load("9q75n"),
    $f75a26d718946271$var$load("iYHbd"),
    $f75a26d718946271$var$load("3q2Ng"),
    $f75a26d718946271$var$load("jRpDi"),
    $f75a26d718946271$var$load("9aQIt"),
    $f75a26d718946271$var$load("XZauT"),
    $f75a26d718946271$var$load("4S1SF"),
    $f75a26d718946271$var$load("jiFtb"),
    $f75a26d718946271$var$load("lm9Lt"),
    $f75a26d718946271$var$load("9wPDc"),
    $f75a26d718946271$var$load("1MWOL"),
    $f75a26d718946271$var$load("6fQco"),
    $f75a26d718946271$var$load("aOY32"),
    $f75a26d718946271$var$load("3gJkK"),
    $f75a26d718946271$var$load("7jSfd"),
    $f75a26d718946271$var$load("4HZlX"),
    $f75a26d718946271$var$load("6wr18"),
    $f75a26d718946271$var$load("kDqHr"),
    $f75a26d718946271$var$load("gHdpU"),
    $f75a26d718946271$var$load("hhss7"),
    $f75a26d718946271$var$load("ffEVr"),
    $f75a26d718946271$var$load("fMsyQ")
]).then(()=>parcelRequire('kWs4M'));

});

parcelRegister("ijSB6", function(module, exports) {

let $03711a3ad2a33040$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $03711a3ad2a33040$var$load("c6fuq"),
    $03711a3ad2a33040$var$load("1oHTu"),
    $03711a3ad2a33040$var$load("juJ52"),
    $03711a3ad2a33040$var$load("dChec"),
    $03711a3ad2a33040$var$load("2YffH"),
    $03711a3ad2a33040$var$load("3RdRc"),
    $03711a3ad2a33040$var$load("j1hcz"),
    $03711a3ad2a33040$var$load("7wBDb"),
    $03711a3ad2a33040$var$load("2mZ4J"),
    $03711a3ad2a33040$var$load("eBRUf"),
    $03711a3ad2a33040$var$load("b90ZR"),
    $03711a3ad2a33040$var$load("9XYQ9"),
    $03711a3ad2a33040$var$load("7EorR"),
    $03711a3ad2a33040$var$load("gknbb"),
    $03711a3ad2a33040$var$load("6iz6l"),
    $03711a3ad2a33040$var$load("4SCW2"),
    $03711a3ad2a33040$var$load("9q75n"),
    $03711a3ad2a33040$var$load("iYHbd"),
    $03711a3ad2a33040$var$load("3q2Ng"),
    $03711a3ad2a33040$var$load("jRpDi"),
    $03711a3ad2a33040$var$load("Wowvf"),
    $03711a3ad2a33040$var$load("6SWFK"),
    $03711a3ad2a33040$var$load("9aQIt"),
    $03711a3ad2a33040$var$load("5zapo"),
    $03711a3ad2a33040$var$load("3MYQs"),
    $03711a3ad2a33040$var$load("XZauT"),
    $03711a3ad2a33040$var$load("4S1SF"),
    $03711a3ad2a33040$var$load("jiFtb"),
    $03711a3ad2a33040$var$load("lm9Lt"),
    $03711a3ad2a33040$var$load("9atVd"),
    $03711a3ad2a33040$var$load("9wPDc"),
    $03711a3ad2a33040$var$load("1MWOL"),
    $03711a3ad2a33040$var$load("6fQco"),
    $03711a3ad2a33040$var$load("aOY32"),
    $03711a3ad2a33040$var$load("7jSfd"),
    $03711a3ad2a33040$var$load("4HZlX"),
    $03711a3ad2a33040$var$load("6wr18"),
    $03711a3ad2a33040$var$load("kDqHr"),
    $03711a3ad2a33040$var$load("gHdpU"),
    $03711a3ad2a33040$var$load("ffEVr"),
    $03711a3ad2a33040$var$load("hhss7"),
    $03711a3ad2a33040$var$load("eVYW1"),
    $03711a3ad2a33040$var$load("1oiJ6"),
    $03711a3ad2a33040$var$load("bTmOC"),
    $03711a3ad2a33040$var$load("8j9XC"),
    $03711a3ad2a33040$var$load("lFZaH")
]).then(()=>parcelRequire('cBfKJ'));

});

parcelRegister("b0Fzw", function(module, exports) {

let $803ff11e8c6a3f30$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $803ff11e8c6a3f30$var$load("jDjSj"),
    $803ff11e8c6a3f30$var$load("3MYQs"),
    $803ff11e8c6a3f30$var$load("6wr18"),
    $803ff11e8c6a3f30$var$load("9GOJf"),
    $803ff11e8c6a3f30$var$load("7wBDb"),
    $803ff11e8c6a3f30$var$load("2mZ4J"),
    $803ff11e8c6a3f30$var$load("3SmkN"),
    $803ff11e8c6a3f30$var$load("9fGNu"),
    $803ff11e8c6a3f30$var$load("lPQcc"),
    $803ff11e8c6a3f30$var$load("hUmZG"),
    $803ff11e8c6a3f30$var$load("9XYQ9"),
    $803ff11e8c6a3f30$var$load("3Bbwl"),
    $803ff11e8c6a3f30$var$load("llxGi"),
    $803ff11e8c6a3f30$var$load("Wowvf"),
    $803ff11e8c6a3f30$var$load("gHdpU"),
    $803ff11e8c6a3f30$var$load("hhss7"),
    $803ff11e8c6a3f30$var$load("ffEVr"),
    $803ff11e8c6a3f30$var$load("kUykF")
]).then(()=>parcelRequire('27HWy'));

});

parcelRegister("fP2mK", function(module, exports) {

let $b84d7440b91c3f96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b84d7440b91c3f96$var$load("2YffH"),
    $b84d7440b91c3f96$var$load("cgmWe"),
    $b84d7440b91c3f96$var$load("7wBDb"),
    $b84d7440b91c3f96$var$load("2mZ4J"),
    $b84d7440b91c3f96$var$load("igTEs"),
    $b84d7440b91c3f96$var$load("2Gceu"),
    $b84d7440b91c3f96$var$load("eBRUf"),
    $b84d7440b91c3f96$var$load("bGpE6"),
    $b84d7440b91c3f96$var$load("hUmZG"),
    $b84d7440b91c3f96$var$load("4RbVd"),
    $b84d7440b91c3f96$var$load("b90ZR"),
    $b84d7440b91c3f96$var$load("9XYQ9"),
    $b84d7440b91c3f96$var$load("7EorR"),
    $b84d7440b91c3f96$var$load("iFEfD"),
    $b84d7440b91c3f96$var$load("Wowvf"),
    $b84d7440b91c3f96$var$load("6SWFK"),
    $b84d7440b91c3f96$var$load("5zapo"),
    $b84d7440b91c3f96$var$load("3MYQs"),
    $b84d7440b91c3f96$var$load("jiFtb"),
    $b84d7440b91c3f96$var$load("6wr18"),
    $b84d7440b91c3f96$var$load("9atVd"),
    $b84d7440b91c3f96$var$load("ffEVr"),
    $b84d7440b91c3f96$var$load("gHdpU"),
    $b84d7440b91c3f96$var$load("hhss7"),
    $b84d7440b91c3f96$var$load("aUuEW")
]).then(()=>parcelRequire('aALia'));

});

parcelRegister("6Ck7n", function(module, exports) {

let $4d15e5b53c2b3d67$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4d15e5b53c2b3d67$var$load("1oHTu"),
    $4d15e5b53c2b3d67$var$load("juJ52"),
    $4d15e5b53c2b3d67$var$load("2YffH"),
    $4d15e5b53c2b3d67$var$load("f35QR"),
    $4d15e5b53c2b3d67$var$load("eVYW1"),
    $4d15e5b53c2b3d67$var$load("ls0Um"),
    $4d15e5b53c2b3d67$var$load("020xd"),
    $4d15e5b53c2b3d67$var$load("eTBsW"),
    $4d15e5b53c2b3d67$var$load("bYxCZ"),
    $4d15e5b53c2b3d67$var$load("6HBYC"),
    $4d15e5b53c2b3d67$var$load("1oiJ6"),
    $4d15e5b53c2b3d67$var$load("huUvS"),
    $4d15e5b53c2b3d67$var$load("g2A8O"),
    $4d15e5b53c2b3d67$var$load("j1hcz"),
    $4d15e5b53c2b3d67$var$load("c6fuq"),
    $4d15e5b53c2b3d67$var$load("bTmOC"),
    $4d15e5b53c2b3d67$var$load("3L4o4"),
    $4d15e5b53c2b3d67$var$load("iJogx"),
    $4d15e5b53c2b3d67$var$load("7wBDb"),
    $4d15e5b53c2b3d67$var$load("2mZ4J"),
    $4d15e5b53c2b3d67$var$load("eBRUf"),
    $4d15e5b53c2b3d67$var$load("b90ZR"),
    $4d15e5b53c2b3d67$var$load("9XYQ9"),
    $4d15e5b53c2b3d67$var$load("7EorR"),
    $4d15e5b53c2b3d67$var$load("8j9XC"),
    $4d15e5b53c2b3d67$var$load("iNa18"),
    $4d15e5b53c2b3d67$var$load("gknbb"),
    $4d15e5b53c2b3d67$var$load("6iz6l"),
    $4d15e5b53c2b3d67$var$load("4SCW2"),
    $4d15e5b53c2b3d67$var$load("9q75n"),
    $4d15e5b53c2b3d67$var$load("iYHbd"),
    $4d15e5b53c2b3d67$var$load("3q2Ng"),
    $4d15e5b53c2b3d67$var$load("jRpDi"),
    $4d15e5b53c2b3d67$var$load("Wowvf"),
    $4d15e5b53c2b3d67$var$load("6SWFK"),
    $4d15e5b53c2b3d67$var$load("9aQIt"),
    $4d15e5b53c2b3d67$var$load("5zapo"),
    $4d15e5b53c2b3d67$var$load("3MYQs"),
    $4d15e5b53c2b3d67$var$load("XZauT"),
    $4d15e5b53c2b3d67$var$load("4S1SF"),
    $4d15e5b53c2b3d67$var$load("jiFtb"),
    $4d15e5b53c2b3d67$var$load("lm9Lt"),
    $4d15e5b53c2b3d67$var$load("9atVd"),
    $4d15e5b53c2b3d67$var$load("9wPDc"),
    $4d15e5b53c2b3d67$var$load("1MWOL"),
    $4d15e5b53c2b3d67$var$load("6fQco"),
    $4d15e5b53c2b3d67$var$load("aOY32"),
    $4d15e5b53c2b3d67$var$load("7jSfd"),
    $4d15e5b53c2b3d67$var$load("4HZlX"),
    $4d15e5b53c2b3d67$var$load("6wr18"),
    $4d15e5b53c2b3d67$var$load("kDqHr"),
    $4d15e5b53c2b3d67$var$load("gHdpU"),
    $4d15e5b53c2b3d67$var$load("hhss7"),
    $4d15e5b53c2b3d67$var$load("ffEVr"),
    $4d15e5b53c2b3d67$var$load("dJOHz")
]).then(()=>parcelRequire('8Hi5s'));

});

parcelRegister("7BsWq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");

const $d70acb7f5d54408a$export$9143d6ac64592241 = ()=>{
    // IMPORTANT: If you add a new feature flag here, please make sure to add it to the
    // `featureFlagsPluginOptions` function in 'packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/featureFlagsPluginOptions.ts`.
    return (0, $42omo.useMemo)(()=>({
            /**
			 * This feature flag has completed rollout in Confluence and is to be cleaned up from LD
			 * but cannot yet be cleaned up from editor component as pending rollout in other products first
			 */ 'lp-link-picker': true,
            'table-drag-and-drop': (0, $6mKj3.expVal)('platform_editor_tables_drag_and_drop', 'isEnabled', false),
            'table-with-fixed-column-widths-option': true
        }), []);
};
module.exports["useEditorFeatureFlags"] = $d70acb7f5d54408a$export$9143d6ac64592241;

});

parcelRegister("brsfB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dh538 = parcelRequire("dh538");


var $6m4LV = parcelRequire("6m4LV");


var $9UKrO = parcelRequire("9UKrO");


var $bedVD = parcelRequire("bedVD");


var $4GlQ9 = parcelRequire("4GlQ9");


var $4qzKl = parcelRequire("4qzKl");


var $bumSD = parcelRequire("bumSD");


var $jlIaF = parcelRequire("jlIaF");


var $bQm3c = parcelRequire("bQm3c");


var $5XsiK = parcelRequire("5XsiK");


var $eLV9q = parcelRequire("eLV9q");

function $ce8c9e4f9afe9f9c$export$14fbdf1c2aa5816c({ push: push, userId: userId, cloudId: cloudId, featureFlags: featureFlags }) {
    const intl = (0, $aXWIB.useIntl)();
    const feedFollowData = (0, $4GlQ9.useFeedFollow)();
    const getNavigateToTeamsApp = (0, $eLV9q.useGetNavigateToTeamsApp)();
    const { orgId: orgId, userId: requestingUserId } = (0, $bQm3c.useSessionData)();
    const handleProfileCardActions = (0, $42omo.useCallback)((pushProfileCardActions, loggedInUserId)=>(profileCardUserId)=>{
            const atlassianPeopleProfileUrl = (0, $4qzKl.getAtlassianPeopleProfileUrl)(profileCardUserId, null, (0, $jlIaF.CONTEXT_PATH));
            const teamsAppPersonProfileUrl = getNavigateToTeamsApp({
                type: 'USER',
                payload: {
                    userId: profileCardUserId
                }
            }).href;
            const followed = !!(profileCardUserId && feedFollowData?.followedUsers?.includes(profileCardUserId));
            return [
                {
                    label: intl.formatMessage({
                        id: "view.profile"
                    }),
                    callback: (0, $5XsiK.isTeamsAppEnabled)() ? undefined : ()=>{
                        pushProfileCardActions((0, $4qzKl.getAtlassianPeopleProfileUrl)(profileCardUserId, null, (0, $jlIaF.CONTEXT_PATH)));
                    },
                    target: (0, $5XsiK.isTeamsAppEnabled)() ? '_blank' : undefined,
                    link: (0, $5XsiK.isTeamsAppEnabled)() ? teamsAppPersonProfileUrl : atlassianPeopleProfileUrl
                },
                {
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bedVD.FeedFollow), {
                        followed: followed
                    }),
                    id: 'feed-follow-user',
                    callback: feedFollowData.getToggleFollowUser(profileCardUserId, followed, 'editor'),
                    shouldRender: (userData)=>feedFollowData.renderFeedFollow && Boolean(profileCardUserId) && profileCardUserId !== loggedInUserId && userData?.status === 'active'
                }
            ];
        }, [
        feedFollowData,
        getNavigateToTeamsApp,
        intl
    ]);
    return (0, $42omo.useMemo)(()=>{
        const providerPromise = (0, $9UKrO.getProfileCardProvider)(cloudId, handleProfileCardActions(push, userId), featureFlags ?? {});
        if (!(0, $dh538.fg)('people-teams_migrate-user-profile-card')) return providerPromise;
        return providerPromise.then((provider)=>({
                ...provider,
                renderUserMentionCard: ({ userId: mentionUserId, cloudId: mentionCloudId, children: children, referenceElement: referenceElement })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6m4LV.UserProfileCardForMention), {
                        userId: mentionUserId,
                        cloudId: mentionCloudId,
                        orgId: orgId ?? '',
                        viewerId: requestingUserId ?? '',
                        referenceElement: referenceElement,
                        agent: {
                            resourceClient: (0, $bumSD.getProfileClient)(mentionCloudId, featureFlags ?? {})
                        }
                    }, children)
            }));
    }, [
        cloudId,
        handleProfileCardActions,
        push,
        userId,
        featureFlags,
        orgId,
        requestingUserId
    ]);
}
module.exports["useProfilecardProvider"] = $ce8c9e4f9afe9f9c$export$14fbdf1c2aa5816c;

});

parcelRegister("9UKrO", function(module, exports) {

var $bumSD = parcelRequire("bumSD");

function $88671cc112964e63$export$ecc18d1a90c31bf8(cloudId, getActions, /**
	 * @deprecated This is no longer used we should remove in a future version
	 */ featureFlags) {
    return Promise.resolve({
        cloudId: cloudId,
        resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
        getActions: getActions
    });
}
module.exports["getProfileCardProvider"] = $88671cc112964e63$export$ecc18d1a90c31bf8;

});

parcelRegister("ldonE", function(module, exports) {

let $f71db95062ec274d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f71db95062ec274d$var$load("hhss7"),
    $f71db95062ec274d$var$load("1sNyt")
]).then(()=>parcelRequire('ddUxf'));

});

parcelRegister("hMB4W", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $8pcS0 = parcelRequire("8pcS0");

const $0cc2e310acfcea5e$var$INLINE_MACRO_OUTPUT_TYPE = 'INLINE';
const $0cc2e310acfcea5e$var$MAX_ADF_CONTENT_TRAVERSAL_DEPTH = 100;
// ADF block/container node types cannot be rendered inside an inline macro wrapper.
const $0cc2e310acfcea5e$var$INLINE_UNSAFE_ADF_BLOCK_NODE_TYPES = new Set([
    'blockquote',
    (0, $8pcS0.BODIED_EXTENSION_TYPE),
    'bulletList',
    'codeBlock',
    'decisionList',
    'expand',
    (0, $8pcS0.REGULAR_EXTENSION_TYPE),
    'heading',
    'layoutColumn',
    'layoutSection',
    'mediaGroup',
    'mediaSingle',
    (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE),
    'nestedExpand',
    'orderedList',
    'panel',
    'rule',
    'table',
    'taskList'
]);
const $0cc2e310acfcea5e$var$isAdfLikeNode = (value)=>Boolean(value && typeof value === 'object' && 'type' in value);
const $0cc2e310acfcea5e$var$pushArrayContent = (stack, content, depth)=>{
    for(let index = content.length - 1; index >= 0; index -= 1)stack.push({
        content: content[index],
        depth: depth
    });
};
const $0cc2e310acfcea5e$var$isLegacyContentBlockExtension = (node)=>node.attrs?.extensionType === (0, $8pcS0.EXTENSION_TYPE).MIGRATION && node.type !== (0, $8pcS0.INLINE_EXTENSION_TYPE);
const $0cc2e310acfcea5e$var$isInlineUnsafeAdfBlockNode = (node)=>typeof node.type === 'string' && $0cc2e310acfcea5e$var$INLINE_UNSAFE_ADF_BLOCK_NODE_TYPES.has(node.type);
const $0cc2e310acfcea5e$var$containsInlineUnsafeContent = (initialContent)=>{
    const stack = [
        {
            content: initialContent,
            depth: 0
        }
    ];
    const visited = new WeakSet();
    while(stack.length){
        const entry = stack.pop();
        if (!entry) continue;
        const { content: currentContent, depth: depth } = entry;
        if (!currentContent || typeof currentContent === 'string') continue;
        if (depth > $0cc2e310acfcea5e$var$MAX_ADF_CONTENT_TRAVERSAL_DEPTH) return true;
        if (Array.isArray(currentContent)) {
            $0cc2e310acfcea5e$var$pushArrayContent(stack, currentContent, depth);
            continue;
        }
        if (!$0cc2e310acfcea5e$var$isAdfLikeNode(currentContent)) continue;
        if (visited.has(currentContent)) continue;
        visited.add(currentContent);
        if ($0cc2e310acfcea5e$var$isLegacyContentBlockExtension(currentContent) || $0cc2e310acfcea5e$var$isInlineUnsafeAdfBlockNode(currentContent)) return true;
        stack.push({
            content: currentContent.content,
            depth: depth + 1
        });
        stack.push({
            content: currentContent.attrs?.parameters?.nestedContent,
            depth: depth + 1
        });
    }
    return false;
};
function $0cc2e310acfcea5e$export$6eb9f199796a82af(extensionParams) {
    // Always display excerpt as block
    if (extensionParams?.extensionKey === 'excerpt') return false;
    if ($0cc2e310acfcea5e$var$containsInlineUnsafeContent(extensionParams?.content) && (0, $9wGTI.fg)('confluence_fix_migrated_macro_inline_rendering')) return false;
    return Boolean(extensionParams?.parameters?.macroParams?.['atlassian-macro-output-type']?.value === $0cc2e310acfcea5e$var$INLINE_MACRO_OUTPUT_TYPE);
}
module.exports["shouldDisplayExtensionAsInline"] = $0cc2e310acfcea5e$export$6eb9f199796a82af;

});

parcelRegister("3WO8q", function(module, exports) {
/**
 * @generated SignedSource<<fe06600cc559f558a289ccb207edd4fd>>
 * @relayHash 71c94317b822094613bae175c3a66d36
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fbaa3ee68b6ac2cd5fd36baecaa22799cd3dbe90afe1df714af04960a657bb74
const $59078742ed079e5f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "taskId"
    }, v3 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "cid",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        },
                        {
                            "kind": "Variable",
                            "name": "taskId",
                            "variableName": "taskId"
                        },
                        {
                            "kind": "Literal",
                            "name": "trigger",
                            "value": "VIEW_PAGE"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "inlineTasksInput"
                }
            ],
            "concreteType": "GraphQLMutationResponse",
            "kind": "LinkedField",
            "name": "setTaskStatus",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SetTaskStatusMutation",
            "selections": v3 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SetTaskStatusMutation",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "71c94317b822094613bae175c3a66d36",
            "id": "fbaa3ee68b6ac2cd5fd36baecaa22799cd3dbe90afe1df714af04960a657bb74",
            "metadata": {},
            "name": "SetTaskStatusMutation",
            "operationKind": "mutation",
            "text": "mutation SetTaskStatusMutation($contentId:ID!,$taskId:ID!,$status:TaskStatus!){setTaskStatus(inlineTasksInput:{cid:$contentId,taskId:$taskId,status:$status,trigger:VIEW_PAGE}){success}}"
        }
    };
}();
$59078742ed079e5f$var$node.hash = "b0fcb034a764e654bff661127582f078";
var $59078742ed079e5f$export$2e2bcd8739ae039 = $59078742ed079e5f$var$node;



var $aXWIB = parcelRequire("aXWIB");

const $c88a9f0357b47b1b$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    flagTitle: {
        id: "fabric-media-support.tasklist.error.flag.title",
        defaultMessage: "Something went wrong"
    },
    flagDescription: {
        id: "fabric-media-support.tasklist.error.flag.description",
        defaultMessage: "An error occurred while trying to change a task\u2019s status. Please try again later."
    }
});



var $6s78L = parcelRequire("6s78L");

class $cc5c5911f5458682$export$bfe822b045233127 {
    toggleTask(objectKey, state) {
        if (this._toggleTaskCallback) {
            this._toggleTaskCallback(objectKey, state);
            return Promise.resolve(state);
        } else /**
       * Using objectKey.objectAri may be a better alternative to passing in
       * contentId to the constructor. If it's reliable.
       */ return (0, $6s78L.mutateInterop)({
            mutation: (0, $59078742ed079e5f$export$2e2bcd8739ae039),
            variables: {
                contentId: this.contentId,
                taskId: objectKey.localId,
                status: state === 'DONE' ? 'CHECKED' : 'UNCHECKED'
            },
            __callerPackage__: "@confluence/fabric-media-support"
        }).then((response)=>{
            const success = response?.data?.setTaskStatus?.success || false;
            if (!success) this.showErrorFlag();
            return state;
        }).catch(// this method is set to return `any` as a workaround for types.
        // Given that `TaskDecisionProvider.toggleTask` does not actually permit
        // `void` to be returned, what the `catch` block should probably be doing
        // is re-throwing the error that it got (at least that might match the
        // expectations). Since doing that will result in actual behavior changes
        // which I'm hesitant to perform, TS is simply silenced by `ny`-ing the
        // return type.
        (_)=>{
            /**
         * Note: there seems to be an issue whereby clicking a checkbox twice
         * quickly causes an error. I'm guessing something's not happy with a
         * mutation being issued while the previous one was still in-flight.
         * KTLO: we should probably create a queue as a workaround.
         * I'm (mdean2) not fixing this right now because I'm up against the
         * clock and the previous classic implementation suffered the same
         * problem.
         */ this.showErrorFlag();
        });
    }
    showErrorFlag() {
        this.flags.showErrorFlag({
            title: this.intl.formatMessage((0, $c88a9f0357b47b1b$export$a7357cdd1f0b0168).flagTitle),
            description: this.intl.formatMessage((0, $c88a9f0357b47b1b$export$a7357cdd1f0b0168).flagDescription)
        });
    }
    // Below are stubs, implemented to pacify TypeScript, and inherited from old
    // classic implementation.
    notifyRecentUpdates(_updateContext) {}
    subscribe(_objectKey, _handler) {}
    unsubscribe(_objectKey, _handler) {}
    unsubscribeRecentUpdates(_id) {}
    /* eslint-disable no-useless-constructor */ constructor(intl, flags, contentId, toggleTaskCallback){
        this.intl = intl;
        this.flags = flags;
        this.contentId = contentId;
        this.toggleTaskCallback = toggleTaskCallback;
        this._toggleTaskCallback = void 0;
        /**
     * eslint mistakenly thinks this is a useless constructor. It's not,
     * because TypeScript translates the 'public' arguments to actual code that
     * assigns them to instance variables.
     */ this._toggleTaskCallback = toggleTaskCallback;
    }
}
module.exports["ConfluenceTaskDecisionProvider"] = $cc5c5911f5458682$export$bfe822b045233127;

});

parcelRegister("gxhb8", function(module, exports) {
/* eslint-disable no-useless-constructor */ class $6c53b0825160fdb5$export$9a91b236871b318c {
    onFlush(callback) {
        if (!(callback instanceof Function)) throw new Error(`"onFlush" callback is supposed to be a function; saw ${typeof callback} instead`);
        this.onFlushCallback = callback;
    }
    /**
   * Forcefully flushes the batcher. Noop if current batch is empty.
   */ forceFlush() {
        // Currently force-flush is synchronous. Make sure the call sites are updated if
        // this is changed to a promise-based approach
        this.flush();
    }
    renewBatch() {
        const oldBatch = this.currentBatch;
        this.currentBatch = [];
        return oldBatch;
    }
    scheduleFlush() {
        if (!this.flushIntervalId) this.flushIntervalId = window.setInterval(this.flush, this.flushIntervalMs);
    }
    unscheduleFlush() {
        if (this.flushIntervalId) {
            window.clearInterval(this.flushIntervalId);
            this.flushIntervalId = undefined;
        }
    }
    constructor(flushIntervalMs){
        this.flushIntervalMs = flushIntervalMs;
        this.flushIntervalId = void 0;
        this.onFlushCallback = void 0;
        this.currentBatch = [];
        this.add = (item)=>{
            this.scheduleFlush();
            // If there's a previous task action for the same task, remove it
            this.currentBatch = this.currentBatch.filter((task)=>task.objectKey.localId !== item.objectKey.localId);
            this.currentBatch.push(item);
        };
        this.flush = ()=>{
            const batch = this.renewBatch();
            this.unscheduleFlush();
            if (batch.length === 0) return;
            try {
                if (this.onFlushCallback) this.onFlushCallback(batch);
            } catch (e) {
                // rethrow error asynchronously to allow other callbacks to execute
                setTimeout(()=>{
                    /* eslint-disable-next-line no-console */ console.error(`"onFlush" callback threw the below error. Please make sure your callbacks have proper error handling`);
                    throw e;
                }, 0);
            }
        };
    }
}
module.exports["TaskBatcher"] = $6c53b0825160fdb5$export$9a91b236871b318c;

});

parcelRegister("dXIrr", function(module, exports) {
/* PromptPopupContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");


var $dpPtd = parcelRequire("dpPtd");


var $6mKj3 = parcelRequire("6mKj3");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $7EIq6 = parcelRequire("7EIq6");


var $cLo2u = parcelRequire("cLo2u");


var $kDja4 = parcelRequire("kDja4");


var $eVXGa = parcelRequire("eVXGa");


var $1xpoY = parcelRequire("1xpoY");







const $623af4b4cfb0b8c1$var$DATABASE_COMPETITORS = [
    {
        name: 'Google Sheets',
        domains: [
            /docs\.google\.com\/spreadsheets/i
        ]
    },
    {
        name: 'Microsoft Lists',
        domains: [
            /lists\.live\.com/i
        ]
    },
    {
        name: 'SmartSheet',
        domains: [
            /smartsheet\.com/i
        ]
    },
    {
        name: 'Airtable',
        domains: [
            /airtable\.com/i
        ]
    },
    {
        name: 'AsanaList',
        domains: [
            /app\.asana\.com.*\/list\//i
        ]
    },
    {
        name: 'AsanaBoard',
        domains: [
            /app\.asana\.com.*\/board\//i
        ]
    }
];
const $623af4b4cfb0b8c1$export$42c019d1a8a7c555 = (url)=>{
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const { isCreateDatabaseEnabled: isCreateDatabaseEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey ?? undefined);
    const databaseCompetitor = $623af4b4cfb0b8c1$var$DATABASE_COMPETITORS.find((competitor)=>competitor.domains.some((regex)=>regex.test(url)));
    return {
        databaseCompetitorName: isCreateDatabaseEnabled ? databaseCompetitor?.name : undefined
    };
};


/**
 * @generated SignedSource<<b83f28e1481ddab674d916893c028e42>>
 * @relayHash 1f09213993754544aa08c52be2fc631e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee3ea7480262edcd30a9dd3f6f311ba153c2654db843999d0fe18c7084a28006
const $e21fff8b5a3f62da$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "contentType",
                    "value": "whiteboard"
                }
            ],
            "concreteType": "PaywallContentSingle",
            "kind": "LinkedField",
            "name": "paywallContentToDisable",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "deactivationIdentifier"
                },
                {
                    "kind": "ScalarField",
                    "name": "link"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ],
            "storageKey": "paywallContentToDisable(contentType:\"whiteboard\")"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "PromptPopupPaywallContentToDisableQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "PromptPopupPaywallContentToDisableQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "1f09213993754544aa08c52be2fc631e",
            "id": "ee3ea7480262edcd30a9dd3f6f311ba153c2654db843999d0fe18c7084a28006",
            "metadata": {},
            "name": "PromptPopupPaywallContentToDisableQuery",
            "operationKind": "query",
            "text": "query PromptPopupPaywallContentToDisableQuery{paywallContentToDisable(contentType:\"whiteboard\"){deactivationIdentifier,link,title}}"
        }
    };
}();
$e21fff8b5a3f62da$var$node.hash = "bb7d0d4a20298d54ac0ea3dd0fe0a1fe";
var $e21fff8b5a3f62da$export$2e2bcd8739ae039 = $e21fff8b5a3f62da$var$node;


/**
 * @generated SignedSource<<7648391b8de4ac887295688e41a4af1f>>
 * @relayHash 536bd75db3cd2df747c3923dbbdfb5dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a306fd79e49849de127258c16f0e3c415f73f67ee0a405b5bc08ec6ef1826cb1
const $c29180730df60abf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "createdInContentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "type"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "createdInContentId",
                            "variableName": "createdInContentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "type",
                            "variableName": "type"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "createContentInline",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PromptPopupCreateContentInlineMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PromptPopupCreateContentInlineMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "536bd75db3cd2df747c3923dbbdfb5dd",
            "id": "a306fd79e49849de127258c16f0e3c415f73f67ee0a405b5bc08ec6ef1826cb1",
            "metadata": {},
            "name": "PromptPopupCreateContentInlineMutation",
            "operationKind": "mutation",
            "text": "mutation PromptPopupCreateContentInlineMutation($createdInContentId:ID!,$spaceKey:String,$type:String!){createContentInline(input:{createdInContentId:$createdInContentId,spaceKey:$spaceKey,type:$type}){id}}"
        }
    };
}();
$c29180730df60abf$var$node.hash = "7e424a27911cd9ea50caa4b8ef0b5877";
var $c29180730df60abf$export$2e2bcd8739ae039 = $c29180730df60abf$var$node;






var $aXWIB = parcelRequire("aXWIB");


var $lGgRw = parcelRequire("lGgRw");


var $fVUfS = parcelRequire("fVUfS");


var $1Whri = parcelRequire("1Whri");


var $3HOqx = parcelRequire("3HOqx");


var $3sFtD = parcelRequire("3sFtD");


var $inPa6 = parcelRequire("inPa6");





var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $euL71 = parcelRequire("euL71");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $bMPhU = parcelRequire("bMPhU");





var $fhofE = parcelRequire("fhofE");


var $ccP7J = parcelRequire("ccP7J");











var $3jwuS = parcelRequire("3jwuS");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");

const $48b719f4930c6be4$export$c2b5ddd2c8b4a98c = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ mode: livePageMode }] = (0, $efvKr.useLivePageMode)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    return (0, $42omo.useMemo)(()=>{
        if (isLivePage) return {
            isLivePage: isLivePage,
            pageMode: livePageMode || 'view' // 'edit' or 'view' for live pages
        };
        return {
            isLivePage: isLivePage,
            pageMode: isEditorPage ? 'edit' : 'view' // 'edit' or 'view' for classic pages
        };
    }, [
        isLivePage,
        livePageMode,
        isEditorPage
    ]);
};





const $ff137fb7addc2b15$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    titleDatabase: {
        id: "prompt-competitor-link.prompt-database.title-database",
        defaultMessage: "Try Confluence databases"
    },
    descriptionDefaultDatabase: {
        id: "prompt-competitor-link.prompt-database.description-default-database",
        defaultMessage: "To organize content and data without switching tools, try Confluence databases."
    },
    createButtonDefaultDatabase: {
        id: "prompt-competitor-link.prompt-database.create-button-default-database",
        defaultMessage: "Create a database"
    },
    dismissButtonDatabase: {
        id: "prompt-competitor-link.prompt-database.dismiss-button",
        defaultMessage: "Do not show for databases again"
    },
    databaseIconAltText: {
        id: "prompt-competitor-link.prompt-database.icon-alt-text",
        defaultMessage: "Confluence Database"
    },
    successFlagTitle: {
        id: "prompt-competitor-link.prompt-database.success-flag-title",
        defaultMessage: "Database added to content tree"
    },
    successFlagDescription: {
        id: "prompt-competitor-link.prompt-database.success-flag-description",
        defaultMessage: "The database has been created in the tree. Go to the database to move its location or change its permissions."
    },
    successFlagAction: {
        id: "prompt-competitor-link.prompt-database.success-flag-action",
        defaultMessage: "Go to database"
    },
    createdFlagTitle: {
        id: "prompt-competitor-link.prompt-database.created-flag-title",
        defaultMessage: "Database successfully created"
    },
    createdFlagDescription: {
        id: "prompt-competitor-link.prompt-database.created-flag-description",
        defaultMessage: "This database was created as a child item of the content you were working on."
    },
    createdFlagAction: {
        id: "prompt-competitor-link.prompt-database.created-flag-action",
        defaultMessage: "Go back to previous content"
    },
    defaultErrorFlagTitle: {
        id: "prompt-competitor-link.prompt-database.default-error-flag-title",
        defaultMessage: "We\u2019re unable to create right now"
    },
    defaultErrorFlagDescription: {
        id: "prompt-competitor-link.prompt-database.default-error-flag-description",
        defaultMessage: "Refresh or wait a few minutes and try again. If this keeps happening, contact support."
    }
});





const $6bf1a4c43dd25981$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    titleWhiteboard: {
        id: "prompt-competitor-link.prompt-whiteboard.title-whiteboard",
        defaultMessage: "Try Confluence whiteboards"
    },
    descriptionDefaultWhiteboard: {
        id: "prompt-competitor-link.prompt-whiteboard.description-default-whiteboard",
        defaultMessage: "To brainstorm and ideate without switching tools, try Confluence whiteboards."
    },
    descriptionImportWhiteboard: {
        id: "prompt-competitor-link.prompt-whiteboard.description-import-whiteboard",
        defaultMessage: "Reduce context switching by importing your work to a Confluence whiteboard instead."
    },
    createButtonDefaultWhiteboard: {
        id: "prompt-competitor-link.prompt-whiteboard.create-button-default-whiteboard",
        defaultMessage: "Create a whiteboard"
    },
    createButtonImportWhiteboard: {
        id: "prompt-competitor-link.prompt-whiteboard.create-button-import-whiteboard",
        defaultMessage: "Import from {competitorName}"
    },
    dismissButton: {
        id: "prompt-competitor-link.prompt-whiteboard.dismiss-button",
        defaultMessage: "Do not show for whiteboards again"
    },
    whiteboardIconAltText: {
        id: "prompt-competitor-link.prompt-whiteboard.icon-alt-text",
        defaultMessage: "Confluence Whiteboard"
    },
    successFlagTitle: {
        id: "prompt-competitor-link.prompt-whiteboard.success-flag-title",
        defaultMessage: "Whiteboard added to content tree"
    },
    successFlagDescription: {
        id: "prompt-competitor-link.prompt-whiteboard.success-flag-description",
        defaultMessage: "The whiteboard has been created in the tree. Go to the whiteboard to move its location or change its permissions."
    },
    successFlagAction: {
        id: "prompt-competitor-link.prompt-whiteboard.success-flag-action",
        defaultMessage: "Go to whiteboard"
    },
    createdFlagTitle: {
        id: "prompt-competitor-link.prompt-whiteboard.created-flag-title",
        defaultMessage: "Whiteboard successfully created"
    },
    createdFlagDescription: {
        id: "prompt-competitor-link.prompt-whiteboard.created-flag-description",
        defaultMessage: "This whiteboard was created as a child item of the content you were working on."
    },
    createdFlagAction: {
        id: "prompt-competitor-link.prompt-whiteboard.created-flag-action",
        defaultMessage: "Go back to previous content"
    },
    defaultErrorFlagTitle: {
        id: "prompt-competitor-link.prompt-whiteboard.default-error-flag-title",
        defaultMessage: "We\u2019re unable to create right now"
    },
    defaultErrorFlagDescription: {
        id: "prompt-competitor-link.prompt-whiteboard.default-error-flag-description",
        defaultMessage: "Refresh or wait a few minutes and try again. If this keeps happening, contact support."
    }
});






var $6B0jU = parcelRequire("6B0jU");


/* PromptContent.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $iXCQx = parcelRequire("iXCQx");


var $1s5hv = parcelRequire("1s5hv");


var $cO1el = parcelRequire("cO1el");


var $lE8sM = parcelRequire("lE8sM");


var $i7jPX = parcelRequire("i7jPX");


var $9VJDA = parcelRequire("9VJDA");








var $9wGTI = parcelRequire("9wGTI");

/* DismissComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 











const $b04ce10a80ad12d8$var$styles = {
    dismissPressable: "_bfhk1bhr _ca0qpxbi _n3tdpxbi _19bv1ejb _u5f31ejb"
};
const $b04ce10a80ad12d8$export$d83330dc6e78fd41 = ({ dismissMessage: dismissMessage, onDismiss: onDismiss })=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: $b04ce10a80ad12d8$var$styles.dismissPressable,
        onClick: onDismiss,
        testId: "competitor-link-prompt-dismiss-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, intl.formatMessage(dismissMessage)));
};


const $1a72f80624178457$var$styles = {
    iconContainer: "_zulppxbi",
    titleContainer: "_1bah1yb4 _4cvr1h6o _1bsb1osq",
    popupBox: "_18s8pxbi _1bsb1gwv",
    popupDescription: "_19pku2gc _otyrpxbi",
    textContainer: "_1e0c1txw _2lx21bp4 _4cvr1y6m _ca0qv77o _n3tdv77o",
    ctaStyles: "_1yt4ze3t _18s8ze3t _4bfu1r31 _1hms8stv _ajmmnqa1 _11c8fhey _syaz13af _bfhk1j28 _9oik1r31 _1bnxglyw _jf4cnqa1",
    showMoreIcon: "_bfhksm61"
};
const $1a72f80624178457$export$500652e4aa00ed2f = ({ titleText: titleText, descriptionText: descriptionText, ctaText: ctaText, dismissText: dismissText, contentIcon: ContentIcon, iconColor: iconColor, iconAltText: iconAltText, onClickAction: onClickAction, contentType: contentType, onDismiss: onDismiss, competitorName: competitorName, linkType: linkType, editorAppearance: editorAppearance, pageAnalyticsAttributes: pageAnalyticsAttributes })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isDismissMenuOpen, setIsDismissMenuOpen] = (0, $42omo.useState)(false);
    const handleMoreMenuClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptMoreMenu',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    editorAppearance: editorAppearance,
                    ...pageAnalyticsAttributes
                }
            }
        }).fire();
        setIsDismissMenuOpen(!isDismissMenuOpen);
    };
    const handleDismissClose = ()=>{
        setIsDismissMenuOpen(false);
    };
    const dismissPopup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.Popup), {
        shouldRenderToParent: false,
        isOpen: isDismissMenuOpen,
        onClose: handleDismissClose,
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b04ce10a80ad12d8$export$d83330dc6e78fd41), {
                dismissMessage: dismissText,
                onDismiss: ()=>{
                    onDismiss();
                    handleDismissClose();
                }
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
                ...triggerProps,
                xcss: $1a72f80624178457$var$styles.showMoreIcon,
                onClick: handleMoreMenuClick,
                testId: "competitor-link-prompt-dismiss-menu"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                label: intl.formatMessage(dismissText),
                size: "medium"
            }))
    });
    const titleSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $1a72f80624178457$var$styles.titleContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall"
    }, intl.formatMessage(titleText)), dismissPopup);
    const contentSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $1a72f80624178457$var$styles.popupDescription
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, intl.formatMessage(descriptionText, {
        competitorName: competitorName
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        onClick: onClickAction,
        xcss: $1a72f80624178457$var$styles.ctaStyles
    }, intl.formatMessage(ctaText, {
        competitorName: competitorName
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $1a72f80624178457$var$styles.popupBox,
        testId: "competitor-link-prompt-popup"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $1a72f80624178457$var$styles.iconContainer
    }, (0, $9wGTI.fg)('confluence_frontend_tile_object_system_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
        key: `${contentType}Icon`,
        testId: `competitor-link-prompt-content-tile-${contentType}`,
        label: intl.formatMessage(iconAltText),
        backgroundColor: contentType === 'database' ? 'color.background.accent.purple.subtle' : 'color.background.accent.teal.subtle',
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ContentIcon, {
        size: "small",
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lE8sM.default), {
        key: `${contentType}Icon`,
        icon: ContentIcon,
        label: intl.formatMessage(iconAltText),
        appearance: iconColor,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $1a72f80624178457$var$styles.textContainer
    }, titleSection, contentSection)));
};



const $a45e7248769652ec$export$8861fc80ccc7c678 = ({ competitorName: competitorName, linkType: linkType, editorAppearance: editorAppearance, onClickAction: onClickAction, onDismiss: onDismiss })=>{
    const pageAnalyticsAttributes = (0, $48b719f4930c6be4$export$c2b5ddd2c8b4a98c)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1a72f80624178457$export$500652e4aa00ed2f), {
        titleText: (0, $ff137fb7addc2b15$export$a7357cdd1f0b0168).titleDatabase,
        descriptionText: (0, $ff137fb7addc2b15$export$a7357cdd1f0b0168).descriptionDefaultDatabase,
        ctaText: (0, $ff137fb7addc2b15$export$a7357cdd1f0b0168).createButtonDefaultDatabase,
        dismissText: (0, $ff137fb7addc2b15$export$a7357cdd1f0b0168).dismissButtonDatabase,
        contentIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        iconColor: "purpleBold",
        iconAltText: (0, $ff137fb7addc2b15$export$a7357cdd1f0b0168).databaseIconAltText,
        onClickAction: onClickAction,
        contentType: "database",
        onDismiss: onDismiss,
        competitorName: competitorName,
        linkType: linkType,
        editorAppearance: editorAppearance,
        pageAnalyticsAttributes: pageAnalyticsAttributes
    });
};






var $ZDq1z = parcelRequire("ZDq1z");




const $3309093763baedfe$export$f9c9b82deaeecce8 = ({ competitorName: competitorName, linkType: linkType, editorAppearance: editorAppearance, displayImportCta: displayImportCta, onClickAction: onClickAction, onDismiss: onDismiss })=>{
    const pageAnalyticsAttributes = (0, $48b719f4930c6be4$export$c2b5ddd2c8b4a98c)();
    // Determine content based on import CTA
    const descriptionText = displayImportCta ? (0, $6bf1a4c43dd25981$export$a7357cdd1f0b0168).descriptionImportWhiteboard : (0, $6bf1a4c43dd25981$export$a7357cdd1f0b0168).descriptionDefaultWhiteboard;
    const ctaText = displayImportCta ? (0, $6bf1a4c43dd25981$export$a7357cdd1f0b0168).createButtonImportWhiteboard : (0, $6bf1a4c43dd25981$export$a7357cdd1f0b0168).createButtonDefaultWhiteboard;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1a72f80624178457$export$500652e4aa00ed2f), {
        titleText: (0, $6bf1a4c43dd25981$export$a7357cdd1f0b0168).titleWhiteboard,
        descriptionText: descriptionText,
        ctaText: ctaText,
        dismissText: (0, $6bf1a4c43dd25981$export$a7357cdd1f0b0168).dismissButton,
        contentIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        iconColor: "tealBold",
        iconAltText: (0, $6bf1a4c43dd25981$export$a7357cdd1f0b0168).whiteboardIconAltText,
        onClickAction: onClickAction,
        contentType: "whiteboard",
        onDismiss: onDismiss,
        competitorName: competitorName,
        linkType: linkType,
        editorAppearance: editorAppearance,
        pageAnalyticsAttributes: pageAnalyticsAttributes
    });
};


const $02f57d39ae5b5c3c$var$styles = {
    pressable: "_1yt41b66 _2rko12b0 _1bsb1tcg _4t3i1tcg",
    pressableClosed: "_bfhkp2ly _irr3kca2",
    pressableOpen: "_1a37fqqo _bfhkkca2 _1cwg1i6y"
};
const $02f57d39ae5b5c3c$var$CREATE_CONTENT_INLINE = (0, $c29180730df60abf$export$2e2bcd8739ae039);
const $02f57d39ae5b5c3c$var$PAYWALL_CONTENT_TO_DISABLE = (0, $e21fff8b5a3f62da$export$2e2bcd8739ae039);
const $02f57d39ae5b5c3c$var$CONTENT_TYPE_URL_FUNCTIONS = {
    whiteboard: (0, $fhofE.getFullWhiteboardUrl),
    database: (0, $ccP7J.getFullDatabaseUrl)
};
const $02f57d39ae5b5c3c$var$IMPORTER_COMPETITORS = [
    'miro',
    'mural'
];
const $02f57d39ae5b5c3c$var$CONTENT_TYPE_ONBOARDING_KEYS = {
    whiteboard: (0, $dBcar.PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED).PROMPT_DISMISSED,
    database: (0, $dBcar.PROMPT_DATABASE_COMPETITOR_LINK).DISMISSED
};
const $02f57d39ae5b5c3c$var$PromptComponent = ({ competitorName: competitorName, linkType: linkType, contentType: contentType, editorAppearance: editorAppearance })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const spaceKey = (0, $cLo2u.useSpaceKey)() || '';
    const [currentPageId] = (0, $ep3mz.usePageContentId)();
    const [currentContentType] = (0, $ep3mz.useContentType)();
    const homepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey); // Blogs cannot have child content, so fall back to space homepage
    const parentContentId = currentContentType === 'blogpost' ? homepageId : currentPageId;
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const pageAnalyticsAttributes = (0, $48b719f4930c6be4$export$c2b5ddd2c8b4a98c)();
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const isImport = $02f57d39ae5b5c3c$var$IMPORTER_COMPETITORS.some((competitor)=>competitorName?.toLowerCase().includes(competitor));
    const { data: paywallData, loading: paywallContentLoading } = (0, $jMyy4.useQueryInterop)($02f57d39ae5b5c3c$var$PAYWALL_CONTENT_TO_DISABLE, {
        skip: contentType !== 'whiteboard' || !isImport || edition === (0, $euL71.ConfluenceEdition).PREMIUM,
        fetchPolicy: 'no-cache',
        __callerPackage__: "@confluence/prompt-competitor-link"
    });
    const paywallContentToDisable = paywallData?.paywallContentToDisable;
    const displayWbImportCta = contentType === 'whiteboard' && isImport && !paywallContentLoading && !(paywallContentToDisable?.deactivationIdentifier && paywallContentToDisable?.link && paywallContentToDisable?.title);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptPopup',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    isImport: displayWbImportCta ? 'true' : 'false',
                    editorAppearance: editorAppearance,
                    ...pageAnalyticsAttributes
                },
                nonPrivacySafeAttributes: {
                    linkDomain: competitorName,
                    linkContentType: contentType,
                    linkType: linkType,
                    isImport: displayWbImportCta ? 'true' : 'false'
                }
            }
        }).fire();
    }, [
        competitorName,
        createAnalyticsEvent,
        linkType,
        pageAnalyticsAttributes,
        displayWbImportCta,
        contentType,
        editorAppearance
    ]);
    const [createContentInline, { loading: createContentLoading }] = (0, $308Wd.useMutationInterop)($02f57d39ae5b5c3c$var$CREATE_CONTENT_INLINE, {
        onCompleted: (data)=>{
            const contentId = data?.createContentInline?.id;
            if (!contentId) throw Error('no content id present');
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'createdByFlow',
                    actionSubject: 'content',
                    objectId: contentId,
                    objectType: contentType,
                    containerId: spaceKey,
                    containerType: 'space',
                    source: 'competitorLink',
                    attributes: {
                        flow: 'competitorLink',
                        contentType: contentType,
                        linkType: linkType,
                        isImport: displayWbImportCta ? 'true' : 'false',
                        editorAppearance: editorAppearance,
                        ...pageAnalyticsAttributes
                    },
                    nonPrivacySafeAttributes: {
                        linkDomain: competitorName
                    }
                }
            }).fire();
            setOnboardingState({
                key: $02f57d39ae5b5c3c$var$CONTENT_TYPE_ONBOARDING_KEYS[contentType],
                value: 'true'
            });
            const urlFunction = $02f57d39ae5b5c3c$var$CONTENT_TYPE_URL_FUNCTIONS[contentType]; // check valid content type
            if (urlFunction) {
                let url = urlFunction(contentId, spaceKey);
                if (displayWbImportCta) {
                    const urlObj = new URL(url);
                    const searchParams = new URLSearchParams(urlObj.search);
                    searchParams.set(`open${competitorName}ImportTool`, 'true');
                    urlObj.search = searchParams.toString();
                    url = urlObj.toString();
                }
                window.open(url, '_blank', 'noreferrer, noopener');
                showFlag?.({
                    id: 'competitor-link-success-flag',
                    title: intl.formatMessage(contentType === 'database' ? (0, $ff137fb7addc2b15$export$a7357cdd1f0b0168).successFlagTitle : (0, $6bf1a4c43dd25981$export$a7357cdd1f0b0168).successFlagTitle),
                    description: intl.formatMessage(contentType === 'database' ? (0, $ff137fb7addc2b15$export$a7357cdd1f0b0168).successFlagDescription : (0, $6bf1a4c43dd25981$export$a7357cdd1f0b0168).successFlagDescription),
                    isAutoDismiss: false,
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                        color: "var(--ds-icon-success, #6A9A23)",
                        label: "success"
                    }),
                    actions: [
                        {
                            content: intl.formatMessage(contentType === 'database' ? (0, $ff137fb7addc2b15$export$a7357cdd1f0b0168).successFlagAction : (0, $6bf1a4c43dd25981$export$a7357cdd1f0b0168).successFlagAction),
                            href: url,
                            onClick: ()=>{
                                createAnalyticsEvent({
                                    type: 'sendUIEvent',
                                    data: {
                                        action: 'clicked',
                                        actionSubject: 'competitorLinkPrompt',
                                        actionSubjectId: 'contentSuccessFlagAction',
                                        source: 'competitorLink',
                                        attributes: {
                                            linkContentType: contentType,
                                            linkType: linkType,
                                            ...pageAnalyticsAttributes
                                        }
                                    }
                                }).fire();
                            }
                        }
                    ]
                });
            }
        },
        __callerPackage__: "@confluence/prompt-competitor-link"
    });
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptDismiss',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    editorAppearance: editorAppearance,
                    ...pageAnalyticsAttributes
                }
            }
        }).fire();
        setOnboardingState({
            key: $02f57d39ae5b5c3c$var$CONTENT_TYPE_ONBOARDING_KEYS[contentType],
            value: 'true'
        });
    }, [
        setOnboardingState,
        contentType,
        createAnalyticsEvent,
        linkType,
        editorAppearance,
        pageAnalyticsAttributes
    ]);
    const handleLinkClick = async ()=>{
        if (createContentLoading || !parentContentId) return;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'clicked',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'createButton',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    isImport: displayWbImportCta ? 'true' : 'false',
                    editorAppearance: editorAppearance,
                    ...pageAnalyticsAttributes
                },
                nonPrivacySafeAttributes: {
                    linkDomain: competitorName,
                    linkContentType: contentType,
                    linkType: linkType,
                    isImport: displayWbImportCta ? 'true' : 'false'
                }
            }
        }).fire();
        await createContentInline({
            variables: {
                createdInContentId: parentContentId,
                spaceKey: spaceKey,
                type: contentType
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, contentType === 'database' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a45e7248769652ec$export$8861fc80ccc7c678), {
        competitorName: competitorName,
        linkType: linkType,
        editorAppearance: editorAppearance,
        onClickAction: handleLinkClick,
        onDismiss: handleDismiss
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3309093763baedfe$export$f9c9b82deaeecce8), {
        competitorName: competitorName,
        linkType: linkType,
        editorAppearance: editorAppearance,
        displayImportCta: displayWbImportCta,
        onClickAction: handleLinkClick,
        onDismiss: handleDismiss
    }));
};
const $02f57d39ae5b5c3c$export$79356a2b3ed5a31d = ({ competitorName: competitorName, linkType: linkType, contentType: contentType, editorAppearance: editorAppearance })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const pageAnalyticsAttributes = (0, $48b719f4930c6be4$export$c2b5ddd2c8b4a98c)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptIcon',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    editorAppearance: editorAppearance,
                    ...pageAnalyticsAttributes
                },
                nonPrivacySafeAttributes: {
                    linkDomain: competitorName
                }
            }
        }).fire();
    }, [
        competitorName,
        createAnalyticsEvent,
        linkType,
        pageAnalyticsAttributes,
        contentType,
        editorAppearance
    ]);
    const handlePromptPopupClose = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'closed',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptPopup',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    editorAppearance: editorAppearance,
                    ...pageAnalyticsAttributes
                }
            }
        }).fire();
        setIsOpen(false);
    }, [
        createAnalyticsEvent,
        linkType,
        pageAnalyticsAttributes,
        contentType,
        editorAppearance
    ]);
    const handlePromptPopupClick = (0, $42omo.useCallback)(()=>{
        if (isOpen) handlePromptPopupClose();
        else {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'competitorLinkPrompt',
                    actionSubjectId: 'promptIcon',
                    source: 'competitorLink',
                    attributes: {
                        linkContentType: contentType,
                        linkType: linkType,
                        editorAppearance: editorAppearance,
                        ...pageAnalyticsAttributes
                    }
                }
            }).fire();
            setIsOpen(!isOpen);
        }
    }, [
        createAnalyticsEvent,
        handlePromptPopupClose,
        isOpen,
        linkType,
        pageAnalyticsAttributes,
        contentType,
        editorAppearance
    ]);
    return(// TODO: Add `shouldRenderToParent = true` to make popup experience accessible. See https://a11y.atlassian.net/browse/JCATS-788
    // shouldRenderToParent currently forced to false to prevent popup from being rendered in the wrong place
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.Popup), {
        shouldRenderToParent: false,
        isOpen: isOpen,
        onClose: handlePromptPopupClose,
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($02f57d39ae5b5c3c$var$PromptComponent, {
                competitorName: competitorName,
                linkType: linkType,
                contentType: contentType
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
                ...triggerProps,
                onClick: handlePromptPopupClick,
                xcss: (0, $1Whri.cx)($02f57d39ae5b5c3c$var$styles.pressable, isOpen ? $02f57d39ae5b5c3c$var$styles.pressableOpen : $02f57d39ae5b5c3c$var$styles.pressableClosed),
                testId: "competitor-link-prompt-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3HOqx))), {
                color: "var(--ds-icon-discovery, #AF59E1)",
                label: intl.formatMessage(contentType === 'database' ? (0, $ff137fb7addc2b15$export$a7357cdd1f0b0168).titleDatabase : (0, $6bf1a4c43dd25981$export$a7357cdd1f0b0168).titleWhiteboard)
            }))
    }));
};


const $ded78f64c507c664$var$styles = {
    promptContainer: "_1e0c116y _4cvr1h6o _2hwxv77o _18u0v77o"
};
const $ded78f64c507c664$var$VALID_LINK_TYPES = [
    'inline',
    'card',
    'embed'
];
const $ded78f64c507c664$var$WHITEBOARD_COMPETITORS = [
    {
        name: 'Miro',
        domains: [
            /miro\.com/i
        ]
    },
    {
        name: 'Mural',
        domains: [
            /mural\.co/i
        ]
    },
    {
        name: 'Lucid',
        domains: [
            /lucid\.co/i,
            /lucid\.app/i
        ]
    },
    {
        name: 'Microsoft Whiteboard',
        domains: [
            /whiteboard\.office\.com/i,
            /wbd\.ms/i,
            /whiteboard\.cloud\.microsoft/i
        ]
    },
    {
        name: 'Figjam',
        domains: [
            /figma\.com\/board/i
        ]
    },
    {
        name: 'Google Jamboard',
        domains: [
            /jamboard\.google\.com/i
        ]
    },
    // Note: Google Jamboard is EOL
    {
        name: 'Excalidraw',
        domains: [
            /excalidraw\.com/i
        ]
    },
    {
        name: 'Klaxoon',
        domains: [
            /klaxoon\.com/i
        ]
    }
];
const $ded78f64c507c664$var$getCompetitorContentType = (whiteboardCompetitorName, databaseCompetitorName)=>{
    if (whiteboardCompetitorName) return 'whiteboard';
    if (databaseCompetitorName) return 'database';
    return undefined;
};
const $ded78f64c507c664$var$PromptPopupContainerInner = ({ sourceUrl: sourceUrl, linkType: linkType, editorAppearance: editorAppearance })=>{
    const { data: onboardingStateData, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED).PROMPT_DISMISSED,
        (0, $dBcar.PROMPT_DATABASE_COMPETITOR_LINK).DISMISSED
    ], false // skip
    );
    const { isPromptDismissed: isPromptWhiteboardDismissed, isPromptDatabaseDismissed: isPromptDatabaseDismissed } = (0, $ivb8S.deserializeState)(onboardingStateData); // Whiteboard competitor eligibility check
    // isCreateWhiteboardEnabled checks if whiteboards are enabled for the space
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const { isCreateWhiteboardEnabled: isCreateWhiteboardEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey ?? undefined); // isWhiteboardFeatureEnabled allows us to check if particular "whiteboard features" are enabled
    // in this case, we are checking if the entire "whiteboard feature" is enabled AND not opted out
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isWhiteboardsEnabled = isWhiteboardFeatureEnabled('whiteboardsEnabled'); // useIsAllowedToCreateWhiteboard checks user permissions to create a whiteboard
    const isAllowedToCreateWhiteboard = (0, $eVXGa.useIsAllowedToCreateWhiteboard)();
    const isEligibleCreateNewWhiteboard = isCreateWhiteboardEnabled && isWhiteboardsEnabled && isAllowedToCreateWhiteboard;
    const whiteboardCompetitor = $ded78f64c507c664$var$WHITEBOARD_COMPETITORS.find((competitor)=>competitor.domains.some((regex)=>regex.test(sourceUrl)));
    const whiteboardCompetitorName = isEligibleCreateNewWhiteboard ? whiteboardCompetitor?.name : undefined;
    const { databaseCompetitorName: databaseCompetitorName } = (0, $623af4b4cfb0b8c1$export$42c019d1a8a7c555)(sourceUrl);
    const competitorContentType = $ded78f64c507c664$var$getCompetitorContentType(whiteboardCompetitorName, databaseCompetitorName);
    const competitorName = whiteboardCompetitorName || databaseCompetitorName;
    if (!competitorContentType || !competitorName) return null;
    const validLinkType = linkType && $ded78f64c507c664$var$VALID_LINK_TYPES.includes(linkType) ? linkType : undefined;
    const contentTypeConfig = {
        database: {
            isFeatureEnabled: ()=>(0, $6mKj3.expValEquals)('cc_fd_prompt_database_competitor_link', 'cohort', 'experiment'),
            isDismissed: isPromptDatabaseDismissed
        },
        whiteboard: {
            // config to exclude tenants or users from the feature
            // if not excluded, `cc_fd_prompt_competitor_link_config` will return `true`
            // `true` is the default value
            isFeatureEnabled: ()=>(0, $1xpoY.default).getBoolean('cc_fd_prompt_competitor_link_config', true),
            isDismissed: isPromptWhiteboardDismissed
        }
    };
    const { isFeatureEnabled: isFeatureEnabled, isDismissed: isDismissed } = contentTypeConfig[competitorContentType];
    return !loading && !error && !isDismissed && isFeatureEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ded78f64c507c664$var$styles.promptContainer,
        "data-vc": "competitor-link-prompt"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $02f57d39ae5b5c3c$export$79356a2b3ed5a31d), {
        competitorName: competitorName,
        linkType: validLinkType,
        contentType: competitorContentType,
        editorAppearance: editorAppearance
    }));
};
const $ded78f64c507c664$export$342f0658478a7894 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ded78f64c507c664$var$PromptPopupContainerInner, props));
module.exports["PromptPopupContainer"] = $ded78f64c507c664$export$342f0658478a7894;

});

parcelRegister("fhofE", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $db55d2db1b1085cb$var$BASE_URL_META_SELECTOR = "meta[name='confluence-base-url']";
const $db55d2db1b1085cb$var$getBaseUrlForLocalhost = ()=>{
    const baseUrlFromMeta = window.document.querySelector($db55d2db1b1085cb$var$BASE_URL_META_SELECTOR)?.getAttribute('content') ?? 'https://hello.atlassian.net/wiki';
    return baseUrlFromMeta.substring(0, baseUrlFromMeta.length - 5);
};
const $db55d2db1b1085cb$export$f654b28f82155665 = ()=>{
    if (typeof window.location === 'undefined') return '';
    const baseUrl = window.location.origin;
    // If we are in localhost, we use the base URL from the meta tag
    if (new URL(baseUrl).hostname === 'localhost') return $db55d2db1b1085cb$var$getBaseUrlForLocalhost();
    return baseUrl;
};
const $db55d2db1b1085cb$export$420f191ed44b660f = (contentId, spaceKey)=>`${$db55d2db1b1085cb$export$f654b28f82155665()}${(0, $1NBp8.WHITEBOARD_BOARD).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    })}`;
module.exports["getFullWhiteboardUrl"] = $db55d2db1b1085cb$export$420f191ed44b660f;

});

parcelRegister("ccP7J", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $3jQ9y = parcelRequire("3jQ9y");


var $6B0jU = parcelRequire("6B0jU");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $1NBp8 = parcelRequire("1NBp8");


var $jn9ek = parcelRequire("jn9ek");


var $irVI7 = parcelRequire("irVI7");


var $aJPUt = parcelRequire("aJPUt");


var $ge2sX = parcelRequire("ge2sX");


var $f7i8j = parcelRequire("f7i8j");

/**
 * @generated SignedSource<<b4de7216f1956b4f6d564d048c80f4fe>>
 * @relayHash d5b3b486626d032523668447f933702e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 354c0b2036d906d7ae2e966f47ff191e75d1623b0c463a838a7bb5cb00d40947
const $9aada210960f84b9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "createdInContentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "createdInContentId",
                            "variableName": "createdInContentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        },
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "database"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "createContentInline",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CreateContentInlineMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CreateContentInlineMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d5b3b486626d032523668447f933702e",
            "id": "354c0b2036d906d7ae2e966f47ff191e75d1623b0c463a838a7bb5cb00d40947",
            "metadata": {},
            "name": "CreateContentInlineMutation",
            "operationKind": "mutation",
            "text": "mutation CreateContentInlineMutation($createdInContentId:ID!,$spaceKey:String){createContentInline(input:{createdInContentId:$createdInContentId,spaceKey:$spaceKey,type:\"database\"}){id}}"
        }
    };
}();
$9aada210960f84b9$var$node.hash = "9d349e804d611298aa425de2f3bfd42a";
var $9aada210960f84b9$export$2e2bcd8739ae039 = $9aada210960f84b9$var$node;






var $jhwJP = parcelRequire("jhwJP");

const $7c2c9699294e7927$var$i18nBase = (0, $aXWIB.defineMessages)({
    manifestDescription: {
        id: "confluence-databases-extension.description",
        defaultMessage: "Create an empty database table"
    },
    manifestTitle: {
        id: "confluence-databases-extension.title",
        defaultMessage: "Database extension"
    },
    createDatabaseTitle: {
        id: "confluence-databases-extension.create-database.title",
        defaultMessage: "New database"
    },
    createDatabaseDescription: {
        id: "confluence-databases-extension.create-database.description",
        defaultMessage: "Create an empty database table"
    },
    referenceDatabaseTitle: {
        id: "confluence-databases-extension.reference-database.title",
        defaultMessage: "Embed database"
    },
    referenceDatabaseDescription: {
        id: "confluence-databases-extension.reference-database.description",
        defaultMessage: "Display an existing database, entry, or value"
    },
    referenceDatabaseModalLabel: {
        id: "confluence-databases-extension.reference-database.modal-label",
        defaultMessage: "Reference database modal"
    },
    createDatabaseIconAltText: {
        id: "confluence-databases-extension.create-database.icon-alt-text",
        defaultMessage: "Create database icon"
    },
    referenceDatabaseIconAltText: {
        id: "confluence-databases-extension.reference-database.icon-alt-text",
        defaultMessage: "Reference database icon"
    },
    successFlagTitle: {
        id: "confluence-databases-extension.success-flag.title",
        defaultMessage: "Database added under this content "
    },
    successFlagAction: {
        id: "confluence-databases-extension.success-flag.action",
        defaultMessage: "Open database in new tab"
    },
    successFlagDescription: {
        id: "confluence-databases-extension.success-flag.description",
        defaultMessage: "To view this database in full and edit it with ease, open it in a new tab."
    },
    defaultErrorFlagTitle: {
        id: "confluence-databases-extension.error-flag.title",
        defaultMessage: "We\u2019re unable to create right now"
    },
    defaultErrorFlagDescription: {
        id: "confluence-databases-extension.error-flag.description",
        defaultMessage: "Refresh or wait a few minutes and try again. If this keeps happening, contact support."
    },
    parentPageMovedErrorTitle: {
        id: "confluence-databases-extension.error.parent-page-moved-error-title",
        defaultMessage: "The parent has moved"
    },
    parentPageMovedErrorDescription: {
        id: "confluence-databases-extension.error.parent-page-moved-error-description",
        defaultMessage: "Refresh to create in the new location."
    },
    permissionRemovedErrorTitle: {
        id: "confluence-databases-extension.error.permission-removed-error-title",
        defaultMessage: "We\u2019re unable to create this content"
    },
    permissionRemovedErrorDescription: {
        id: "confluence-databases-extension.error.permission-removed-error-description",
        defaultMessage: "You don\u2019t have permission to create here or the space has been recently deleted."
    },
    invalidParentErrorTitle: {
        id: "confluence-databases-extension.error.invalid-parent-error-title",
        defaultMessage: "We can\u2019t create a database"
    },
    invalidParentErrorDescription: {
        id: "confluence-databases-extension.error.invalid-parent-error-description",
        defaultMessage: "This page was deleted or archived. You can create a database on a different page."
    },
    databaseDefaultTitle: {
        id: "confluence-databases-extension.database-default.title",
        defaultMessage: "Database"
    },
    databaseDefaultDescription: {
        id: "confluence-databases-extension.database-default.description",
        defaultMessage: "Create a database to organize and sync info"
    },
    databaseDefaultIconAltText: {
        id: "confluence-databases-extension.database-default.icon-alt-text",
        defaultMessage: "Database icon"
    }
});
const $7c2c9699294e7927$var$i18nLiveDocs = (0, $aXWIB.defineMessages)({
    invalidParentErrorDescription: {
        id: "confluence-databases-extension.error.invalid-parent-error-description.livedocs",
        defaultMessage: "This item was deleted or archived. You can create a database on a different page or live doc."
    }
});
const $7c2c9699294e7927$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($7c2c9699294e7927$var$i18nBase, $7c2c9699294e7927$var$i18nLiveDocs);


var $bc87b26567284590$exports = {};
$bc87b26567284590$exports = new URL("InlineCreateIcon.2a8cad4b.svg", import.meta.url).toString();


var $c7f5a98f0ee5cc1e$exports = {};
$c7f5a98f0ee5cc1e$exports = new URL("InlineEmbedIcon.eb3ad338.svg", import.meta.url).toString();






var $8CZUH = parcelRequire("8CZUH");


var $9ot3w = parcelRequire("9ot3w");


var $d8eRd = parcelRequire("d8eRd");


var $6xdDU = parcelRequire("6xdDU");


var $bQm3c = parcelRequire("bQm3c");









var $2LONO = parcelRequire("2LONO");


var $7J5Uc = parcelRequire("7J5Uc");

const $e8cbe0a1e77b1d69$export$3f6d3dddadd0c944 = ()=>{
    const params = new URLSearchParams(window.location.search);
    const version = params.get('databases-frontend') || undefined;
    const [{ theme: theme }] = (0, $7J5Uc.useThemingState)();
    return (0, $42omo.useMemo)(()=>{
        const url = new URL('/databases/standalone', window.location.origin);
        if (version) url.searchParams.set('bifrost-override', version);
        if (theme) {
            url.pathname = `${url.pathname}/${theme.colorMode === 'dark' ? 'index-dark.html' : 'index.html'}`;
            url.searchParams.set('themeState', encodeURIComponent((0, $2LONO.themeObjectToString)(theme)));
        }
        url.searchParams.set('referencing', 'true');
        url.searchParams.set('parentProduct', 'smartLink');
        const finalUrlParts = [
            url.pathname
        ];
        if (Array.from(url.searchParams).length > 0) finalUrlParts.push(url.searchParams.toString());
        return finalUrlParts.join('?');
    }, [
        version,
        theme
    ]);
};


/**
 * @generated SignedSource<<2ee8713375fb79b28b48377dd2066673>>
 * @relayHash d74c02bb5f354ff3819d9b43f86431af
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e60df62ac017064af1e7d578c6fe1bed7115af17de2be761e182f801b2162514
const $005429b0440abbd3$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "isPrimary"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": v0 /*: any*/ 
                },
                {
                    "concreteType": "AtlassianUserEmail",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": v0 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "locale"
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "DatabaseReferenceModalCurrentUserQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "DatabaseReferenceModalCurrentUserQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d74c02bb5f354ff3819d9b43f86431af",
            "id": "e60df62ac017064af1e7d578c6fe1bed7115af17de2be761e182f801b2162514",
            "metadata": {},
            "name": "DatabaseReferenceModalCurrentUserQuery",
            "operationKind": "query",
            "text": "query DatabaseReferenceModalCurrentUserQuery{user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary},emails{value,isPrimary},locale}}"
        }
    };
}();
$005429b0440abbd3$var$node.hash = "da5e7e584d6c779f02f908f5482b3187";
var $005429b0440abbd3$export$2e2bcd8739ae039 = $005429b0440abbd3$var$node;


/* DatabaseReferenceModalSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $kpYGL = parcelRequire("kpYGL");


var $eyWa4 = parcelRequire("eyWa4");


var $u9agA = parcelRequire("u9agA");

const $c190662e98183b48$var$skeletonStyles = {
    embedReferenceContainer: "_1rjcu2gc _18zr1ejb",
    placeholderContainer: "_1bsb1osq _4t3irdnh",
    placeholderText: "_1bsb1osq",
    footerContainer: "_n3td1ejb"
};
const $c190662e98183b48$export$c5d436bba21e5326 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        xcss: $c190662e98183b48$var$skeletonStyles.embedReferenceContainer,
        space: "space.200",
        testId: "reference-database-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.150",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        width: 240,
        height: 40,
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        width: 240,
        height: 40,
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        width: 240,
        height: 40,
        borderRadius: "var(--ds-radius-small, 4px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        alignBlock: "center",
        alignInline: "center",
        space: "space.400",
        xcss: $c190662e98183b48$var$skeletonStyles.placeholderContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        width: 108,
        height: 108,
        borderRadius: "var(--ds-radius-full, 9999px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        width: 316,
        height: 14,
        borderRadius: 18
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignInline: "end",
        space: "space.100",
        xcss: $c190662e98183b48$var$skeletonStyles.footerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        width: 61,
        height: 32,
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        width: 61,
        height: 32,
        borderRadius: "var(--ds-radius-small, 4px)"
    })));
};



var $c0rhi = parcelRequire("c0rhi");

const $dc4f221a49e0d4ac$var$isDatabaseUrl = (value)=>/database\/\d+/.test(value);
const $dc4f221a49e0d4ac$export$8480276ebb3b339b = ({ onClose: onClose, intl: intl })=>{
    const iframeRef = (0, $42omo.useRef)(null);
    const [identity, setIdentity] = (0, $42omo.useState)(null);
    const { activationId: activationId, userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const initialUrl = (0, $e8cbe0a1e77b1d69$export$3f6d3dddadd0c944)();
    const [isLoading, setIsLoading] = (0, $42omo.useState)(true);
    (0, $42omo.useEffect)(()=>{
        (0, $c0rhi.queryInterop)({
            query: (0, $005429b0440abbd3$export$2e2bcd8739ae039),
            __callerPackage__: "@confluence/confluence-databases-extension"
        }).then(({ data: data })=>{
            setIdentity({
                accountId: data?.user?.id,
                nickname: data?.user?.displayName,
                picture: data?.user?.photos?.find((photo)=>photo?.isPrimary)?.value,
                email: data?.user?.emails?.find((email)=>email?.isPrimary)?.value,
                locale: data?.user?.locale
            });
        });
    }, []);
    const bridgeData = {
        cloudId: cloudId,
        activationId: activationId,
        userId: userId,
        identity: identity
    };
    const messageCallback = (0, $42omo.useCallback)((event)=>{
        const isFromExpectedIframe = iframeRef.current && event.source === iframeRef.current.contentWindow;
        if (isFromExpectedIframe) try {
            const data = JSON.parse(event.data);
            if (data.finalDatabaseUrl && $dc4f221a49e0d4ac$var$isDatabaseUrl(data.finalDatabaseUrl)) onClose(data.finalDatabaseUrl);
            else if (data.cancelDatabaseReference) onClose(undefined);
            else if (data.databaseReferencingComponentLoaded) setIsLoading(false);
        } catch  {}
    }, [
        onClose,
        iframeRef
    ]);
    (0, $42omo.useEffect)(()=>{
        window.addEventListener('message', messageCallback);
        return ()=>{
            window.removeEventListener('message', messageCallback);
        };
    }, [
        messageCallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        width: 1200,
        height: 592,
        onClose: ()=>onClose(undefined),
        testId: "reference-database-modal",
        label: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).referenceDatabaseModalLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).referenceDatabaseTitle))), isLoading || !identity ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c190662e98183b48$export$c5d436bba21e5326), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("iframe", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: '505px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            border: (0, $9wGTI.fg)('confluence_frontend_tokenize_border') ? "var(--ds-space-0, 0px)" : '0px',
            display: !isLoading && identity ? 'block' : 'none'
        },
        src: initialUrl,
        ...identity ? {
            'data-bridge-data': JSON.stringify(bridgeData)
        } : {},
        title: "reference-database-frame",
        ref: iframeRef
    })));
};






var $9hlns = parcelRequire("9hlns");








/**
 * @generated SignedSource<<b035fda6a872ab7331ba8bc85786fd7e>>
 * @relayHash 40826fc58666f6735d9c7867264a488a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 419c5723846b6b093ae72cf841f1af5f13d93a23b4eb82a119b57a7dfb9b71c4
const $3c3a42cef99017de$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "isPrimary"
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "referenceId"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": v2 /*: any*/ 
                },
                {
                    "concreteType": "AtlassianUserEmail",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": v2 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "locale"
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "DatabaseValueContainerContentUnifiedQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "DatabaseValueContainerContentUnifiedQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "40826fc58666f6735d9c7867264a488a",
            "id": "419c5723846b6b093ae72cf841f1af5f13d93a23b4eb82a119b57a7dfb9b71c4",
            "metadata": {},
            "name": "DatabaseValueContainerContentUnifiedQuery",
            "operationKind": "query",
            "text": "query DatabaseValueContainerContentUnifiedQuery($contentId:ID!){content(id:$contentId){nodes{id,referenceId,space{id,key,name}}},user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary},emails{value,isPrimary},locale}}"
        }
    };
}();
$3c3a42cef99017de$var$node.hash = "e6d282732f563a19f236b7e97e2dc95a";
var $3c3a42cef99017de$export$2e2bcd8739ae039 = $3c3a42cef99017de$var$node;





const $e75add8c1d946f03$export$df287bda027f951a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ contentId: contentId, entryId: entryId, fieldId: fieldId, isEdit: isEdit })=>{
    const iframeRef = (0, $42omo.useRef)(null);
    const [content, setContent] = (0, $42omo.useState)(null);
    const [dataLoaded, setDataLoaded] = (0, $42omo.useState)(false);
    const [width, setWidth] = (0, $42omo.useState)(0);
    const [height, setHeight] = (0, $42omo.useState)(0);
    const databaseUrl = new URL((0, $e8cbe0a1e77b1d69$export$3f6d3dddadd0c944)(), window.location.origin);
    const [identity, setIdentity] = (0, $42omo.useState)(null);
    const { activationId: activationId, userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    (0, $42omo.useEffect)(()=>{
        (0, $c0rhi.queryInterop)({
            query: (0, $3c3a42cef99017de$export$2e2bcd8739ae039),
            variables: {
                contentId: contentId
            },
            __callerPackage__: "@confluence/confluence-databases-extension"
        }).then(({ data: data })=>{
            setContent({
                contentReferenceId: data.content?.nodes?.[0]?.referenceId,
                spaceId: data.content?.nodes?.[0]?.space?.id,
                spaceKey: data.content?.nodes?.[0]?.space?.key,
                spaceName: data.content?.nodes?.[0]?.space?.name
            });
            setIdentity({
                accountId: data?.user?.id,
                nickname: data?.user?.displayName,
                picture: data?.user?.photos?.find((photo)=>photo?.isPrimary)?.value,
                email: data?.user?.emails?.find((email)=>email?.isPrimary)?.value,
                locale: data?.user?.locale
            });
            setDataLoaded(true);
        });
    }, [
        contentId
    ]);
    const bridgeData = {
        cloudId: cloudId,
        activationId: activationId,
        userId: userId,
        identity: identity,
        contentId: contentId,
        ...content ? {
            content: content
        } : {}
    };
    const messageCallback = (0, $42omo.useCallback)((event)=>{
        const isFromExpectedIframe = iframeRef.current && event.source === iframeRef.current.contentWindow;
        if (isFromExpectedIframe) try {
            const data = JSON.parse(event.data);
            if (data.method === 'resize' && 'width' in data && 'height' in data) {
                setWidth(data.width);
                setHeight(data.height);
            }
        } catch  {}
    }, []);
    (0, $42omo.useEffect)(()=>{
        window.addEventListener('message', messageCallback);
        return ()=>{
            window.removeEventListener('message', messageCallback);
        };
    }, [
        messageCallback
    ]);
    if (entryId && fieldId && contentId) {
        databaseUrl.searchParams.delete('referencing');
        databaseUrl.searchParams.set('contentId', contentId);
        databaseUrl.searchParams.set('entryId', entryId);
        databaseUrl.searchParams.set('fieldId', fieldId);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("iframe", {
            style: {
                width: `${width}px`,
                height: `${height}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                border: (0, $9wGTI.fg)('confluence_frontend_tokenize_border') ? "var(--ds-space-0, 0px)" : '0px',
                pointerEvents: isEdit ? 'none' : 'auto',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                verticalAlign: 'middle'
            },
            src: databaseUrl.toString(),
            ...dataLoaded ? {
                'data-bridge-data': JSON.stringify(bridgeData)
            } : {},
            title: "database-value-frame",
            ref: iframeRef
        }), width === 0 || height === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            testId: "database-value-spinner"
        }) : null);
    }
    return null;
});



var $6s78L = parcelRequire("6s78L");

const $dfcefa6efd7a826f$var$isParentPageMovedError = (error)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some((graphQLError)=>graphQLError.extensions.data.errors.some((nestedError)=>nestedError.message.key.includes('The parent space does not match the desired space')));
    return false;
};
const $dfcefa6efd7a826f$var$isInvalidParentError = (error)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some((graphQLError)=>graphQLError.extensions.data.errors.some((nestedError)=>nestedError.message.key.includes('Invalid potential parent passed')));
    return false;
};
const $dfcefa6efd7a826f$export$56cb25c20f68202b = (error)=>{
    if ($dfcefa6efd7a826f$var$isParentPageMovedError(error)) return {
        title: (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).parentPageMovedErrorTitle,
        description: (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).parentPageMovedErrorDescription
    };
    else if ($dfcefa6efd7a826f$var$isInvalidParentError(error)) return {
        title: (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).invalidParentErrorTitle,
        description: (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).invalidParentErrorDescription
    };
    else if ((0, $1uFM6.isUnauthorizedError)(error)) return {
        title: (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).permissionRemovedErrorTitle,
        description: (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).permissionRemovedErrorDescription
    };
    return null;
};
const $dfcefa6efd7a826f$var$fireFlagActionClickedAnalytics = ({ createAnalyticsEvent: createAnalyticsEvent })=>{
    createAnalyticsEvent?.({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'redirectToDatabase',
            source: 'editorComponent',
            attributes: {
                flow: 'inlineDatabaseCreation',
                contentType: 'database',
                collabService: 'canvas-relay'
            }
        }
    }).fire();
};
const $dfcefa6efd7a826f$export$c063c49e521623c3 = ({ pageId: pageId, spaceKey: spaceKey, spaceId: spaceId, experienceTracker: experienceTracker, createAnalyticsEvent: createAnalyticsEvent, flags: flags, pageTreeStateUpdater: pageTreeStateUpdater })=>{
    return async ()=>{
        try {
            experienceTracker?.start({
                name: (0, $irVI7.CREATE_DATABASE_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
                attributes: {
                    flow: 'inlinePageCreation'
                }
            });
            const mutationResult = await (0, $6s78L.mutateInterop)({
                mutation: (0, $9aada210960f84b9$export$2e2bcd8739ae039),
                variables: {
                    createdInContentId: pageId,
                    spaceKey: spaceKey
                },
                __callerPackage__: "@confluence/confluence-databases-extension"
            });
            const contentId = mutationResult?.data?.createContentInline?.id ?? '';
            createAnalyticsEvent?.({
                type: 'sendTrackEvent',
                data: {
                    actionSubject: 'content',
                    action: 'createdByFlow',
                    objectId: contentId,
                    objectType: 'database',
                    containerId: spaceId,
                    containerType: 'space',
                    source: 'editorComponent',
                    attributes: {
                        flow: 'inlineDatabaseCreation',
                        contentType: 'database',
                        collabService: 'canvas-relay'
                    }
                }
            }).fire();
            const fullUrl = $dfcefa6efd7a826f$export$b51cf6ef6d0676bd(contentId, spaceKey);
            await flags?.showFlag({
                type: 'success-circle',
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).successFlagTitle),
                actions: [
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).successFlagAction),
                        href: fullUrl,
                        target: '_blank',
                        onClick: ()=>$dfcefa6efd7a826f$var$fireFlagActionClickedAnalytics({
                                createAnalyticsEvent: createAnalyticsEvent
                            })
                    }
                ],
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).successFlagDescription)
            });
            if (contentId && pageTreeStateUpdater) pageTreeStateUpdater.setForceFetchPageId(contentId);
            experienceTracker?.succeed({
                name: (0, $irVI7.CREATE_DATABASE_EXPERIENCE)
            });
            if ((0, $9wGTI.fg)('platform_native_embeds_rollout_non_maui_experience')) return {
                type: 'extension',
                attrs: {
                    extensionKey: `${0, $3jQ9y.NATIVE_EMBED_EXTENSION_KEY}:database`,
                    extensionType: (0, $3jQ9y.NATIVE_EMBED_EXTENSION_TYPE),
                    parameters: {
                        macroParams: {
                            url: {
                                value: fullUrl
                            },
                            alwaysShowTitle: {
                                value: 'true'
                            }
                        }
                    }
                }
            };
            return {
                type: 'embedCard',
                attrs: {
                    url: fullUrl
                }
            };
        } catch (error) {
            const cteTraceId = (0, $jn9ek.getTraceIdFromApolloError)(error);
            const expectedErrorMessage = $dfcefa6efd7a826f$export$56cb25c20f68202b(error);
            if (expectedErrorMessage) {
                experienceTracker?.succeed({
                    name: (0, $irVI7.CREATE_DATABASE_EXPERIENCE),
                    attributes: {
                        abortReason: 'expectedErrorMessage'
                    }
                });
                await flags?.showErrorFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), expectedErrorMessage.title),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), expectedErrorMessage.description)
                });
            } else {
                (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).DATABASES
                });
                experienceTracker?.stopOnError({
                    name: (0, $irVI7.CREATE_DATABASE_EXPERIENCE),
                    error: error,
                    attributes: {
                        cteTraceId: cteTraceId
                    }
                });
                await flags?.showErrorFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).defaultErrorFlagTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).defaultErrorFlagDescription)
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    };
};
const $dfcefa6efd7a826f$export$b51cf6ef6d0676bd = (contentId, spaceKey)=>{
    const databaseUrl = (0, $1NBp8.DATABASE_VIEW).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    return window.location.origin + databaseUrl;
};
const $dfcefa6efd7a826f$export$3fddcebfd1fcb0f5 = (intl)=>{
    return async ()=>{
        const el = document.createElement('div');
        document.body.appendChild(el);
        const sessionData = await (0, $ge2sX.getSessionData)();
        let result;
        try {
            result = await new Promise((resolve)=>{
                // eslint-disable-next-line react/no-deprecated
                (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7i8j.SessionDataContext).Provider, {
                    value: sessionData
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dc4f221a49e0d4ac$export$8480276ebb3b339b), {
                    onClose: async (result)=>{
                        resolve(result);
                    },
                    intl: intl
                })), el);
            });
        } finally{
            // eslint-disable-next-line react/no-deprecated
            (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).unmountComponentAtNode(el);
            document.body.removeChild(el);
        }
        if (result) {
            if ((0, $9wGTI.fg)('platform_native_embeds_rollout_non_maui_experience')) return {
                type: 'extension',
                attrs: {
                    extensionKey: `${0, $3jQ9y.NATIVE_EMBED_EXTENSION_KEY}:database`,
                    extensionType: (0, $3jQ9y.NATIVE_EMBED_EXTENSION_TYPE),
                    parameters: {
                        macroParams: {
                            url: {
                                value: result
                            },
                            alwaysShowTitle: {
                                value: 'true'
                            }
                        }
                    }
                }
            };
            return {
                type: 'embedCard',
                attrs: {
                    url: result
                }
            };
        } else return;
    };
};
const $dfcefa6efd7a826f$var$getDatabaseIcon = ()=>{
    // when cleaning up the experiment, can productionalize the DatabaseIcon
    if ([
        'new-description',
        'orig-description'
    ].includes((0, $6mKj3.UNSAFE_expValNoExposure)('cc_fd_db_top_editor_toolbar', 'cohort', 'control'))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))), {
        label: ""
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bc87b26567284590$exports))),
        alt: ""
    });
};
const $dfcefa6efd7a826f$var$getQuickInsertItemsForPage = ({ pageId: pageId, spaceKey: spaceKey, spaceId: spaceId, experienceTracker: experienceTracker, createAnalyticsEvent: createAnalyticsEvent, intl: intl, flags: flags, pageTreeStateUpdater: pageTreeStateUpdater })=>{
    const items = [
        {
            key: 'create-database',
            title: [
                'new-description',
                'orig-description'
            ].includes((0, $6mKj3.UNSAFE_expValNoExposure)('cc_fd_db_top_editor_toolbar', 'cohort', 'control')) ? intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).databaseDefaultTitle) : intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).createDatabaseTitle),
            description: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_fd_db_top_editor_toolbar', 'cohort', 'new-description') ? intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).databaseDefaultDescription) : intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).createDatabaseDescription),
            priority: -100,
            icon: async ()=>()=>$dfcefa6efd7a826f$var$getDatabaseIcon(),
            action: $dfcefa6efd7a826f$export$c063c49e521623c3({
                pageId: pageId,
                spaceKey: spaceKey,
                spaceId: spaceId,
                experienceTracker: experienceTracker,
                createAnalyticsEvent: createAnalyticsEvent,
                flags: flags,
                pageTreeStateUpdater: pageTreeStateUpdater
            }),
            ...[
                'new-description',
                'orig-description'
            ].includes((0, $6mKj3.UNSAFE_expValNoExposure)('cc_fd_db_top_editor_toolbar', 'cohort', 'control')) ? {
                featured: true
            } : {}
        }
    ];
    return items;
};
const $dfcefa6efd7a826f$export$f86f9e9c7cf6f650 = ({ pageId: pageId, spaceKey: spaceKey, spaceId: spaceId, intl: intl, flags: flags, experienceTracker: experienceTracker, createAnalyticsEvent: createAnalyticsEvent, contentType: contentType, allowDatabaseQuickInsert: allowDatabaseQuickInsert, isEdit: isEdit, pageTreeStateUpdater: pageTreeStateUpdater })=>{
    const quickInsert = [];
    if (contentType === 'page') quickInsert.push(...$dfcefa6efd7a826f$var$getQuickInsertItemsForPage({
        pageId: pageId,
        spaceKey: spaceKey,
        spaceId: spaceId,
        experienceTracker: experienceTracker,
        createAnalyticsEvent: createAnalyticsEvent,
        intl: intl,
        flags: flags,
        pageTreeStateUpdater: pageTreeStateUpdater
    }));
    quickInsert.push({
        key: 'reference-database',
        title: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).referenceDatabaseTitle),
        description: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).referenceDatabaseDescription),
        icon: async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c7f5a98f0ee5cc1e$exports))),
                    alt: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).referenceDatabaseIconAltText)
                }),
        action: $dfcefa6efd7a826f$export$3fddcebfd1fcb0f5(intl)
    });
    return {
        title: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).manifestTitle),
        type: 'com.atlassian.confluence.macro.core',
        key: 'database-extension',
        icons: {
            '48': async ()=>()=>$dfcefa6efd7a826f$var$getDatabaseIcon()
        },
        modules: {
            quickInsert: allowDatabaseQuickInsert ? quickInsert : [],
            nodes: {
                default: {
                    type: 'inlineExtension',
                    render: async ()=>{
                        const sessionData = await (0, $ge2sX.getSessionData)();
                        return ({ node: node })=>{
                            const contentId = node.parameters?.macroParams?.contentId.value;
                            const entryId = node.parameters?.macroParams?.entryId.value;
                            const fieldId = node.parameters?.macroParams?.fieldId.value;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7i8j.SessionDataContext).Provider, {
                                value: sessionData
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e75add8c1d946f03$export$df287bda027f951a), {
                                contentId: contentId,
                                fieldId: fieldId,
                                entryId: entryId,
                                isEdit: isEdit
                            }));
                        };
                    }
                }
            }
        }
    };
};
module.exports["getFullDatabaseUrl"] = $dfcefa6efd7a826f$export$b51cf6ef6d0676bd;
module.exports["createDatabaseExtension"] = $dfcefa6efd7a826f$export$f86f9e9c7cf6f650;

});

parcelRegister("9Eka4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T9xHm = parcelRequire("T9xHm");


var $ibzAc = parcelRequire("ibzAc");


var $f8eu7 = parcelRequire("f8eu7");


var $l1vR8 = parcelRequire("l1vR8");


var $1RH0O = parcelRequire("1RH0O");


var $inPa6 = parcelRequire("inPa6");





var $d925B = parcelRequire("d925B");


var $7fmpI = parcelRequire("7fmpI");


var $9eOvr = parcelRequire("9eOvr");


var $gtauf = parcelRequire("gtauf");

var $lEQpi = parcelRequire("lEQpi");





var $eTj7Y = parcelRequire("eTj7Y");


var $lBSlf = parcelRequire("lBSlf");

var $e6n00 = parcelRequire("e6n00");


var $awHlv = parcelRequire("awHlv");

var $a7tZV = parcelRequire("a7tZV");


var $eC3mJ = parcelRequire("eC3mJ");

const $97d9ff76fb12c778$export$da661eaac6059c75 = ({ nodeProps: nodeProps, syncBlockStoreManager: syncBlockStoreManager, rendererOptions: rendererOptions, getAccountId: getAccountId })=>{
    const { resourceId: resourceId, localId: localId, fireAnalyticsEvent: fireAnalyticsEvent } = nodeProps;
    // `fireAnalyticsEvent` from NodeProps is typed as the generic
    // `AnalyticsEventPayload`. The synced-block consumers below
    // (`updateFireAnalyticsEvent`, `useFetchSyncBlockData`, `renderSyncedBlockContent`)
    // only ever invoke it with the narrower `RendererSyncBlockEventPayload`
    // union, which is a strict subset of `AnalyticsEventPayload`, so the cast
    // is safe.
    const syncBlockFireAnalyticsEvent = fireAnalyticsEvent;
    (0, $42omo.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            // handleSSRErrorsAnalytics expects only `SyncedBlockSSRErrorAEP` — the
            // generic `fireAnalyticsEvent` from NodeProps is a superset, so the
            // cast is safe (the handler only ever calls back with that one AEP).
            (0, $lBSlf.handleSSRErrorsAnalytics)(fireAnalyticsEvent);
        }, 0);
        return ()=>{
            clearTimeout(timeoutId);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        syncBlockStoreManager.referenceManager.updateFireAnalyticsEvent(syncBlockFireAnalyticsEvent);
    }, [
        syncBlockStoreManager.referenceManager,
        syncBlockFireAnalyticsEvent
    ]);
    const { syncBlockInstance: syncBlockInstance, isLoading: isLoading, reloadData: reloadData, providerFactory: providerFactory, ssrProviders: ssrProviders } = (0, $a7tZV.useFetchSyncBlockData)(syncBlockStoreManager, resourceId, localId, syncBlockFireAnalyticsEvent);
    const finalRendererOptions = (0, $42omo.useMemo)(()=>{
        if (rendererOptions?.media?.ssr || // already has ssr config
        !ssrProviders?.media?.viewMediaClientConfig) return rendererOptions;
        const mediaSSR = {
            // Use synced block's media config so auth uses source contentId, not current page.
            // Server: during SSR; client: after hydration (avoids using page's MediaClient).
            mode: (0, $eTj7Y.isSSR)() ? 'server' : 'client',
            config: ssrProviders?.media.viewMediaClientConfig
        };
        return {
            ...rendererOptions,
            media: {
                ...rendererOptions?.media || {},
                ssr: mediaSSR
            }
        };
    }, [
        rendererOptions,
        ssrProviders
    ]);
    const errorForDisplay = syncBlockInstance?.error ?? (syncBlockInstance?.data?.status === 'deleted' ? {
        type: (0, $awHlv.SyncBlockError).NotFound,
        reason: syncBlockInstance.data?.deletionReason
    } : {
        type: (0, $awHlv.SyncBlockError).Errored,
        reason: !resourceId ? 'missing resource id' : `missing data for block ${resourceId}`
    });
    const result = (0, $eC3mJ.renderSyncedBlockContent)({
        syncBlockInstance: syncBlockInstance ?? undefined,
        isLoading: isLoading,
        rendererOptions: finalRendererOptions,
        providerFactory: providerFactory,
        reloadData: reloadData,
        fireAnalyticsEvent: syncBlockFireAnalyticsEvent,
        resourceId: resourceId,
        error: errorForDisplay,
        getAccountId: getAccountId
    });
    if (result.isSuccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $e6n00.SyncBlockSharedCssClassName).renderer,
        [(0, $e6n00.SyncBlockRendererDataAttributeName)]: true
    }, result.element);
    return result.element;
};


const $eb2b1125b5abca94$export$28a555a4d57f5843 = (doc)=>{
    const { content: content } = doc;
    const isEmpty = !content || !Array.isArray(content) || content.length === 0;
    const syncBlockNodes = isEmpty ? [] : content.map((node)=>(0, $gtauf.convertSyncBlockJSONNodeToSyncBlockNode)(node)).filter((node)=>node !== undefined);
    return syncBlockNodes;
};
const $eb2b1125b5abca94$export$2813820533ed0641 = ({ syncBlockNodes: syncBlockNodes, syncBlockProvider: syncBlockProvider, syncBlockRendererOptions: syncBlockRendererOptions, fireAnalyticsEvent: fireAnalyticsEvent, getAccountId: getAccountId, getPrefetchedData: getPrefetchedData })=>{
    const syncBlockStoreManager = (0, $lEQpi.useMemoizedSyncBlockStoreManager)(syncBlockProvider, fireAnalyticsEvent);
    // Process prefetched data early, if available
    (0, $42omo.useEffect)(()=>{
        if (getPrefetchedData) try {
            const prefetchedData = getPrefetchedData();
            syncBlockStoreManager.referenceManager.processPrefetchedData(prefetchedData);
        } catch  {
        // Silently ignore errors from getPrefetchedData so the fetch effect can still run
        }
    }, [
        getPrefetchedData,
        syncBlockStoreManager.referenceManager
    ]);
    // Initial fetch sync block data (will use SSR data as initial cache, or the prefetched data if available)
    (0, $42omo.useEffect)(()=>{
        syncBlockStoreManager.referenceManager.fetchSyncBlocksData(syncBlockNodes);
    }, [
        syncBlockNodes,
        syncBlockStoreManager.referenceManager
    ]);
    return (0, $42omo.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7fmpI.ErrorBoundary), {
            component: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
            dispatchAnalyticsEvent: fireAnalyticsEvent,
            fallbackComponent: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9eOvr.SyncBlockActionsProvider), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            fetchSyncBlockSourceInfo: (sourceAri)=>syncBlockStoreManager.referenceManager.fetchSyncBlockSourceInfoBySourceAri(sourceAri)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $97d9ff76fb12c778$export$da661eaac6059c75), {
            key: props.localId,
            nodeProps: props,
            syncBlockStoreManager: syncBlockStoreManager,
            rendererOptions: syncBlockRendererOptions,
            getAccountId: getAccountId
        }))), [
        syncBlockStoreManager,
        syncBlockRendererOptions,
        fireAnalyticsEvent,
        getAccountId
    ]);
};



var $k00oi = parcelRequire("k00oi");


var $dTb09 = parcelRequire("dTb09");


var $6GQtz = parcelRequire("6GQtz");


var $jQQYu = parcelRequire("jQQYu");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $4IoVL = parcelRequire("4IoVL");


var $iP9x4 = parcelRequire("iP9x4");


var $dPJCf = parcelRequire("dPJCf");


var $60cDW = parcelRequire("60cDW");


var $32x2E = parcelRequire("32x2E");


var $gsPOZ = parcelRequire("gsPOZ");


var $2XqLN = parcelRequire("2XqLN");


var $dHSeC = parcelRequire("dHSeC");

const $70b9b34c85768a23$export$4128d9964cdd56b5 = (e, { shouldCheckIframe: shouldCheckIframe = false } = {})=>{
    const { metaKey: metaKey, ctrlKey: ctrlKey, shiftKey: shiftKey } = e.nativeEvent;
    const hasModifierKeyPressed = metaKey || ctrlKey || shiftKey;
    const isInIframe = shouldCheckIframe ? window.top !== window : false;
    return hasModifierKeyPressed || isInIframe;
};


/**
 * Duplicated from @confluence/linking-platform to avoid circular dependency.
 * Original: next/packages/linking-platform/src/utils/isExternalLink.ts
 */ const $f3e762af8cd6ff89$export$b98882f166bb7ce2 = (url)=>{
    if (!url) return false;
    try {
        const urlObj = new URL(url, window.location.origin);
        return urlObj.origin !== window.location.origin;
    } catch  {
        return false;
    }
};



var $1NBp8 = parcelRequire("1NBp8");




const $afbbb35f90e71c1c$export$50d92d69a5c05c70 = ()=>{
    if ((0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false)) return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname) || !!(0, $1NBp8.ACCESS_LINK).match(window.location.pathname);
    return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname);
};


const $8cc710eb1f83f98d$export$71eec072841e6b90 = (routesContext, e, url)=>{
    const details = (0, $dHSeC.getSpaTransitionDetails)(e, routesContext);
    if ((0, $f3e762af8cd6ff89$export$b98882f166bb7ce2)(url)) {
        e.preventDefault();
        window.open(url, '_blank', 'noopener, noreferrer');
    } else if (details?.href && details.href === url) {
        e.preventDefault();
        routesContext.push(details.href, (0, $afbbb35f90e71c1c$export$50d92d69a5c05c70)());
    } else $8cc710eb1f83f98d$var$handleClick(e, url);
};
/**
 * Copied from @atlaskit/smart-card and
 * packages/media/smart-card/src/view/CardWithUrl/component.tsx to handle click
 * on a smart card with a URL because @atlaskit/smart-card expects
 * SmartCardEventClickHandler to handle the event fully, doesn't allow the
 * SmartCardEventClickHandler to fall back to the default @atlaskit/smart-card
 * click handler.
 */ const $8cc710eb1f83f98d$var$handleClick = (e, url)=>{
    (0, $70b9b34c85768a23$export$4128d9964cdd56b5)(e, {
        shouldCheckIframe: true
    }) ? window.open(url, '_blank') : window.open(url, '_self');
};


const $8b8ae4c054fbf670$export$f996105bf70a5c25 = (0, $2XqLN.default)((routesContext)=>routesContext && typeof routesContext.push === 'function' ? {
        smartCard: {
            onClick: (e, url)=>(0, $8cc710eb1f83f98d$export$71eec072841e6b90)(routesContext, e, url)
        },
        link: {
            onClick: (e, url)=>(0, $8cc710eb1f83f98d$export$71eec072841e6b90)(routesContext, e, url)
        }
    } : undefined);



var $epn2u = parcelRequire("epn2u");

const $4a3ff359f5c9274c$export$6af91131bd465ca7 = (cloudId, userId, spaceKey)=>{
    return (0, $42omo.useMemo)(()=>({
            createEmojiProvider: ()=>{
                return (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
                    cloudId: cloudId,
                    userId: userId || undefined,
                    allowAnonymousAccess: true
                });
            },
            createMediaProvider: ({ contentAri: contentAri, contentId: refSyncBlockContentId, contentProduct: contentProduct })=>{
                return (0, $4IoVL.createRendererMediaProvider)({
                    contentAri: contentAri,
                    contentId: refSyncBlockContentId,
                    contentProduct: contentProduct,
                    isExternalShare: false
                });
            },
            createSSRMediaProvider: ({ contentAri: contentAri, contentId: refSyncBlockContentId, contentProduct: contentProduct })=>{
                const mediaClientConfig = (0, $iP9x4.getMediaSSRModeAndAuthConfigMemoized)({
                    contentAri: contentAri,
                    contentId: refSyncBlockContentId,
                    contentProduct: contentProduct,
                    isExternalShare: false,
                    spaceKey: spaceKey
                });
                if (mediaClientConfig) // Return config for both server (SSR) and client (post-hydration) so synced block
                // media uses the source contentId for auth, not the current page's contentId.
                return {
                    viewMediaClientConfig: mediaClientConfig.config
                };
                return undefined;
            },
            // Uses the same logic as in preloadEditorNodeDataProvidersData.ts
            createSmartLinkProvider: ()=>{
                const { host: host, cloudId: ssrCloudId, userContext: userContext, customURLs: customURLs } = (0, $60cDW.getSSRRenderInputs)();
                const objectResolverURL = customURLs?.['object-resolver-service']?.match(/^(https?:\/\/[^/]+)/)?.[0];
                if (objectResolverURL) {
                    const ssrCardClient = new (0, $k00oi.default)('custom', objectResolverURL);
                    ssrCardClient.setHeaders({
                        Cookie: (0, $jQQYu.createCookie)(userContext),
                        Origin: host.startsWith('http') ? host : `https://${host}`,
                        CloudId: ssrCloudId || cloudId
                    });
                    return Promise.resolve(new (0, $6GQtz.ConfluenceEditorCardProvider)('custom', objectResolverURL, undefined, ssrCardClient));
                }
                return Promise.resolve(new (0, $6GQtz.ConfluenceEditorCardProvider)());
            }
        }), [
        cloudId,
        userId,
        spaceKey
    ]);
};
const $4a3ff359f5c9274c$var$useMemoizedSyncedBlockProviderNodeComponentEnabled = ({ doc: doc, spaceKey: spaceKey, contentId: confluencePageId, contentType: contentType, mergedDataProviderDefinitions: mergedDataProviderDefinitions, stickyHeadersConfig: stickyHeadersConfig, contentMode: contentMode })=>{
    const syncBlockNodes = (0, $42omo.useMemo)(()=>{
        return (0, $eb2b1125b5abca94$export$28a555a4d57f5843)(doc);
    }, [
        doc
    ]);
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const confluencePageAri = (0, $42omo.useMemo)(()=>confluencePageId ? (0, $f8eu7.getConfluencePageAri)({
            pageId: confluencePageId,
            cloudId: cloudId,
            pageType: contentType === 'page' ? 'page' : 'blogpost'
        }) : undefined, [
        cloudId,
        confluencePageId,
        contentType
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { fetchProvider: blockServiceFetchProvider, writeProvider: blockServiceWriteProvider } = (0, $l1vR8.useMemoizedBlockServiceAPIProviders)({
        parentAri: confluencePageAri ?? '',
        parentId: confluencePageId ?? '',
        product: 'confluence-page',
        cloudId: cloudId
    });
    // Wrap the fetch provider with Relay subscription support
    const relayFetchProvider = (0, $42omo.useMemo)(()=>(0, $gsPOZ.createRelaySyncBlockFetchProvider)(blockServiceFetchProvider, cloudId), [
        blockServiceFetchProvider,
        cloudId
    ]);
    const syncedBlockNestedRendererProviderCreator = $4a3ff359f5c9274c$export$6af91131bd465ca7(cloudId, userId, spaceKey);
    const providerOptions = (0, $42omo.useMemo)(()=>{
        return {
            parentDataProviders: {
                ...mergedDataProviderDefinitions
            },
            providerCreator: syncedBlockNestedRendererProviderCreator
        };
    }, [
        mergedDataProviderDefinitions,
        syncedBlockNestedRendererProviderCreator
    ]);
    const syncedBlockProvider = (0, $1RH0O.useMemoizedSyncedBlockProvider)({
        fetchProvider: relayFetchProvider,
        writeProvider: blockServiceWriteProvider,
        providerOptions: providerOptions,
        getSSRData: (0, $epn2u.syncedBlockLoadSSRData)
    });
    const handleSyncedBlockAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: payload
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const matchRoute = (0, $dPJCf.useMatchRoute)();
    const syncedBlockEventHandlers = (0, $42omo.useMemo)(()=>{
        return (0, $8b8ae4c054fbf670$export$f996105bf70a5c25)({
            matchRoute: matchRoute,
            push: push
        });
    }, [
        matchRoute,
        push
    ]);
    const SyncedBlockNodeComponent = (0, $eb2b1125b5abca94$export$2813820533ed0641)({
        syncBlockProvider: syncedBlockProvider,
        syncBlockNodes: syncBlockNodes,
        syncBlockRendererOptions: {
            smartLinks: {
                ssr: true
            },
            eventHandlers: syncedBlockEventHandlers,
            stickyHeaders: stickyHeadersConfig ? {
                show: true,
                ...stickyHeadersConfig
            } : {
                show: true,
                offsetTop: 0
            },
            contentMode: contentMode
        },
        fireAnalyticsEvent: handleSyncedBlockAnalyticsEvent
    });
    // If confluencePageId is undefined, don't return the synced block node component, and don't render synced blocks
    return confluencePageId ? SyncedBlockNodeComponent : undefined;
};
const $4a3ff359f5c9274c$export$27db3e01691a7a01 = (_props)=>{
    return undefined;
};
const $4a3ff359f5c9274c$var$isFedrampOrIsolatedCloud = ()=>{
    return (0, $T9xHm.isFedrampModerate)() || (0, $T9xHm.isIsolatedCloud)();
};
const $4a3ff359f5c9274c$export$e8874f89f60efbe6 = (0, $dTb09.conditionalHooksFactory)(()=>!$4a3ff359f5c9274c$var$isFedrampOrIsolatedCloud() && (0, $6mKj3.isExperimentEnabled)('platform_synced_block'), $4a3ff359f5c9274c$var$useMemoizedSyncedBlockProviderNodeComponentEnabled, $4a3ff359f5c9274c$export$27db3e01691a7a01);
module.exports["useMemoizedSyncedBlockNestedRendererProviderCreator"] = $4a3ff359f5c9274c$export$6af91131bd465ca7;
module.exports["useMemoizedSyncedBlockProviderNodeComponent"] = $4a3ff359f5c9274c$export$e8874f89f60efbe6;

});

parcelRegister("1RH0O", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ejAeh = parcelRequire("ejAeh");


var $f8eu7 = parcelRequire("f8eu7");


var $k2in1 = parcelRequire("k2in1");

const $03df2d74a364c2ee$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $03df2d74a364c2ee$var$AGG_HEADERS = {
    'X-ExperimentalApi': 'confluence-agg-beta'
};
const $03df2d74a364c2ee$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $03df2d74a364c2ee$var$GET_SOURCE_INFO_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_SOURCE_INFO';
/**
 * Query to get the page subtype by id (i.e. live or classic)
 * @param documentARI
 * @returns subType live if livePage, subType null if classic page
 */ const $03df2d74a364c2ee$var$GET_SOURCE_INFO_QUERY = `query ${$03df2d74a364c2ee$var$GET_SOURCE_INFO_OPERATION_NAME} ($id: ID!, $status: [String]) {
	content (id: $id, status: $status) {
		nodes {
			id
			links {
				base
				editui
				webui
			}
			space {
				key
			}
			status
			subType
			title
		}
	}
}`;
const $03df2d74a364c2ee$var$getConfluenceSourceInfo = async (ari, status)=>{
    const variables = {
        id: ari
    };
    if (status) variables.status = status;
    const bodyData = {
        query: $03df2d74a364c2ee$var$GET_SOURCE_INFO_QUERY,
        operationName: $03df2d74a364c2ee$var$GET_SOURCE_INFO_OPERATION_NAME,
        variables: variables
    };
    const response = await (0, $k2in1.fetchWithRetry)($03df2d74a364c2ee$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$03df2d74a364c2ee$var$COMMON_HEADERS,
            ...$03df2d74a364c2ee$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to get url: ${response.statusText}`);
    return await response.json();
};
const $03df2d74a364c2ee$var$resolveNoAccessPageInfo = async (ari)=>{
    const response = await fetch('/gateway/api/object-resolver/resolve/ari', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify({
            ari: ari
        })
    });
    if (response.ok) {
        const payload = await response.json();
        const url = payload?.data?.url;
        const title = payload?.data?.name;
        return {
            url: typeof url === 'string' ? url : undefined,
            title: typeof title === 'string' ? title : undefined,
            sourceAri: ari
        };
    } else throw new Error(`Failed to resolve ari: ${response.statusText}`);
};
const $03df2d74a364c2ee$export$11ee05f70c94d3d7 = async (pageAri, hasAccess, localId)=>{
    if (hasAccess) {
        const status = [
            'draft',
            'archived',
            'current'
        ];
        const response = await $03df2d74a364c2ee$var$getConfluenceSourceInfo(pageAri, status);
        const contentData = response.data?.content?.nodes?.[0];
        const { title: title, subType: subType } = contentData || {};
        let url;
        const { base: base, editui: editui, webui: webui } = contentData?.links || {};
        const pageStatus = contentData?.status;
        if (base && editui && pageStatus !== 'archived') url = `${base}${editui}`;
        else if (base && webui && pageStatus === 'archived') url = `${base}${webui}`;
        url = url && localId ? `${url}#block-${localId}` : url;
        return Promise.resolve({
            title: title,
            url: url,
            sourceAri: pageAri,
            subType: subType
        });
    } else return await $03df2d74a364c2ee$var$resolveNoAccessPageInfo(pageAri);
};


/* eslint-disable require-unicode-regexp  */ 


const $9d43f2a08d0d5e41$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $9d43f2a08d0d5e41$var$AGG_HEADERS = {
    'X-ExperimentalApi': 'confluence-agg-beta'
};
const $9d43f2a08d0d5e41$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $9d43f2a08d0d5e41$var$GET_SOURCE_INFO_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_SOURCE_INFO';
/**
 * Query to get the work item url by id
 * @param id - the ID of the work item
 * @returns url of the work item
 */ // `issueType` is requested alongside `summary` and `webUrl` so the
// SyncedLocationDropdown can render the correct ADS issue-type icon.
const $9d43f2a08d0d5e41$var$GET_SOURCE_INFO_QUERY = `query ${$9d43f2a08d0d5e41$var$GET_SOURCE_INFO_OPERATION_NAME} ($id: ID!) {
  jira {
	issueById(id: $id) {
	id
	webUrl
	summary
	issueType {
		name
		avatar {
		xsmall
		}
	}
	}
  }}`;
const $9d43f2a08d0d5e41$var$getJiraWorkItemSourceInfo = async (ari)=>{
    const bodyData = {
        query: $9d43f2a08d0d5e41$var$GET_SOURCE_INFO_QUERY,
        operationName: $9d43f2a08d0d5e41$var$GET_SOURCE_INFO_OPERATION_NAME,
        variables: {
            id: ari
        }
    };
    const response = await (0, $k2in1.fetchWithRetry)($9d43f2a08d0d5e41$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$9d43f2a08d0d5e41$var$COMMON_HEADERS,
            ...$9d43f2a08d0d5e41$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to get url: ${response.statusText}`);
    return await response.json();
};
const $9d43f2a08d0d5e41$var$resolveNoAccessWorkItemInfo = async (ari)=>{
    const response = await fetch('/gateway/api/object-resolver/resolve/ari', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify({
            ari: ari
        })
    });
    if (response.ok) {
        const payload = await response.json();
        const url = payload?.data?.url;
        const title = payload?.data?.name;
        return {
            url: typeof url === 'string' ? url : undefined,
            title: typeof title === 'string' ? title : undefined,
            sourceAri: ari
        };
    } else throw new Error(`Failed to resolve ari: ${response.statusText}`);
};
const $9d43f2a08d0d5e41$export$5e43429d194de44c = async (workItemAri, hasAccess)=>{
    if (hasAccess) {
        const response = await $9d43f2a08d0d5e41$var$getJiraWorkItemSourceInfo(workItemAri);
        const contentData = response.data?.jira?.issueById;
        const webUrl = typeof contentData?.webUrl === 'string' ? contentData.webUrl : undefined;
        const summary = typeof contentData?.summary === 'string' ? contentData.summary : undefined;
        // Surface issue-type metadata for the SyncedLocationDropdown's ADS icon.
        // Defensive narrowing: only surface when `name` is a non-empty string;
        // AGG values like `{ name: null }` collapse back to `undefined`.
        const issueTypeName = contentData?.issueType?.name;
        const issueType = typeof issueTypeName === 'string' && issueTypeName.length > 0 ? {
            name: issueTypeName,
            iconUrl: typeof contentData?.issueType?.avatar?.xsmall === 'string' ? contentData.issueType.avatar.xsmall : undefined
        } : undefined;
        return Promise.resolve({
            url: webUrl,
            sourceAri: workItemAri,
            title: summary,
            issueType: issueType
        });
    } else return await $9d43f2a08d0d5e41$var$resolveNoAccessWorkItemInfo(workItemAri);
};



var $awHlv = parcelRequire("awHlv");


var $i0VEL = parcelRequire("i0VEL");

class $fc26c56016d8bd54$export$cd52318aefe371fb extends (0, $i0VEL.NodeDataProvider) {
}


class $082ae0f64f625fc6$export$ead9a287a0b743c7 extends (0, $fc26c56016d8bd54$export$cd52318aefe371fb) {
    setProviderOptions(providerOptions) {
        this.providerOptions = providerOptions;
    }
    /**
   * Check if the node is supported by the provider
   *
   * @param node
   *
   * @returns True if the node is supported, false otherwise
   */ isNodeSupported(node) {
        return node.type === 'syncBlock' || node.type === 'bodiedSyncBlock';
    }
    /**
   * Get the data key for the node
   *
   * @param node
   *
   * @returns The data key
   */ nodeDataKey(node) {
        return node.attrs.resourceId;
    }
    /**
   * Fetch the data from the fetch provider using batch API
   *
   * @param nodes
   *
   * @returns Array of {resourceId?: string, error?: string}.
   */ async fetchNodesData(nodes) {
        const blockIdentifiers = nodes.map((node)=>({
                resourceId: node.attrs.resourceId,
                blockInstanceId: node.attrs.localId
            }));
        if (blockIdentifiers.length === 0) return [];
        try {
            return await this.fetchProvider.batchFetchData(blockIdentifiers);
        } catch  {
            // If batch fetch fails, fall back to individual fetch behavior
            // This allows loading states to be shown before errors, matching non-batch behavior
            return Promise.allSettled(blockIdentifiers.map((blockIdentifier)=>{
                return this.fetchProvider.fetchData(blockIdentifier.resourceId).then((data)=>{
                    return data;
                }, (error)=>{
                    return {
                        error: {
                            type: (0, $awHlv.SyncBlockError).Errored,
                            reason: error
                        },
                        resourceId: blockIdentifier.resourceId
                    };
                });
            })).then((results)=>{
                return results.filter((result)=>{
                    return result.status === 'fulfilled';
                }).map((result)=>result.value);
            });
        }
    }
    /**
   * Write the data to the write provider
   *
   * @param nodes
   * @param data
   *
   * @returns Array of {resourceId?: string, error?: string}.
   * resourceId: resource id of the node if write successfully , error: reason for when write failed
   */ async writeNodesData(nodes, data) {
        if (!this.writeProvider) return Promise.reject(new Error('Write provider not set'));
        // Use batch write only when method is available
        if (this.writeProvider.writeDataBatch) {
            // Separate data into valid (with content) and invalid (without content)
            const validDataWithIndices = [];
            const invalidResults = [];
            data.forEach((blockData)=>{
                if (blockData.content) validDataWithIndices.push(blockData);
                else invalidResults.push({
                    error: 'No Synced Block content to write',
                    resourceId: blockData.resourceId
                });
            });
            // Process valid data in batch
            let batchResults = [];
            if (validDataWithIndices.length > 0) batchResults = await this.writeProvider.writeDataBatch(validDataWithIndices);
            return [
                ...batchResults,
                ...invalidResults
            ];
        }
        // Fall back to individual writes
        const results = await Promise.allSettled(nodes.map((_node, index)=>{
            if (!this.writeProvider) return Promise.reject('Write provider not set');
            if (!data[index].content) return Promise.reject('No Synced Block content to write');
            return this.writeProvider?.writeData(data[index]);
        }));
        return results.map((result)=>{
            if (result.status === 'fulfilled') return result.value;
            else return {
                error: result.reason
            };
        });
    }
    createNodeData(data) {
        if (!this.writeProvider) return Promise.reject(new Error('Write provider not set'));
        return this.writeProvider.createData(data).then((result)=>result, (error)=>({
                error: error
            }));
    }
    /**
   * Delete the data from the write provider
   *
   * @param resourceIds
   *
   * @returns Array of {resourceId?: string, error?: string}.
   */ async deleteNodesData(resourceIds, deletionReason) {
        if (!this.writeProvider) return Promise.reject(new Error('Write provider not set'));
        const results = await Promise.allSettled(resourceIds.map((resourceId)=>{
            if (!this.writeProvider) return Promise.reject('Write provider not set');
            return this.writeProvider.deleteData(resourceId, deletionReason);
        }));
        return results.map((result, index)=>{
            if (result.status === 'fulfilled') return result.value;
            else return {
                resourceId: resourceIds[index],
                success: false,
                error: result.reason
            };
        });
    }
    /**
   * Fetch the source info from the source id
   *
   * @param params
   * @param params.sourceAri - The source ARI
   * @param params.sourceProduct - The source product. e.g. 'confluence-page', 'jira-work-item'
   *
   * @returns The source info
   */ async fetchSyncBlockSourceInfo(localId, sourceAri, sourceProduct, hasAccess = true) {
        const ari = sourceAri ?? this.writeProvider?.parentAri;
        const product = sourceProduct ?? (0, $ejAeh.getProductFromSourceAri)(ari);
        if (!ari || !product) return Promise.reject(new Error('Source ari or source product is undefined'));
        switch(product){
            case 'confluence-page':
                {
                    const sourceInfo = await (0, $03df2d74a364c2ee$export$11ee05f70c94d3d7)(ari, hasAccess, localId);
                    if (!sourceInfo) return Promise.resolve(undefined);
                    return {
                        ...sourceInfo,
                        onSameDocument: this.writeProvider?.parentAri === ari,
                        productType: product
                    };
                }
            case 'jira-work-item':
                {
                    // Note: `subType`, archived URL handling, and `isUnpublished` are intentionally
                    // omitted here — Jira work items have no equivalent page subtype or archived state.
                    // The `localId` param is intentionally not forwarded: the current Jira issue view
                    // does not scroll to `#block-{localId}` anchors, so passing it would only pollute
                    // the URL. See the parity-notes JSDoc on `fetchJiraWorkItemInfo` for the full
                    // rationale and the conditions under which this should be revisited.
                    const sourceInfo = await (0, $9d43f2a08d0d5e41$export$5e43429d194de44c)(ari, hasAccess);
                    if (!sourceInfo) return Promise.resolve(undefined);
                    return {
                        ...sourceInfo,
                        onSameDocument: this.writeProvider?.parentAri === ari,
                        productType: product
                    };
                }
            default:
                return Promise.reject(new Error(`${product} source product not supported`));
        }
    }
    generateResourceId() {
        const localId = crypto.randomUUID();
        const resourceId = crypto.randomUUID();
        return {
            localId: localId,
            resourceId: resourceId
        };
    }
    generateResourceIdForReference(sourceId) {
        if (!this.writeProvider) throw new Error('Write provider not set');
        return this.writeProvider.generateResourceIdForReference(sourceId);
    }
    /**
   * Get the synced block renderer provider options
   *
   * @returns The synced block renderer provider options
   */ getSyncedBlockRendererProviderOptions() {
        return this.providerOptions;
    }
    /**
   * Retrieve the parent info for the sync block
   *
   * @param sourceAri - The source ARI
   * @param sourceProduct - The source product. e.g. 'confluence-page', 'jira-work-item'
   *
   * @returns The parent info for the sync block
   */ retrieveSyncBlockParentInfo(sourceAri, sourceProduct) {
        if (!sourceAri || !sourceProduct) return undefined;
        switch(sourceProduct){
            case 'confluence-page':
                return {
                    contentAri: sourceAri,
                    contentId: (0, $f8eu7.getPageIdAndTypeFromConfluencePageAri)({
                        ari: sourceAri
                    }).id,
                    contentProduct: sourceProduct
                };
            case 'jira-work-item':
                return {
                    contentAri: sourceAri,
                    contentId: sourceAri,
                    contentProduct: sourceProduct
                };
            default:
                throw new Error(`${sourceProduct} source product not supported`);
        }
    }
    updateReferenceData(blocks, noContent) {
        if (!this.writeProvider) throw new Error('Write provider not set');
        return this.writeProvider.updateReferenceData(blocks, noContent);
    }
    fetchReferences(resourceId, isSource) {
        if (!this.fetchProvider) throw new Error('Fetch provider not set');
        return this.fetchProvider.fetchReferences(isSource ? this.generateResourceIdForReference(resourceId) : resourceId);
    }
    /**
   * Subscribes to real-time updates for a specific block.
   * @param resourceId - The resource ID of the block to subscribe to
   * @param onUpdate - Callback function invoked when the block is updated
   * @param onError - Optional callback function invoked on subscription errors
   * @returns Unsubscribe function to stop receiving updates, or undefined if not supported
   */ subscribeToBlockUpdates(resourceId, onUpdate, onError, onComplete) {
        if (this.fetchProvider.subscribeToBlockUpdates) return this.fetchProvider.subscribeToBlockUpdates(resourceId, onUpdate, onError, onComplete);
        return undefined;
    }
    /**
   * Constructor for the SyncedBlockProvider
   *
   * @param fetchProvider
   * @param writeProvider
   * @param nestedRendererDataProviders
   */ constructor(fetchProvider, writeProvider){
        super();
        this.name = 'syncBlockProvider';
        this.fetchProvider = void 0;
        this.writeProvider = void 0;
        this.providerOptions = void 0;
        this.fetchProvider = fetchProvider;
        this.writeProvider = writeProvider;
        this.providerOptions = {};
    }
}
const $082ae0f64f625fc6$var$createSyncedBlockProvider = ({ fetchProvider: fetchProvider, writeProvider: writeProvider })=>{
    return new $082ae0f64f625fc6$export$ead9a287a0b743c7(fetchProvider, writeProvider);
};
const $082ae0f64f625fc6$export$ae97d432056ca005 = ({ fetchProvider: fetchProvider, writeProvider: writeProvider, providerOptions: providerOptions, getSSRData: getSSRData })=>{
    const syncBlockProvider = (0, $42omo.useMemo)(()=>$082ae0f64f625fc6$var$createSyncedBlockProvider({
            fetchProvider: fetchProvider,
            writeProvider: writeProvider
        }), [
        fetchProvider,
        writeProvider
    ]);
    const prevProviderOptionsRef = (0, $42omo.useRef)(undefined);
    if (providerOptions !== prevProviderOptionsRef.current) {
        prevProviderOptionsRef.current = providerOptions;
        syncBlockProvider.setProviderOptions(providerOptions);
    }
    const prevSSRDataRef = (0, $42omo.useRef)(undefined);
    const ssrData = getSSRData?.();
    if (ssrData !== prevSSRDataRef.current) {
        prevSSRDataRef.current = ssrData;
        if (ssrData) syncBlockProvider.setSSRData(ssrData);
    }
    return syncBlockProvider;
};
module.exports["useMemoizedSyncedBlockProvider"] = $082ae0f64f625fc6$export$ae97d432056ca005;

});

parcelRegister("lBSlf", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $eTj7Y = parcelRequire("eTj7Y");


var $ghBq4 = parcelRequire("ghBq4");

const $a0f9e31b9493339e$var$isSyncedBlocksSSRErrorObj = (maybeSSRErrorObj)=>{
    if (!maybeSSRErrorObj || typeof maybeSSRErrorObj !== 'object') return false;
    const errorWrapper = maybeSSRErrorObj;
    // Check for meta object with valid code
    const hasValidMeta = errorWrapper.meta && typeof errorWrapper.meta === 'object' && Object.values((0, $ghBq4.SyncedBlocksSSRErrorCodeMap)).includes(errorWrapper.meta.code);
    return Boolean(hasValidMeta);
};
/**
 * Get the first SSR error for synced blocks from the window.__SSR_ERROR__ array.
 *
 * Expected structure of error objects stored in confluence window.__SSR_ERROR__ for synced blocks SSR errors:
 *
 * @example
 * {
 *   error: {
 *     message: "Synced blocks fetch operation timed out",
 *     stack: "Error: Synced blocks fetch operation timed out\n    at /tmp/script.js:xxx:xxx"
 *   },
 *   meta: {
 *     code: "SYNCED_BLOCKS_FETCH_TIMEOUT",
 *     contentId: "XXXXXX",
 *     cloudId: "XXXX-XXXX-XXXX-XXXX-XXXX",
 *     isBlog: false,
 *     identifiers: [
 *       {
 *         resourceId: "confluence-page/XXXXXX/XXXX-XXXX-XXXX-XXXX-XXXX",
 *         blockInstanceId: "XXXX-XXXX-XXXX-XXXX-XXXX"
 *       }
 *     ]
 *   }
 * }
 *
 * @returns The first SSR error metadata, or undefined if no error found
 */ const $a0f9e31b9493339e$var$getSyncedBlocksSSRError = ()=>{
    if ((0, $eTj7Y.isSSR)()) return undefined;
    const ssrErrors = window.__SSR_ERROR__;
    if (Array.isArray(ssrErrors)) {
        const syncedBlockErrors = ssrErrors.filter($a0f9e31b9493339e$var$isSyncedBlocksSSRErrorObj).map((errorWrapper)=>errorWrapper.meta);
        return syncedBlockErrors.length > 0 ? syncedBlockErrors[0] : undefined;
    }
    return undefined;
};
const $a0f9e31b9493339e$export$8be916857642095b = (()=>{
    let called = false;
    // I want this fireAnalyticsEvent only takes in SyncedBlockSSRErrorAEP
    return (fireAnalyticsEvent)=>{
        if (called) return;
        called = true;
        if (!fireAnalyticsEvent) return;
        const error = $a0f9e31b9493339e$var$getSyncedBlocksSSRError();
        if (error) fireAnalyticsEvent({
            action: (0, $d925B.ACTION).ERROR,
            actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_SSR_ERROR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                code: error.code,
                isBlog: error.isBlog,
                syncedBlocksCount: error.identifiers?.length || 0,
                missingSyncedBlocksCount: error.missingIdentifiers?.length || 0,
                errorMessage: error.errorMessage,
                errorName: error.errorName
            }
        });
    };
})();
module.exports["handleSSRErrorsAnalytics"] = $a0f9e31b9493339e$export$8be916857642095b;

});

parcelRegister("eC3mJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eTj7Y = parcelRequire("eTj7Y");


var $awHlv = parcelRequire("awHlv");





var $aXWIB = parcelRequire("aXWIB");


var $fzXn1 = parcelRequire("fzXn1");


var $hlcQd = parcelRequire("hlcQd");

var $67O0h = parcelRequire("67O0h");

var $iZq0X = parcelRequire("iZq0X");


var $lspPP = parcelRequire("lspPP");


var $bBvs5 = parcelRequire("bBvs5");


var $3gadb = parcelRequire("3gadb");

const $a04998616bd329fd$var$ValidationContextWrapper = ({ children: children })=>{
    const validationContextValue = (0, $42omo.useMemo)(()=>({
            allowNestedTables: true
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iZq0X.ValidationContextProvider), {
        value: validationContextValue
    }, children);
};
const $a04998616bd329fd$var$DisabledTaskWithTooltip = ({ componentKey: componentKey, ...props })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const tooltipContent = formatMessage((0, $fzXn1.syncBlockMessages).taskInDestinationSyncedBlockTooltip);
    const Component = (0, $hlcQd.nodeToReact)[componentKey];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltipContent,
        position: "auto-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
        ...props,
        disableOnChange: true
    }));
};
const $a04998616bd329fd$var$defaultOptions = {
    appearance: 'full-width',
    allowAltTextOnImages: true,
    allowAnnotations: true,
    allowColumnSorting: true,
    allowCopyToClipboard: true,
    allowCustomPanels: true,
    allowPlaceholderText: true,
    allowRendererContainerStyles: true,
    allowSelectAllTrap: true,
    allowUgcScrubber: true,
    allowWrapCodeBlock: true,
    emojiResourceConfig: undefined,
    media: {
        allowLinking: true,
        allowCaptions: true,
        featureFlags: {
            mediaInline: true
        }
    },
    smartLinks: {
        ssr: true
    }
};
const $a04998616bd329fd$export$cc2ec5e10e7ca244 = /*#__PURE__*/ (0, $42omo.memo)(({ doc: doc, dataProviders: dataProviders, options: options })=>{
    const mergedOptions = {
        ...$a04998616bd329fd$var$defaultOptions,
        ...options
    };
    const { appearance: appearance, allowAltTextOnImages: allowAltTextOnImages, allowAnnotations: allowAnnotations, allowColumnSorting: allowColumnSorting, allowCopyToClipboard: allowCopyToClipboard, allowCustomPanels: allowCustomPanels, allowHeadingAnchorLinks: allowHeadingAnchorLinks, allowPlaceholderText: allowPlaceholderText, allowRendererContainerStyles: allowRendererContainerStyles, allowSelectAllTrap: allowSelectAllTrap, allowUgcScrubber: allowUgcScrubber, allowWrapCodeBlock: allowWrapCodeBlock, emojiResourceConfig: emojiResourceConfig, eventHandlers: eventHandlers, media: media, smartLinks: smartLinks, stickyHeaders: stickyHeaders, contentMode: contentMode } = mergedOptions ?? {};
    const nodeComponents = (0, $42omo.useMemo)(()=>{
        return {
            taskItem: (props)=>{
                // eslint-disable-next-line react/jsx-props-no-spreading
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a04998616bd329fd$var$DisabledTaskWithTooltip, {
                    componentKey: "taskItem",
                    ...props
                });
            },
            blockTaskItem: (props)=>{
                // eslint-disable-next-line react/jsx-props-no-spreading
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a04998616bd329fd$var$DisabledTaskWithTooltip, {
                    componentKey: "blockTaskItem",
                    ...props
                });
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a04998616bd329fd$var$ValidationContextWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bBvs5.RendererContextProvider), {
        value: {
            nestedRendererType: 'syncedBlock'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "sync-block-renderer-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67O0h.default), {
        appearance: appearance,
        adfStage: "stage0",
        document: doc,
        disableHeadingIDs: true,
        dataProviders: dataProviders,
        nodeComponents: nodeComponents,
        allowAltTextOnImages: allowAltTextOnImages,
        allowAnnotations: allowAnnotations,
        allowColumnSorting: allowColumnSorting,
        allowCopyToClipboard: allowCopyToClipboard,
        allowCustomPanels: allowCustomPanels,
        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
        allowPlaceholderText: allowPlaceholderText,
        allowRendererContainerStyles: allowRendererContainerStyles,
        allowSelectAllTrap: allowSelectAllTrap,
        allowUgcScrubber: allowUgcScrubber,
        allowWrapCodeBlock: allowWrapCodeBlock,
        disableTableOverflowShadow: true,
        emojiResourceConfig: emojiResourceConfig,
        eventHandlers: eventHandlers,
        media: media,
        smartLinks: smartLinks,
        stickyHeaders: stickyHeaders,
        contentMode: contentMode
    })))));
});






var $d925B = parcelRequire("d925B");


var $hWRJP = parcelRequire("hWRJP");


var $e6n00 = parcelRequire("e6n00");


var $cFpEg = parcelRequire("cFpEg");

var $gtauf = parcelRequire("gtauf");






/* SyncedBlockEntityNotFoundError.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $cQHTi = parcelRequire("cQHTi");


var $dZMVn = parcelRequire("dZMVn");


var $auNCB = parcelRequire("auNCB");

/* SyncedBlockErrorStateCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $744ND = parcelRequire("744ND");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");

const $167b82dc4ac7f177$var$styles = {
    wrapper: "_zulppxbi _1rjc12x7 _bozgpxbi _1e0c1txw _1bahv2br _4cvr1h6o",
    container: "_1e0c1txw"
};
const $167b82dc4ac7f177$export$dc0ab13618635cb1 = ({ children: children, description: description, icon: icon })=>{
    const Icon = icon ?? (0, (/*@__PURE__*/$parcel$interopDefault($744ND)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $167b82dc4ac7f177$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $167b82dc4ac7f177$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        color: "var(--ds-icon-subtle, #505258)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle"
    }, description)), children);
};


const $174edb1be82b4c25$var$styles = {
    link: "_4bfu1r31 _1hmsglyw _ajmmnqa1"
};
const $174edb1be82b4c25$export$c15feb10af1ecdbf = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const description = formatMessage((0, $fzXn1.syncBlockMessages).entityNotFoundDescription, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
                href: (0, $cQHTi.SYNCED_BLOCKS_DOCUMENTATION_URL),
                target: "_blank",
                rel: "noopener noreferrer",
                xcss: $174edb1be82b4c25$var$styles.link
            }, chunks)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $167b82dc4ac7f177$export$dc0ab13618635cb1), {
        description: description,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dZMVn)))
    });
};












const $f85682255cf077df$export$59b0b39f63011407 = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $167b82dc4ac7f177$export$dc0ab13618635cb1), {
        description: formatMessage((0, $fzXn1.syncBlockMessages).generalErrorDescription)
    });
};


/* SyncedBlockLoadError.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $ccHMk = parcelRequire("ccHMk");








const $5e5c198b585256f8$var$styles = {
    buttonContainer: "_18u0u2gc _1e0c1txw _4cvr1h6o"
};
const $5e5c198b585256f8$export$ca85b0be86ccfb26 = ({ onRetry: onRetry, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "default",
        spacing: "compact",
        onClick: (event)=>{
            event.preventDefault();
            event.stopPropagation();
            onRetry?.();
        },
        isLoading: isLoading,
        testId: "sync-block-retry-btn"
    }, formatMessage((0, $fzXn1.syncBlockMessages).retryButton));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $167b82dc4ac7f177$export$dc0ab13618635cb1), {
        description: formatMessage((0, $fzXn1.syncBlockMessages).generalErrorDescription)
    }, onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $5e5c198b585256f8$var$styles.buttonContainer
    }, button));
};


/* SyncedBlockNotFoundError.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $1qfLF = parcelRequire("1qfLF");


var $61p3e = parcelRequire("61p3e");




var $9eOvr = parcelRequire("9eOvr");


var $hmuev = parcelRequire("hmuev");


var $aRCWA = parcelRequire("aRCWA");










var $9hlns = parcelRequire("9hlns");


const $feacbaab62ed6a89$var$styles = {
    link: "_4bfu1r31 _1hmsglyw _ajmmnqa1",
    spinner: "_1rjcutpp _1e0c1txw _1bah1h6o",
    closeButton: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _1bahesu3"
};
const $feacbaab62ed6a89$var$errorMap = {
    'source-block-unsynced': {
        description: (0, $fzXn1.syncBlockMessages).sourceUnsyncedDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dZMVn)))
    },
    'source-block-deleted': {
        description: (0, $fzXn1.syncBlockMessages).sourceDeletedDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dZMVn)))
    },
    'source-block-unpublished': {
        description: (0, $fzXn1.syncBlockMessages).sourceDeletedDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dZMVn)))
    },
    'source-document-deleted': {
        description: (0, $fzXn1.syncBlockMessages).notFoundDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aRCWA)))
    },
    generic: {
        description: (0, $fzXn1.syncBlockMessages).genericNotFoundDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dZMVn)))
    }
};
const $feacbaab62ed6a89$var$useErrorInfo = (reason, url, title)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    if (reason === 'source-document-deleted') {
        const { icon: icon, description: description } = $feacbaab62ed6a89$var$errorMap['source-document-deleted'];
        return {
            description: formatMessage(description),
            icon: icon
        };
    }
    if (!url || !title) {
        const { icon: icon, description: description } = $feacbaab62ed6a89$var$errorMap['generic'];
        return {
            description: formatMessage(description),
            icon: icon
        };
    }
    const { icon: icon, description: description } = $feacbaab62ed6a89$var$errorMap[reason || 'generic'] ?? $feacbaab62ed6a89$var$errorMap['generic'];
    return {
        description: formatMessage(description, {
            title: title,
            a: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
                    href: url,
                    target: "_blank",
                    rel: 'noopener noreferrer',
                    xcss: $feacbaab62ed6a89$var$styles.link
                }, chunk)
        }),
        icon: icon
    };
};
const $feacbaab62ed6a89$export$3f73b17e61025be6 = ({ reason: reason = 'source-block-deleted', sourceAri: sourceAri })=>{
    const { deleteSyncBlock: deleteSyncBlock, fetchSourceInfo: fetchSourceInfo } = (0, $9eOvr.useSyncBlockActions)() ?? {};
    const [sourceInfo, setSourceInfo] = (0, $42omo.useState)(undefined);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    (0, $42omo.useEffect)(()=>{
        if (!sourceAri || // Only fetch source info for these 3 cases
        ![
            'source-block-deleted',
            'source-block-unsynced',
            'source-block-unpublished'
        ].includes(reason)) {
            setSourceInfo({});
            return;
        }
        const getSourceInfo = async ()=>{
            const sourceInfo = await fetchSourceInfo?.(sourceAri, true);
            setSourceInfo({
                url: sourceInfo?.url,
                title: sourceInfo?.title
            });
        };
        getSourceInfo();
    }, [
        reason,
        sourceAri,
        fetchSourceInfo
    ]);
    const { description: description, icon: icon } = $feacbaab62ed6a89$var$useErrorInfo(reason, sourceInfo?.url, sourceInfo?.title);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, sourceInfo === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $feacbaab62ed6a89$var$styles.spinner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $167b82dc4ac7f177$export$dc0ab13618635cb1), {
        description: description,
        icon: icon
    }, deleteSyncBlock && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $feacbaab62ed6a89$var$styles.closeButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: formatMessage((0, $61p3e.default).delete),
        onClick: deleteSyncBlock
    }))));
};












const $9db02b4444c232ef$export$8a461f6033aecd80 = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $167b82dc4ac7f177$export$dc0ab13618635cb1), {
        description: formatMessage((0, $fzXn1.syncBlockMessages).offlineError)
    });
};


/**
 * @generated SignedSource<<0c6c51fca90b1d8be221569188b41155>>
 * @relayHash 676631e44ffd7d0d16b3a7e96ba02def
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 68a651ca7e5a5c9b5a075954ed948672c451b0f8c255f4edbd3219fe4947484d
const $81e8fecca2e99343$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "requestPageAccessInput"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "requestPageAccessInput",
                    "variableName": "requestPageAccessInput"
                }
            ],
            "concreteType": "RequestPageAccessPayload",
            "kind": "LinkedField",
            "name": "requestPageAccess",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SyncedBlockPermissionDeniedRequestAccessMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SyncedBlockPermissionDeniedRequestAccessMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "68a651ca7e5a5c9b5a075954ed948672c451b0f8c255f4edbd3219fe4947484d",
            "metadata": {},
            "name": "SyncedBlockPermissionDeniedRequestAccessMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$81e8fecca2e99343$var$node.hash = "d0d4982ad805583380d2436a8e21ee6a";
var $81e8fecca2e99343$export$2e2bcd8739ae039 = $81e8fecca2e99343$var$node;









var $irOoi = parcelRequire("irOoi");







/**
 * Sends a "request access" notification for a Jira work item the current viewer
 * cannot see. A copy of jira/src/packages/platform/space-not-found-with-request-access/src/requestSpaceAccess.tsx
 */ const $cb6ec007f12d3cc7$var$REQUEST_ACCESS_URL = '/rest/internal/latest/project-access/access-requested';
const $cb6ec007f12d3cc7$export$47e85d58c126fc4d = (payload)=>{
    // we return nothing on purpose to be vague, not disclose if the project exists or not,
    // so we use fetch instead of performPutRequest as performPutRequest will return null for empty response
    return fetch($cb6ec007f12d3cc7$var$REQUEST_ACCESS_URL, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });
};



var $cO1el = parcelRequire("cO1el");


var $3sFtD = parcelRequire("3sFtD");


var $gj7hi = parcelRequire("gj7hi");




var $1s5hv = parcelRequire("1s5hv");

var $eyWa4 = parcelRequire("eyWa4");



var $682ccca673fecc9d$exports = {};
$682ccca673fecc9d$exports = new URL("PermissionDenied.bfcb6211.svg", import.meta.url).toString();



const $a081b56695b04c74$var$styles = {
    wrapper: "_zulppxbi _ca0qv47k _n3tdv47k _19bvv47k _u5f3v47k _1e0c1txw _1bahv2br _4cvr1h6o"
};
var $a081b56695b04c74$var$RequestAccessState = /*#__PURE__*/ function(RequestAccessState) {
    RequestAccessState["default"] = "default";
    RequestAccessState["errored"] = "errored";
    RequestAccessState["loading"] = "loading";
    RequestAccessState["pending"] = "pending";
    return RequestAccessState;
}($a081b56695b04c74$var$RequestAccessState || {});
const $a081b56695b04c74$var$SyncedBlockPermissionDeniedConfluencePage = ({ sourceContentId: sourceContentId })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [requestAccessState, setRequestAccessState] = (0, $42omo.useState)("default");
    const handleRequestComplete = ()=>{
        setRequestAccessState("pending");
    };
    const handleRequestError = ()=>{
        setRequestAccessState("errored");
    };
    const [commitMutation] = (0, $irOoi.useMutation)((0, $81e8fecca2e99343$export$2e2bcd8739ae039));
    const onClick = ()=>{
        setRequestAccessState("loading");
        commitMutation({
            variables: {
                requestPageAccessInput: {
                    pageId: sourceContentId,
                    accessType: 'VIEW'
                }
            },
            onCompleted: ()=>{
                handleRequestComplete();
            },
            onError: handleRequestError
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $a081b56695b04c74$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($682ccca673fecc9d$exports))),
        alt: formatMessage((0, $fzXn1.syncBlockMessages).permissionDeniedAltText),
        width: "48",
        height: "48"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall"
    }, formatMessage((0, $fzXn1.syncBlockMessages).permissionDeniedHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle"
    }, formatMessage((0, $fzXn1.syncBlockMessages).permissionDeniedDescription)), requestAccessState === "pending" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        columnGap: "space.050",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
        size: "small",
        color: "var(--ds-icon-subtle, #505258)",
        label: formatMessage((0, $fzXn1.syncBlockMessages).accessRequested)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest",
        weight: "bold",
        testId: "sync-block-access-requested-msg"
    }, formatMessage((0, $fzXn1.syncBlockMessages).accessRequested))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        columnGap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "default",
        spacing: "compact",
        onClick: onClick,
        isLoading: requestAccessState === "loading",
        testId: "sync-block-request-access-btn"
    }, formatMessage((0, $fzXn1.syncBlockMessages).requestAccessButton)), requestAccessState === "errored" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.warning",
        testId: "sync-block-access-error-msg"
    }, formatMessage((0, $fzXn1.syncBlockMessages).requestAccessError)))));
};
const $a081b56695b04c74$var$SyncedBlockPermissionDeniedJiraWorkItem = ({ sourceContentId: sourceContentId, accountId: accountId })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [requestAccessState, setRequestAccessState] = (0, $42omo.useState)("default");
    const onClick = (0, $42omo.useCallback)(async ()=>{
        setRequestAccessState("loading"); // Fire and forget. Per the Jira backend contract the response is
        // intentionally opaque (empty 204 on success, generic on failure) to
        // prevent issue-existence enumeration. We always end in `pending`.
        try {
            await (0, $cb6ec007f12d3cc7$export$47e85d58c126fc4d)({
                accountId: accountId,
                issueId: Number(sourceContentId) || null,
                projectKey: null
            });
        } catch (_e) {}
        setRequestAccessState("pending");
    }, [
        accountId,
        sourceContentId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $a081b56695b04c74$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($682ccca673fecc9d$exports))),
        alt: formatMessage((0, $fzXn1.syncBlockMessages).permissionDeniedAltText),
        width: "48",
        height: "48"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall"
    }, formatMessage((0, $fzXn1.syncBlockMessages).permissionDeniedHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle"
    }, formatMessage((0, $fzXn1.syncBlockMessages).permissionDeniedDescription)), requestAccessState === "pending" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        columnGap: "space.050",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
        size: "small",
        color: "var(--ds-icon-subtle, #505258)",
        label: formatMessage((0, $fzXn1.syncBlockMessages).accessRequested)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest",
        weight: "bold",
        testId: "sync-block-access-requested-msg"
    }, formatMessage((0, $fzXn1.syncBlockMessages).accessRequested))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        columnGap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "default",
        spacing: "compact",
        onClick: onClick,
        isLoading: requestAccessState === "loading",
        testId: "sync-block-request-access-btn"
    }, formatMessage((0, $fzXn1.syncBlockMessages).requestAccessButton)))));
};
const $a081b56695b04c74$export$33325aff698460b9 = ({ sourceContentId: sourceContentId, sourceProduct: sourceProduct, accountId: accountId })=>{
    switch(sourceProduct){
        case 'confluence-page':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a081b56695b04c74$var$SyncedBlockPermissionDeniedConfluencePage, {
                sourceContentId: sourceContentId
            });
        case 'jira-work-item':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a081b56695b04c74$var$SyncedBlockPermissionDeniedJiraWorkItem, {
                sourceContentId: sourceContentId,
                accountId: accountId
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f85682255cf077df$export$59b0b39f63011407), null);
    }
};


/* SyncedBlockUnpublishedError.tsx generated by @compiled/babel-plugin v0.36.1 */ 















const $99e9b8c546355e27$var$styles = {
    link: "_4bfu1r31 _1hmsglyw _ajmmnqa1"
};
const $99e9b8c546355e27$export$a78c0479e6ca5528 = ({ sourceURL: sourceURL, sourceProduct: sourceProduct })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)(); // Pick the product-specific copy. Jira work items are described as "the item's
    // description is saved" rather than "the page is published" because Jira issues
    // don't have a page-level publish action — the description field is what's
    // being authored.
    const message = sourceProduct === 'jira-work-item' ? (0, $fzXn1.syncBlockMessages).unpublishedErrorJiraWorkItem : (0, $fzXn1.syncBlockMessages).unpublishedError;
    const description = formatMessage(message, {
        link: (chunks)=>sourceURL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
                href: sourceURL,
                target: "_blank",
                rel: 'noopener noreferrer',
                xcss: $99e9b8c546355e27$var$styles.link
            }, chunks) : chunks
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $167b82dc4ac7f177$export$dc0ab13618635cb1), {
        description: description,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aRCWA)))
    });
};


const $ea1f07a46e6e26ea$var$getForbiddenErrorContent = (resourceId, fireAnalyticsEvent, getAccountId)=>{
    try {
        if (!resourceId) throw new Error('Missing resource id');
        const { sourceContentId: sourceContentId, sourceProduct: sourceProduct } = (0, $gtauf.getContentIdAndProductFromResourceId)(resourceId);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a081b56695b04c74$export$33325aff698460b9), {
            sourceContentId: sourceContentId,
            sourceProduct: sourceProduct,
            accountId: getAccountId?.() ?? null
        });
    } catch (error) {
        (0, $hWRJP.logException)(error, {
            location: 'editor-synced-block-renderer/SyncedBlockErrorComponent'
        });
        fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f85682255cf077df$export$59b0b39f63011407), null);
    }
};
const $ea1f07a46e6e26ea$export$f4d17ad2341a04f8 = ({ error: error, isLoading: isLoading, onRetry: onRetry, resourceId: resourceId, fireAnalyticsEvent: fireAnalyticsEvent, sourceURL: sourceURL, getAccountId: getAccountId })=>{
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent?.({
            action: (0, $d925B.ACTION).ERROR,
            actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH,
            attributes: {
                error: `${error?.reason || error?.type}: error component rendered`,
                resourceId: resourceId
            },
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
    }, [
        error?.reason,
        error?.type,
        resourceId,
        fireAnalyticsEvent
    ]);
    const getErrorContent = (0, $42omo.useMemo)(()=>{
        switch(error?.type){
            case (0, $awHlv.SyncBlockError).EntityNotFound:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $174edb1be82b4c25$export$c15feb10af1ecdbf), null);
            case (0, $awHlv.SyncBlockError).Offline:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9db02b4444c232ef$export$8a461f6033aecd80), null);
            case (0, $awHlv.SyncBlockError).Forbidden:
                return $ea1f07a46e6e26ea$var$getForbiddenErrorContent(resourceId, fireAnalyticsEvent, getAccountId);
            case (0, $awHlv.SyncBlockError).NotFound:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $feacbaab62ed6a89$export$3f73b17e61025be6), {
                    reason: error.reason,
                    sourceAri: error.sourceAri
                });
            case (0, $awHlv.SyncBlockError).Unpublished:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $99e9b8c546355e27$export$a78c0479e6ca5528), {
                    sourceURL: sourceURL,
                    sourceProduct: (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)
                });
            case (0, $awHlv.SyncBlockError).Errored:
            case (0, $awHlv.SyncBlockError).RateLimited:
            case (0, $awHlv.SyncBlockError).ServerError:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5e5c198b585256f8$export$ca85b0be86ccfb26), {
                    onRetry: onRetry,
                    isLoading: isLoading
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f85682255cf077df$export$59b0b39f63011407), null);
        }
    }, [
        error,
        isLoading,
        onRetry,
        resourceId,
        fireAnalyticsEvent,
        sourceURL,
        getAccountId
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "sync-block-error",
        className: (0, $e6n00.SyncBlockSharedCssClassName).error
    }, getErrorContent));
};


/* SyncedBlockLoadingState.tsx generated by @compiled/babel-plugin v0.36.1 */ 

















const $ab0addd976e372f3$var$styles = {
    wrapper: "_1tkevbgk _1e0c1txw _1bah1h6o _4cvr1h6o"
};
const $ab0addd976e372f3$export$6d2e5b4986b73a9a = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $e6n00.SyncBlockSharedCssClassName).loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ab0addd976e372f3$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "small",
        label: formatMessage((0, $fzXn1.syncBlockMessages).loadingSyncedContent)
    }))));
};


function $288964647d5dddb7$export$6942d731e9271481({ syncBlockInstance: syncBlockInstance, isLoading: isLoading, rendererOptions: rendererOptions, providerFactory: providerFactory, reloadData: reloadData, fireAnalyticsEvent: fireAnalyticsEvent, resourceId: resourceId, isOffline: isOffline, error: error, getAccountId: getAccountId }) {
    const isSSRMode = (0, $eTj7Y.isSSR)();
    if (isOffline && !isSSRMode) return {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ea1f07a46e6e26ea$export$f4d17ad2341a04f8), {
            error: {
                type: (0, $awHlv.SyncBlockError).Offline
            }
        }),
        isSuccess: false
    };
    if (isLoading && !syncBlockInstance) return {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ab0addd976e372f3$export$6d2e5b4986b73a9a), null),
        isSuccess: false
    };
    if (isSSRMode && syncBlockInstance?.error) return {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ab0addd976e372f3$export$6d2e5b4986b73a9a), null),
        isSuccess: false
    };
    if (!resourceId || syncBlockInstance?.error || !syncBlockInstance?.data || syncBlockInstance.data.status === 'deleted') {
        const errorToDisplay = error ?? syncBlockInstance?.error ?? (syncBlockInstance?.data?.status === 'deleted' ? {
            type: (0, $awHlv.SyncBlockError).NotFound
        } : {
            type: (0, $awHlv.SyncBlockError).Errored
        });
        return {
            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ea1f07a46e6e26ea$export$f4d17ad2341a04f8), {
                error: errorToDisplay,
                resourceId: resourceId,
                onRetry: reloadData,
                isLoading: isLoading,
                fireAnalyticsEvent: fireAnalyticsEvent,
                getAccountId: getAccountId
            }),
            isSuccess: false
        };
    }
    if (syncBlockInstance?.data?.status === 'unpublished') return {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ea1f07a46e6e26ea$export$f4d17ad2341a04f8), {
            /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ error: {
                type: (0, $awHlv.SyncBlockError).Unpublished
            },
            resourceId: resourceId,
            sourceURL: syncBlockInstance.data?.sourceURL,
            fireAnalyticsEvent: fireAnalyticsEvent,
            getAccountId: getAccountId
        }),
        isSuccess: false
    };
    const syncBlockDoc = {
        content: syncBlockInstance.data.content,
        version: 1,
        type: 'doc'
    };
    return {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a04998616bd329fd$export$cc2ec5e10e7ca244), {
            doc: syncBlockDoc,
            dataProviders: providerFactory,
            options: rendererOptions
        }),
        isSuccess: true
    };
}
module.exports["renderSyncedBlockContent"] = $288964647d5dddb7$export$6942d731e9271481;

});

parcelRegister("gsPOZ", function(module, exports) {
/**
 * @generated SignedSource<<eba967ef43ce0005d9aebfc0d15e70bc>>
 * @relayHash 3e442d5d3227540b5f9648827533c2f8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cd1ae3e91e6cce9d7c559a091c26b1b5d144b0cbd98427fa9498628b398d03cd
const $11aa77d8f290fc7b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "resourceId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "resourceId",
                    "variableName": "resourceId"
                }
            ],
            "concreteType": "BlockServiceBlockPayload",
            "kind": "LinkedField",
            "name": "blockService_onBlockUpdated",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "blockAri"
                },
                {
                    "kind": "ScalarField",
                    "name": "blockInstanceId"
                },
                {
                    "kind": "ScalarField",
                    "name": "content"
                },
                {
                    "kind": "ScalarField",
                    "name": "contentUpdatedAt"
                },
                {
                    "kind": "ScalarField",
                    "name": "createdAt"
                },
                {
                    "kind": "ScalarField",
                    "name": "createdBy"
                },
                {
                    "kind": "ScalarField",
                    "name": "deletionReason"
                },
                {
                    "kind": "ScalarField",
                    "name": "product"
                },
                {
                    "kind": "ScalarField",
                    "name": "sourceAri"
                },
                {
                    "kind": "ScalarField",
                    "name": "status"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "relaySyncBlockFetchProviderSubscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "relaySyncBlockFetchProviderSubscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3e442d5d3227540b5f9648827533c2f8",
            "id": "cd1ae3e91e6cce9d7c559a091c26b1b5d144b0cbd98427fa9498628b398d03cd",
            "metadata": {},
            "name": "relaySyncBlockFetchProviderSubscription",
            "operationKind": "subscription",
            "text": "subscription relaySyncBlockFetchProviderSubscription($resourceId:ID!){blockService_onBlockUpdated(resourceId:$resourceId){blockAri,blockInstanceId,content,contentUpdatedAt,createdAt,createdBy,deletionReason,product,sourceAri,status}}"
        }
    };
}();
$11aa77d8f290fc7b$var$node.hash = "f3661ea7b2ab697a90b3ec5ef8d55382";
var $11aa77d8f290fc7b$export$2e2bcd8739ae039 = $11aa77d8f290fc7b$var$node;



var $3e6Uc = parcelRequire("3e6Uc");


var $ejAeh = parcelRequire("ejAeh");


var $9HB34 = parcelRequire("9HB34");

/**
 * Converts a Relay subscription response to SyncBlockInstance format.
 */ function $8642b45e2aee2bb6$var$convertRelayResponseToSyncBlockInstance(response, resourceId) {
    let createdAt;
    if (response.createdAt !== undefined && response.createdAt !== null) try {
        createdAt = new Date(response.createdAt).toISOString();
    } catch  {
        createdAt = undefined;
    }
    let contentUpdatedAt;
    if (response.contentUpdatedAt !== undefined && response.contentUpdatedAt !== null) try {
        contentUpdatedAt = new Date(response.contentUpdatedAt).toISOString();
    } catch  {
        contentUpdatedAt = undefined;
    }
    return {
        data: {
            content: JSON.parse(response.content),
            contentUpdatedAt: contentUpdatedAt,
            resourceId: response.blockAri,
            blockInstanceId: response.blockInstanceId,
            sourceAri: response.sourceAri,
            product: response.product,
            createdAt: createdAt,
            createdBy: response.createdBy,
            status: response.status
        },
        resourceId: resourceId
    };
}
function $8642b45e2aee2bb6$export$7a629188ade23de0(baseProvider, cloudId) {
    const subscription = (0, $11aa77d8f290fc7b$export$2e2bcd8739ae039);
    // Create a new provider that preserves all methods from baseProvider
    // Preserve the prototype chain to ensure all methods are accessible
    const wrappedProvider = Object.create(Object.getPrototypeOf(baseProvider));
    Object.assign(wrappedProvider, baseProvider);
    // Override subscribeToBlockUpdates with Relay subscription support
    wrappedProvider.subscribeToBlockUpdates = function(resourceId, onUpdate, onError, onComplete) {
        // Get the Relay environment — returns null when SSR or tests haven't initialised it.
        const environment = (0, $9HB34.getRelayEnvironment)();
        if (!environment) {
            onError?.(new Error('Relay environment not available'));
            return ()=>{};
        }
        // Convert resourceId to blockAri for the subscription
        const blockAri = (0, $ejAeh.generateBlockAriFromReference)({
            cloudId: cloudId,
            resourceId: resourceId
        });
        let disposable = null;
        try {
            disposable = (0, $3e6Uc.requestSubscription)(environment, {
                subscription: subscription,
                variables: {
                    resourceId: blockAri
                },
                onNext: (response)=>{
                    if (response?.blockService_onBlockUpdated) {
                        const syncBlockInstance = $8642b45e2aee2bb6$var$convertRelayResponseToSyncBlockInstance(response.blockService_onBlockUpdated, resourceId);
                        onUpdate(syncBlockInstance);
                    }
                },
                onError: (error)=>{
                    // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
                    onError?.(error);
                },
                onCompleted: ()=>{
                    onComplete?.();
                }
            });
        } catch (error) {
            onError?.(error instanceof Error ? error : new Error(String(error)));
            // Return a no-op unsubscribe if subscription fails
            return ()=>{};
        }
        return ()=>{
            if (disposable) disposable.dispose();
        };
    };
    return wrappedProvider;
}
module.exports["createRelaySyncBlockFetchProvider"] = $8642b45e2aee2bb6$export$7a629188ade23de0;

});

parcelRegister("epn2u", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

const $950ecc7cad6e8d10$export$e09386e914855e84 = ()=>{
    // Fire a client-side exposure for the SSR preload experiment. The experiment is only
    // evaluated in SSR preload code where the Statsig JS SDK is not initialized, so exposures
    // never reach Statsig from SSR alone. Calling manuallyLogExpExposure here — at the exact
    // point where the SSR-preloaded sync block data is consumed on the client — ensures every
    // page load records an exposure, allowing us to measure the experiment's effect accurately.
    // Once the optimal value is found, this will be converted to a permanent Statsig config.
    (0, $6mKj3.manuallyLogExpExposure)('platform_editor_sync_block_ssr_config');
    const rawSyncBlockData = typeof globalThis !== 'undefined' ? globalThis.__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__?.syncBlocks : undefined;
    if (rawSyncBlockData) return rawSyncBlockData.reduce((acc, item)=>{
        acc[item.resourceId] = item;
        return acc;
    }, {});
    return undefined;
};
module.exports["syncedBlockLoadSSRData"] = $950ecc7cad6e8d10$export$e09386e914855e84;

});

parcelRegister("BjpgS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $6mKj3 = parcelRequire("6mKj3");


var $1yB28 = parcelRequire("1yB28");


var $21K7m = parcelRequire("21K7m");


var $9FoVw = parcelRequire("9FoVw");


var $8i27m = parcelRequire("8i27m");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");

const $fcc85c86573dc170$var$i18n = (0, $aXWIB.defineMessages)({
    viewCommentsLabel: {
        id: "editor-features.media-viewer.view-comments.label",
        defaultMessage: "View comments"
    },
    commentUnavailableTitle: {
        id: "editor-features.media-viewer.comment-unavailable.title",
        defaultMessage: "This comment isn't available"
    },
    commentUnavailableDescription: {
        id: "editor-features.media-viewer.comment-unavailable.description",
        defaultMessage: "It may have been resolved or deleted."
    }
});
const $fcc85c86573dc170$var$MEDIA_VIEWER_POPUP_SELECTOR = '[data-testid="media-viewer-popup"]';
// This function exists because navigating in between previewed elements only uses the file id.
// We need a way to map that back to the annotation ID used by comments, however keeping track of
// this at a global level is likely too heavy relative to usage. Better to just compute on the fly.
function $fcc85c86573dc170$var$findAnnotationForMediaFile(annotationIds, fileId, isViewPage) {
    const activeSet = new Set(annotationIds);
    // Locate the media element directly by file ID.
    // - Renderer nodes use: <div data-node-type="media" data-id="<fileId>">
    // - Editor nodes use:   <div data-prosemirror-node-name="media" id="<fileId>">
    const mediaElement = isViewPage ? document.querySelector(`[data-node-type="media"][data-id="${fileId}"]`) : document.getElementById(fileId);
    if (!mediaElement) return undefined;
    // Walk up the DOM to find the enclosing annotation element, but stop once we
    // leave the relevant content root for the current mode.
    let current = mediaElement.parentElement;
    while(current){
        if (current.getAttribute('data-mark-annotation-type') === 'inlineComment') {
            const annotationId = current.id;
            // For view pages the mark must also be in the 'active' state.
            if (isViewPage && current.getAttribute('data-mark-annotation-state') !== 'active') return undefined;
            return activeSet.has(annotationId) ? annotationId : undefined;
        }
        // Once we reach the top of the renderer / editor container, it's safe to assume this element is not within an annotation
        if (isViewPage && current.classList.contains('ak-renderer-wrapper') || !isViewPage && current.classList.contains('ProseMirror')) return undefined;
        current = current.parentElement;
    }
    return undefined;
}
function $fcc85c86573dc170$export$4905f58a835caea6(annotationId, isCommentsPanelOpen = false) {
    (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
        annotationIds: [
            annotationId
        ],
        eventTarget: document.getElementById(annotationId)
    });
    (0, $9FoVw.handleKeyboardShortcutNavigation)({
        scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
        block: 'center',
        annotationId: annotationId,
        commentType: 'INLINE',
        isCommentsPanelOpen: isCommentsPanelOpen,
        context: (0, $9FoVw.NavigationContext).RENDERER
    });
}
function $fcc85c86573dc170$export$4485dd592403beab(annotationId, isCommentsPanelOpen = false) {
    const markElement = document.getElementById(annotationId);
    if (markElement) {
        (0, $gfqXk.getEditorAnnotationEventEmitter)().emit('setselectedannotation', annotationId);
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: annotationId,
            commentType: 'INLINE',
            isCommentsPanelOpen: isCommentsPanelOpen,
            context: (0, $9FoVw.NavigationContext).EDITOR
        });
    }
}
// Used to handle cases where another user removed this comment
function $fcc85c86573dc170$var$showUnavailableCommentFlag(flags, title, description) {
    flags?.showWarningFlag({
        id: 'media-viewer-comment-unavailable',
        title: title,
        description: description
    });
}
const $fcc85c86573dc170$var$MEDIA_VIEWER_UNMOUNT_TIMEOUT_MS = 2000;
/**
 * Waits for the media viewer popup to be removed from the DOM before invoking `callback`.
 * If the popup is already gone (e.g. it unmounted synchronously), the callback fires on
 * the next animation frame. A safety timeout ensures the callback always fires even if
 * the DOM mutation is never observed.
 */ function $fcc85c86573dc170$var$waitForMediaViewerUnmount(callback) {
    const popup = document.querySelector($fcc85c86573dc170$var$MEDIA_VIEWER_POPUP_SELECTOR);
    if (!popup) {
        // Already unmounted — fire after a rAF to let React finish any pending work.
        requestAnimationFrame(callback);
        return;
    }
    const observer = new MutationObserver(()=>{
        if (!document.querySelector($fcc85c86573dc170$var$MEDIA_VIEWER_POPUP_SELECTOR)) {
            observer.disconnect();
            clearTimeout(safetyTimer);
            requestAnimationFrame(callback);
        }
    });
    // The media viewer is rendered inside an Atlaskit portal (atlaskit-portal-container),
    // so we observe document.body with subtree:true to catch the removal regardless of
    // how deep in the portal tree the popup lives.
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // Safety net: if the observer never fires (e.g. the popup is removed in an
    // unexpected way), ensure we still invoke the callback.
    const safetyTimer = window.setTimeout(()=>{
        observer.disconnect();
        callback();
    }, $fcc85c86573dc170$var$MEDIA_VIEWER_UNMOUNT_TIMEOUT_MS);
}
function $fcc85c86573dc170$export$bd892f36627deebf({ isViewPage: isViewPage, analyticsSource: analyticsSource, flags: flags }) {
    const intl = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { getCurrentCommentsPanelState: getCurrentCommentsPanelState } = (0, $8i27m.useCommentsDataActions)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const isCommentsPanelShown = isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel;
    return (0, $42omo.useMemo)(()=>{
        if (!(0, $6mKj3.expValEquals)('cc_comments_media_preview_integration', 'isEnabled', true)) return undefined;
        const getActiveAnnotationIds = ()=>getCurrentCommentsPanelState().orderedActiveAnnotationIdList?.map(({ threadKey: threadKey })=>threadKey) ?? [];
        return {
            headerActions: [
                {
                    label: intl.formatMessage($fcc85c86573dc170$var$i18n.viewCommentsLabel),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                        label: "",
                        spacing: "spacious"
                    }),
                    isVisible: (identifier)=>{
                        // Only show icon when image has comments
                        // NOTE - this is called whenever the header section is rendered (can be multiple times per image), so be careful with non-performant updates!
                        // Media viewer identifiers can also be external-image items, which do not have an `id`.
                        if (!('id' in identifier)) return false;
                        const annotationId = $fcc85c86573dc170$var$findAnnotationForMediaFile(getActiveAnnotationIds(), identifier.id, isViewPage);
                        return !!annotationId;
                    },
                    onClick: (identifier, actions)=>{
                        // Media viewer identifiers can also be external-image items, which do not have an `id`.
                        if (!('id' in identifier)) return;
                        // Re-check on click in case the comment was deleted or resolved after the button rendered.
                        const annotationId = $fcc85c86573dc170$var$findAnnotationForMediaFile(getActiveAnnotationIds(), identifier.id, isViewPage);
                        // Fire regardless of outcome, so we can get proper click data
                        createAnalyticsEvent({
                            type: 'sendUIEvent',
                            data: {
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: 'mediaPreviewCommentsButton',
                                source: analyticsSource,
                                attributes: {
                                    context: 'mediaViewer',
                                    fileId: identifier.id,
                                    annotationId: annotationId ?? null
                                }
                            }
                        }).fire();
                        if (!annotationId) {
                            $fcc85c86573dc170$var$showUnavailableCommentFlag(flags, intl.formatMessage($fcc85c86573dc170$var$i18n.commentUnavailableTitle), intl.formatMessage($fcc85c86573dc170$var$i18n.commentUnavailableDescription));
                            return;
                        }
                        actions.close();
                        // Defer navigation until after the viewer close has started so selection and scrolling
                        // happen against the underlying page, not the still-open modal.
                        if (isViewPage) requestAnimationFrame(()=>{
                            $fcc85c86573dc170$export$4905f58a835caea6(annotationId, isCommentsPanelShown);
                        });
                        else $fcc85c86573dc170$var$waitForMediaViewerUnmount(()=>{
                            $fcc85c86573dc170$export$4485dd592403beab(annotationId, isCommentsPanelShown);
                        });
                    }
                }
            ]
        };
    }, [
        analyticsSource,
        createAnalyticsEvent,
        flags,
        getCurrentCommentsPanelState,
        intl,
        isCommentsPanelShown,
        isViewPage
    ]);
}
module.exports["useMediaCommentExtensions"] = $fcc85c86573dc170$export$bd892f36627deebf;

});

parcelRegister("8wppk", function(module, exports) {

var $8z3oB = parcelRequire("8z3oB");

const $f3689d580c651296$var$CONNECT_MACRO_EXTENSION_TYPE = 'com.atlassian.confluence.macro.core';
const $f3689d580c651296$var$FORGE_EXTENSION_TYPE = 'com.atlassian.ecosystem';
const $f3689d580c651296$var$EMBEDDED_FAUS_MESSAGE_PREFIX = 'messageFromEmbeddedFAUS_';
const $f3689d580c651296$var$EMBEDDED_FAUS_ANALYTICS_PREFIX = 'analyticsFromEmbeddedFAUS_';
const $f3689d580c651296$var$EMBEDDED_FAUS_FETCH_APP_KEY_PREFIX = 'fetchAppKeyFromEmbeddedFAUS_';
let $f3689d580c651296$var$postRobotOn = null;

if (typeof window !== 'undefined') $f3689d580c651296$var$postRobotOn = (parcelRequire("eLUTa")).postRobotOn;
const $f3689d580c651296$var$getFausDomain = ()=>{
    // allow all domains in development mode
    return `${window.location.protocol}//${window.location.hostname}`;
};
const $f3689d580c651296$var$hasForgeDescendant = (nodes)=>{
    if (!nodes) return false;
    for (const node of nodes){
        if ((node.type === 'extension' || node.type === 'inlineExtension' || node.type === 'bodiedExtension') && node.attrs?.extensionType === $f3689d580c651296$var$FORGE_EXTENSION_TYPE) return true;
        if ($f3689d580c651296$var$hasForgeDescendant(node.content)) return true;
    }
    return false;
};
const $f3689d580c651296$var$getConnectMacroIdentifiers = (node)=>{
    const localId = node.attrs?.localId;
    const macroId = node.attrs?.parameters?.macroMetadata?.macroId?.value;
    return [
        localId,
        macroId
    ].filter((value)=>typeof value === 'string');
};
/**
 * Walk the ADF tree and return identifiers for Connect bodied macros whose
 * body content contains at least one Forge extension.
 *
 * Note: forwarded FAUS messages currently target the Connect macro's
 * `macroMetadata.macroId.value`, not the ADF node `attrs.localId`.
 */ const $f3689d580c651296$var$findConnectBodiedMacrosWithForgeChildren = (adf)=>{
    const result = new Set();
    if (!adf?.content) return result;
    const walk = (nodes)=>{
        for (const node of nodes){
            if (node.type === 'bodiedExtension' && node.attrs?.extensionType === $f3689d580c651296$var$CONNECT_MACRO_EXTENSION_TYPE && $f3689d580c651296$var$hasForgeDescendant(node.content)) for (const identifier of $f3689d580c651296$var$getConnectMacroIdentifiers(node))result.add(identifier);
            if (node.content) walk(node.content);
        }
    };
    walk(adf.content);
    return result;
};
/**
 * Walk the ADF tree and return `localId` values for Forge extension nodes
 * (`com.atlassian.ecosystem`) that are nested inside Connect bodied macros.
 *
 * FAUS uses the Forge extension's own `localId` as the channel identifier
 * when forwarding bridge calls via `messageFromEmbeddedFAUS_<localId>`.
 */ const $f3689d580c651296$var$findForgeMacroLocalIds = (adf)=>{
    const result = new Set();
    if (!adf?.content) return result;
    const walk = (nodes, insideConnectMacro)=>{
        for (const node of nodes){
            const isConnectBodiedMacro = node.type === 'bodiedExtension' && node.attrs?.extensionType === $f3689d580c651296$var$CONNECT_MACRO_EXTENSION_TYPE;
            if (insideConnectMacro && (node.type === 'extension' || node.type === 'inlineExtension' || node.type === 'bodiedExtension') && node.attrs?.extensionType === $f3689d580c651296$var$FORGE_EXTENSION_TYPE && node.attrs?.localId) result.add(node.attrs.localId);
            if (node.content) walk(node.content, insideConnectMacro || isConnectBodiedMacro);
        }
    };
    walk(adf.content, false);
    return result;
};
const $f3689d580c651296$var$buildBridgeEventHandlers = (flagProvider, options)=>{
    const handlers = {};
    if (flagProvider) {
        handlers.showFlag = (payload)=>{
            const actions = payload.actions;
            const flagActions = actions?.map((action)=>({
                    ...action,
                    onClick: action.onClick ? action.onClick : ()=>{}
                }));
            flagProvider.showFlag({
                ...payload,
                actions: flagActions
            });
        };
        handlers.closeFlag = (payload)=>{
            flagProvider.closeFlag(payload);
        };
    }
    if (options?.onEmbeddedForgeOpenModal) {
        const onOpenModal = options.onEmbeddedForgeOpenModal;
        handlers.openModal = (payload)=>{
            // `payload.extension` is required to render the modal — if it's
            // missing the bridge call is malformed and we silently drop it
            // rather than rendering an empty modal.
            if (!payload.extension) return;
            onOpenModal(payload);
        };
    }
    return handlers;
};
/**
 * Register postRobot listeners for a single Connect-macro identifier.
 *
 * Sets up a message channel (`messageFromEmbeddedFAUS_<id>`) that dispatches
 * incoming bridge calls to the matching handler, and an analytics channel
 * (`analyticsFromEmbeddedFAUS_<id>`) that acknowledges events to prevent
 * "No handler found" errors from postRobot.
 *
 * @returns An array of cancel functions for every registered listener.
 */ const $f3689d580c651296$var$setupBridgeListeners = (on, identifier, productHostname, handlers)=>{
    const cancelFns = [];
    const originDomain = $f3689d580c651296$var$getFausDomain();
    const messageHandler = on(`${$f3689d580c651296$var$EMBEDDED_FAUS_MESSAGE_PREFIX}${identifier}`, {
        domain: originDomain
    }, (event)=>{
        const originUrl = new URL(event.origin);
        if (originUrl.hostname !== productHostname) return Promise.resolve();
        const { eventKey: eventKey, ...payload } = event.data ?? {};
        const handler = typeof eventKey === 'string' ? handlers[eventKey] : undefined;
        if (handler) handler(payload);
        return Promise.resolve();
    });
    cancelFns.push(messageHandler.cancel);
    // FAUS also sends a one-shot `analyticsFromEmbeddedFAUS_<id>` message per
    // identifier so embedded Forge apps can forward analytics events (UI, track,
    // operational, screen) to the product. In the normal Forge-in-Forge case this
    // is handled by ForgeUIExtensionPointProvider which has access to the product's
    // AnalyticsWebClient (see ForgeUIExtensionPointProvider.tsx). In the
    // Connect-bodied-macro case there is no parent Forge provider, so we register
    // the listener here to prevent "No handler found" errors from postRobot.
    const analyticsHandler = on(`${$f3689d580c651296$var$EMBEDDED_FAUS_ANALYTICS_PREFIX}${identifier}`, {
        domain: originDomain
    }, (_event)=>{
        // TODO: forward events to the Confluence analytics pipeline once an
        // AnalyticsWebClient is plumbed through to this helper.
        // https://product-fabric.atlassian.net/browse/SCALE-8758
        return Promise.resolve();
    });
    cancelFns.push(analyticsHandler.cancel);
    return cancelFns;
};
const $f3689d580c651296$export$2710834bb826f82 = (adf, flags, options)=>{
    if (!$f3689d580c651296$var$postRobotOn) return;
    const connectMacroIdentifiers = $f3689d580c651296$var$findConnectBodiedMacrosWithForgeChildren(adf);
    const forgeMacroLocalIds = $f3689d580c651296$var$findForgeMacroLocalIds(adf);
    if (connectMacroIdentifiers.size === 0 && forgeMacroLocalIds.size === 0) return;
    const flagProvider = flags ? (0, $8z3oB.getFlagProvider)(flags) : null;
    const productHostname = window.location.hostname;
    const handlers = $f3689d580c651296$var$buildBridgeEventHandlers(flagProvider, options);
    const cancelFns = [];
    for (const identifier of connectMacroIdentifiers)cancelFns.push(...$f3689d580c651296$var$setupBridgeListeners($f3689d580c651296$var$postRobotOn, identifier, productHostname, handlers));
    for (const forgeMacroLocalId of forgeMacroLocalIds)cancelFns.push(...$f3689d580c651296$var$setupBridgeListeners($f3689d580c651296$var$postRobotOn, forgeMacroLocalId, productHostname, handlers));
    return ()=>{
        for (const cancel of cancelFns)cancel();
    };
};
const $f3689d580c651296$var$appKeyListenerRegistry = new Map();
const $f3689d580c651296$export$9039814cc3b5c36b = ()=>{
    $f3689d580c651296$var$appKeyListenerRegistry.clear();
};
const $f3689d580c651296$export$22c0e5b0fd0b5778 = (bridgeIdentifier, macroOrigin, macroId, targetWindow)=>{
    if (!$f3689d580c651296$var$postRobotOn || !macroOrigin || !bridgeIdentifier || !macroId) return;
    const requestName = `${$f3689d580c651296$var$EMBEDDED_FAUS_FETCH_APP_KEY_PREFIX}${bridgeIdentifier}`;
    const appKeyInfo = {
        connectIdentifier: bridgeIdentifier,
        connectMacroOrigin: macroOrigin,
        connectMacroId: macroId
    };
    const existingEntry = $f3689d580c651296$var$appKeyListenerRegistry.get(requestName);
    if (existingEntry) {
        existingEntry.byWindow.set(targetWindow, appKeyInfo);
        return ()=>{
            const entry = $f3689d580c651296$var$appKeyListenerRegistry.get(requestName);
            if (!entry) return;
            entry.byWindow.delete(targetWindow);
            if (entry.byWindow.size === 0) {
                entry.listenerCancel();
                $f3689d580c651296$var$appKeyListenerRegistry.delete(requestName);
            }
        };
    }
    const byWindow = new Map();
    byWindow.set(targetWindow, appKeyInfo);
    const listener = $f3689d580c651296$var$postRobotOn(requestName, {
        domain: $f3689d580c651296$var$getFausDomain()
    }, (event)=>{
        const entry = $f3689d580c651296$var$appKeyListenerRegistry.get(requestName);
        if (!entry || entry.byWindow.size === 0) return Promise.reject(new Error('No listeners registered for request'));
        const responseFromSource = event.source ? entry.byWindow.get(event.source) : undefined;
        const fallbackResponse = !responseFromSource && entry.byWindow.size === 1 ? entry.byWindow.values().next().value : undefined;
        const response = responseFromSource ?? fallbackResponse;
        if (!response) return Promise.reject(new Error('No listener registered for source window'));
        return Promise.resolve(response);
    });
    $f3689d580c651296$var$appKeyListenerRegistry.set(requestName, {
        listenerCancel: listener.cancel,
        byWindow: byWindow
    });
    return ()=>{
        const entry = $f3689d580c651296$var$appKeyListenerRegistry.get(requestName);
        if (!entry) return;
        entry.byWindow.delete(targetWindow);
        if (entry.byWindow.size === 0) {
            entry.listenerCancel();
            $f3689d580c651296$var$appKeyListenerRegistry.delete(requestName);
        }
    };
};
module.exports["registerEmbeddedMacroListeners"] = $f3689d580c651296$export$2710834bb826f82;
module.exports["registerEmbeddedFausAppKeyListener"] = $f3689d580c651296$export$22c0e5b0fd0b5778;

});

parcelRegister("6Trhx", function(module, exports) {
/**
 * @generated SignedSource<<7b142a9e5bf037e5bf84df26b0f166d8>>
 * @relayHash 5cd532f1dbaa98f680938803d44a7622
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e5ac65b8296456b7407a8600258ddf7c3aacc70dded453a67ff3cc8dff3a53e3
const $8905400aadac7d47$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "offset"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "current",
                "draft"
            ]
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "offset",
            "variableName": "offset"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "title"
    }, v6 = {
        "concreteType": "KeyValueHierarchyMap",
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v7 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "fallbackMediaNameFetcherQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "PaginatedContentList",
                                            "kind": "LinkedField",
                                            "name": "attachments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "fallbackMediaNameFetcherQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "PaginatedContentList",
                                            "kind": "LinkedField",
                                            "name": "attachments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "5cd532f1dbaa98f680938803d44a7622",
            "id": "e5ac65b8296456b7407a8600258ddf7c3aacc70dded453a67ff3cc8dff3a53e3",
            "metadata": {},
            "name": "fallbackMediaNameFetcherQuery",
            "operationKind": "query",
            "text": "query fallbackMediaNameFetcherQuery($contentId:ID!,$offset:Int,$first:Int){content(id:$contentId,status:[\"current\",\"draft\"]){edges{node{attachments(first:$first,offset:$offset){nodes{title,extensions{key,value},id},pageInfo{hasNextPage}},id}}}}"
        }
    };
}();
$8905400aadac7d47$var$node.hash = "86d114dcacd8ef1cb2ec5aab70e98d80";
var $8905400aadac7d47$export$2e2bcd8739ae039 = $8905400aadac7d47$var$node;



var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $c0rhi = parcelRequire("c0rhi");

const $16afe942cafdcc72$var$PAGE_SIZE = 50;
// setting max iterations to avoid ever getting into an infinite loop just in case
const $16afe942cafdcc72$var$MAX_ITERATIONS = 50;
const $16afe942cafdcc72$var$fallbackMediaNameFetcherQueryNode = (0, $8905400aadac7d47$export$2e2bcd8739ae039);
const $16afe942cafdcc72$export$8632f0c995082e2a = (contentId)=>async (id)=>{
        let offset = 0;
        let iterations = 0;
        let hasNextPage = true;
        while(hasNextPage && iterations < $16afe942cafdcc72$var$MAX_ITERATIONS){
            const { data: data } = await (0, $c0rhi.queryInterop)({
                query: $16afe942cafdcc72$var$fallbackMediaNameFetcherQueryNode,
                variables: {
                    contentId: contentId,
                    offset: offset,
                    first: $16afe942cafdcc72$var$PAGE_SIZE
                },
                fetchPolicy: 'cache-first',
                __callerPackage__: "@confluence/editor-features"
            }).catch((e)=>{
                if ((0, $1uFM6.isUnauthorizedError)(e) || (0, $6fil2.containsNetworkError)(e)) (0, $7Sm4c.markErrorAsHandled)(e);
                return {
                    data: null
                };
            });
            const attachments = data?.content?.edges?.[0]?.node?.attachments;
            const nodes = attachments?.nodes ?? [];
            for (const node of nodes){
                const fileId = node?.extensions?.find((ext)=>ext?.key === 'fileId')?.value;
                if (fileId === id && node?.title) return node.title;
            }
            hasNextPage = attachments?.pageInfo?.hasNextPage ?? false;
            offset += $16afe942cafdcc72$var$PAGE_SIZE;
            iterations += 1;
        }
        throw new Error(`Attachment with fileId ${id} not found on page ${contentId}`);
    };
module.exports["createFallbackMediaNameFetcher"] = $16afe942cafdcc72$export$8632f0c995082e2a;

});

parcelRegister("edEsl", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ 
var $eGqQQ = parcelRequire("eGqQQ");


var $04e9M = parcelRequire("04e9M");


var $9wGTI = parcelRequire("9wGTI");

const $027ba4852fb11225$var$requests = new Map();
const $027ba4852fb11225$var$setCacheWithTimeout = (fileId, req)=>$027ba4852fb11225$var$requests.set(fileId, req) && void setTimeout(()=>$027ba4852fb11225$var$requests.delete(fileId), 3000);
const $027ba4852fb11225$var$isDownloadEvent = (options)=>(0, $9wGTI.fg)('confluence_publish_attachment_audit_log_event') && options.viewingLevel === 'download';
const $027ba4852fb11225$var$getNotifyRequestBody = (options)=>{
    if ($027ba4852fb11225$var$isDownloadEvent(options)) return {
        attachmentDownloaded: {
            fileStoreId: options.fileId
        }
    };
    return {
        attachmentViewed: {
            fileStoreId: options.fileId
        }
    };
};
const $027ba4852fb11225$var$getTrackEventPayload = (options, contentType)=>{
    const action = $027ba4852fb11225$var$isDownloadEvent(options) ? 'downloaded' : 'viewed';
    return {
        source: 'ui',
        actionSubject: 'attachment',
        action: action,
        name: `attachment ${action}`,
        attributes: {
            activationId: options.fileId,
            pageType: contentType
        }
    };
};
const $027ba4852fb11225$var$globalMediaViewedListener = (options, contentType)=>{
    // To avoid case when user opens media-picker (and we don't want to call BE API after that)
    if (!options.isUserCollection) {
        // Sometimes globalEventMediaEmitter will invoke the globalMediaViewedListener callback
        // multiple times for a single `media-viewed` event. For this reason we return a cached
        // request promise if one exists
        const priorRequestForTheSameFileID = $027ba4852fb11225$var$requests.get(options?.fileId);
        return priorRequestForTheSameFileID || (()=>{
            const mediaViewedReq = (0, $9wGTI.fg)('confluence_event_notifier_deprecation') ? Promise.resolve({}) : fetch('/wiki/rest/internal/1.0/eventnotifier/notify', {
                method: 'POST',
                body: JSON.stringify($027ba4852fb11225$var$getNotifyRequestBody(options)),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if ((0, $9wGTI.fg)('confluence_event_notifier_updates')) (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendTrackEvent($027ba4852fb11225$var$getTrackEventPayload(options, contentType));
            });
            $027ba4852fb11225$var$setCacheWithTimeout(options.fileId, mediaViewedReq);
            return mediaViewedReq;
        })();
    }
};
let $027ba4852fb11225$var$mediaViewedListenerRegistered = false;
// make sure currentListener is a stable reference so it can be removed by .off event handler
let $027ba4852fb11225$var$currentListener = null;
const $027ba4852fb11225$export$dbbc14ed63c88dd4 = ({ contentType: contentType })=>{
    if (!$027ba4852fb11225$var$mediaViewedListenerRegistered) {
        $027ba4852fb11225$var$currentListener = (options)=>{
            $027ba4852fb11225$var$globalMediaViewedListener(options, contentType);
        };
        (0, $eGqQQ.globalMediaEventEmitter).on('media-viewed', $027ba4852fb11225$var$currentListener);
        $027ba4852fb11225$var$mediaViewedListenerRegistered = true;
    }
};
const $027ba4852fb11225$export$29046bd16724fad9 = ()=>{
    if ($027ba4852fb11225$var$currentListener) {
        (0, $eGqQQ.globalMediaEventEmitter).off('media-viewed', $027ba4852fb11225$var$currentListener);
        $027ba4852fb11225$var$currentListener = null;
        $027ba4852fb11225$var$mediaViewedListenerRegistered = false;
    }
};
module.exports["registerGlobalMediaViewedListener"] = $027ba4852fb11225$export$dbbc14ed63c88dd4;
module.exports["removeGlobalMediaViewedListener"] = $027ba4852fb11225$export$29046bd16724fad9;

});

parcelRegister("eXfot", function(module, exports) {
/**
 * @generated SignedSource<<8ed8dc03028e55b4cdab4438310d33a6>>
 * @relayHash 3f8b7bb91ace1543a1f04562b04091b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a2e2b777c5ee42b9bf48b2d4941abddb1ed952d85e1942a2be06c0d3dae63930
const $0c16356697ac10ff$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "tasks"
        },
        {
            "defaultValue": "VIEW_PAGE",
            "kind": "LocalArgument",
            "name": "trigger"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "tasks",
                            "variableName": "tasks"
                        },
                        {
                            "kind": "Variable",
                            "name": "trigger",
                            "variableName": "trigger"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "batchedInlineTasksInput"
                }
            ],
            "concreteType": "GraphQLMutationResponse",
            "kind": "LinkedField",
            "name": "setBatchedTaskStatus",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SetBatchedTaskStatusMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SetBatchedTaskStatusMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3f8b7bb91ace1543a1f04562b04091b2",
            "id": "a2e2b777c5ee42b9bf48b2d4941abddb1ed952d85e1942a2be06c0d3dae63930",
            "metadata": {},
            "name": "SetBatchedTaskStatusMutation",
            "operationKind": "mutation",
            "text": "mutation SetBatchedTaskStatusMutation($contentId:ID!,$tasks:[InlineTask]!,$trigger:PageUpdateTrigger=VIEW_PAGE){setBatchedTaskStatus(batchedInlineTasksInput:{contentId:$contentId,tasks:$tasks,trigger:$trigger}){success}}"
        }
    };
}();
$0c16356697ac10ff$var$node.hash = "69534ca77b812c2f6a503bd25527650c";
var $0c16356697ac10ff$export$2e2bcd8739ae039 = $0c16356697ac10ff$var$node;


const $408d997ca1cff4e4$export$2fe8e9e635ca9d7a = (0, $0c16356697ac10ff$export$2e2bcd8739ae039);
module.exports["SetBatchedTaskStatusMutation"] = $408d997ca1cff4e4$export$2fe8e9e635ca9d7a;

});

parcelRegister("hMmSn", function(module, exports) {

let $cf18aa0b31abacc3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cf18aa0b31abacc3$var$load("6wr18"),
    $cf18aa0b31abacc3$var$load("ffEVr"),
    $cf18aa0b31abacc3$var$load("8VYL2")
]).then(()=>parcelRequire('yAmxl'));

});


$parcel$global.rlb("jBZJd")
//# sourceMappingURL=FullPageEditorComponent.136d8d1d.js.map
